var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTauxUtilisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-19",
    d: "M76.66,243.77c-95.18,55-95.17,144,0,199s249.49,55,344.67,0,95.17-144,0-199S171.84,188.82,76.66,243.77Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-19",
    points: "430.67 317.28 381.95 289.15 430.67 260.9 479.49 289.09 430.67 317.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-19",
    d: "M72.94,364.26,197.5,436.18a12.14,12.14,0,0,0,11,0l201-116c3-1.76,3-4.6,0-6.35L284.9,241.89a12.14,12.14,0,0,0-11,0l-200.95,116C69.9,359.66,69.9,362.51,72.94,364.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-19",
    cx: 47.23,
    cy: 398.32,
    rx: 35.84,
    ry: 20.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-19",
    cx: 108.33,
    cy: 424.9,
    rx: 35.84,
    ry: 20.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-19",
    d: "M268.62,456.08a10.37,10.37,0,0,1-5.09-1.25l-3.83-2.21a4.3,4.3,0,0,1,0-8l50.47-29.22c-4.5-5-6.5-10.61-5.8-16.36.9-7.34,6.26-14.19,15.11-19.3,9.58-5.53,22.29-8.57,35.78-8.57s26.2,3,35.78,8.57c9.83,5.68,15.24,13.32,15.24,21.51s-5.41,15.82-15.24,21.5c-9.58,5.53-22.29,8.57-35.77,8.57h0c-13,0-25.27-2.83-34.72-8l-46.22,31.14A10.4,10.4,0,0,1,268.62,456.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.69,376.58h-.29l-7.33-.69a2.93,2.93,0,0,1-2.63-3.32l.35-2.72a30.75,30.75,0,0,1-3.11-1.13,2.16,2.16,0,0,0-.8-.13,1.4,1.4,0,0,0-.45.05l-5.73,1.88a3.74,3.74,0,0,1-1.18.18,4.26,4.26,0,0,1-2.67-.91l-3.71-3.12a2.48,2.48,0,0,1,.49-4.21l4.43-2.3a11.77,11.77,0,0,1-.44-1.26.56.56,0,0,0-.24-.31l-6.33-1a2.8,2.8,0,0,1-1.94-1.28,2.86,2.86,0,0,1-.26-2.36l1-3.3a3.51,3.51,0,0,1,3.27-2.39l6.79.19a1.75,1.75,0,0,0,.93-.45,17.91,17.91,0,0,1,1.42-1.31l-2.26-2.45a2.54,2.54,0,0,1-.68-2.3,2.61,2.61,0,0,1,1.6-1.84l5.9-2.45a4,4,0,0,1,1.54-.29,4.27,4.27,0,0,1,2.33.65l3.92,2.62a2.19,2.19,0,0,0,.93.21h.19c1.3-.25,2.64-.43,4-.55a1.1,1.1,0,0,0,.58-.38l1.49-2.9a3.79,3.79,0,0,1,3.26-2h.3l7.33.69a2.9,2.9,0,0,1,2,1.09,3,3,0,0,1,.62,2.24l-.36,2.71a27.78,27.78,0,0,1,3.11,1.14,2.41,2.41,0,0,0,.81.13,1.74,1.74,0,0,0,.44-.05l5.73-1.89a4.1,4.1,0,0,1,1.18-.18,4.27,4.27,0,0,1,2.67.92l3.71,3.12a2.54,2.54,0,0,1,.95,2.22,2.59,2.59,0,0,1-1.44,2l-4.43,2.29a12.59,12.59,0,0,1,.44,1.26.61.61,0,0,0,.24.31l6.33,1a2.8,2.8,0,0,1,1.94,1.28,2.86,2.86,0,0,1,.26,2.36l-1.05,3.3a3.51,3.51,0,0,1-3.26,2.4l-6.8-.2a1.78,1.78,0,0,0-.93.45c-.43.45-.91.89-1.41,1.32l2.26,2.44a2.57,2.57,0,0,1,.67,2.31,2.6,2.6,0,0,1-1.59,1.83L451.9,374a4.17,4.17,0,0,1-1.53.28,4.3,4.3,0,0,1-2.34-.65L444.12,371a2,2,0,0,0-.94-.22l-.19,0c-1.29.24-2.62.42-4,.54a1.14,1.14,0,0,0-.58.38L437,374.61A3.8,3.8,0,0,1,433.69,376.58Zm2.56-27.33a20.07,20.07,0,0,0-7.64,1.43c-2.88,1.2-4.76,3-5,4.85a4.25,4.25,0,0,0,1.81,3.79c2.24,1.88,6,3,10.14,3a20,20,0,0,0,7.64-1.44c2.88-1.19,4.76-3,5-4.85a4.28,4.28,0,0,0-1.82-3.79C444.15,350.37,440.36,349.25,436.25,349.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-2--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.92,339.65a.93.93,0,0,1-.54.75l-4.75,2.45a1.33,1.33,0,0,0-.56,1.76,11,11,0,0,1,.47,1.28,2.11,2.11,0,0,0,1.54,1.5l1.18.19,2-1.05a.87.87,0,0,0,.53-.77h0ZM428,341.89c-5.52,2.29-7.49,6.42-5.13,9.87a11.21,11.21,0,0,1,5.05-3.74c6.4-2.66,15.14-1.84,19.51,1.83a8.59,8.59,0,0,1,1.48,1.58c1.72-2.49,1.34-5.39-1.41-7.7C443.1,340.05,434.37,339.23,428,341.89Zm40.42,7.65a1.12,1.12,0,0,1-.06.35l-1.05,3.31a1.85,1.85,0,0,1-1.71,1.23l-6.72-.2a2.55,2.55,0,0,0-1,.23,3.55,3.55,0,0,0-1.14.73,16.67,16.67,0,0,1-1.62,1.48,1.17,1.17,0,0,0-.19,1.74l2.3,2.47a2.86,2.86,0,0,1,.58-.29h0a2.74,2.74,0,0,1,1-.22l6.72.2a1.85,1.85,0,0,0,1.7-1.23l1.05-3.31a1,1,0,0,0,.06-.37h0Zm-54.47-8.25h0a.92.92,0,0,0,.28.66l.34.37a3.11,3.11,0,0,0,.56-.44,15.42,15.42,0,0,1,1.62-1.47,1.15,1.15,0,0,0,.18-1.74l-2.63-2.84a.93.93,0,0,1-.27-.53Zm43.86,20.62a.87.87,0,0,1-.62.8l-5.9,2.45a2.54,2.54,0,0,1-1.53.09,2,2,0,0,1-.77-.3L445,362.34a3.64,3.64,0,0,0-2.36-.45c-1.25.23-2.53.41-3.81.52a2.55,2.55,0,0,0-1.28.55,2.28,2.28,0,0,0-.63.73l-1.5,2.91a2.09,2.09,0,0,1-1.09.93,1.81,1.81,0,0,1-.82.13l-7.33-.69a1.27,1.27,0,0,1-1.13-1.44l.38-2.83a1.59,1.59,0,0,0-1.08-1.67,28.17,28.17,0,0,1-3.05-1.11,4.11,4.11,0,0,0-2.43-.13l-.06,0-5.67,1.86a2.58,2.58,0,0,1-1.43,0,2.26,2.26,0,0,1-.82-.41l-3.71-3.12a.89.89,0,0,1-.36-.64l-.08,6.1a1,1,0,0,0,.37.67l3.7,3.12a2.52,2.52,0,0,0,1.56.51,1.22,1.22,0,0,0,.33,0h.06a1.63,1.63,0,0,0,.3-.07l5.67-1.87.07,0a3.85,3.85,0,0,1,2.42.14,31.36,31.36,0,0,0,3.05,1.1,1.55,1.55,0,0,1,.76.53l-.06,4.15a1.25,1.25,0,0,0,1.14,1.25l7.33.69a1.71,1.71,0,0,0,.82-.13,1.87,1.87,0,0,0,.48-.26,2.31,2.31,0,0,0,.23-.18l0,0a1.37,1.37,0,0,0,.16-.18,1.77,1.77,0,0,0,.16-.22l0-.07,1.49-2.9a1,1,0,0,1,.17-.24.55.55,0,0,1,.13-.17,2.08,2.08,0,0,1,.34-.32,2.55,2.55,0,0,1,1.28-.55c1.28-.12,2.55-.28,3.81-.52a3.59,3.59,0,0,1,2.36.45l3.93,2.61a2.09,2.09,0,0,0,.75.28h0l.19,0a3,3,0,0,0,.9,0l.19,0,.26-.08,5.9-2.46a1,1,0,0,0,.51-.42.87.87,0,0,0,.11-.38Zm-53.46-13.25a1.08,1.08,0,0,1-.94-1.07l-.07,6.15h0a1.07,1.07,0,0,0,.93,1.07l5.19.84,2.7-1.41a1.32,1.32,0,0,0,.56-1.76,8.86,8.86,0,0,1-.47-1.27,2.14,2.14,0,0,0-1.54-1.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.85,359.82l-5.67,1.86a2.58,2.58,0,0,1-1.43,0l-.07,6.11a3,3,0,0,0,.73.12,1.22,1.22,0,0,0,.33,0h.06a1.63,1.63,0,0,0,.3-.07l5.67-1.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.59,363a2.28,2.28,0,0,0-.63.73l-1.5,2.91a2.09,2.09,0,0,1-1.09.93l-.07,6.12a1.87,1.87,0,0,0,.48-.26,2.31,2.31,0,0,0,.23-.18l0,0a1.37,1.37,0,0,0,.16-.18,1.77,1.77,0,0,0,.16-.22l0-.07,1.49-2.9a1,1,0,0,1,.17-.24,1.09,1.09,0,0,1,.13-.17c.1-.11.22-.2.33-.3v0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.92,339.65a.88.88,0,0,1-.55.74l-4.74,2.46a1.34,1.34,0,0,0-.56,1.76,9.44,9.44,0,0,1,.47,1.28,2.12,2.12,0,0,0,1.54,1.5l1.18.19,2-1.05a.9.9,0,0,0,.54-.77h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.39,349.54a1.12,1.12,0,0,1-.06.35l-1.05,3.31a1.85,1.85,0,0,1-1.71,1.23l-6.72-.2a2.55,2.55,0,0,0-1,.23l-.07,6.12a2.74,2.74,0,0,1,1-.22l6.72.2a1.85,1.85,0,0,0,1.7-1.23l1.05-3.31a1,1,0,0,0,.06-.37h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.78,361.91a.87.87,0,0,1-.62.8l-5.9,2.45a2.54,2.54,0,0,1-1.53.09l-.08,6.12.19,0a3,3,0,0,0,.9,0l.19,0,.26-.08,5.9-2.46a1,1,0,0,0,.51-.42.87.87,0,0,0,.11-.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,335.41l-5.74,1.88a4,4,0,0,1-2.43-.13,28.17,28.17,0,0,0-3.05-1.11,1.56,1.56,0,0,1-1.07-1.66l.37-2.83a1.26,1.26,0,0,0-1.13-1.44l-7.33-.69a2.11,2.11,0,0,0-1.91,1.06l-1.49,2.9a2.63,2.63,0,0,1-1.92,1.28c-1.28.12-2.55.29-3.81.53a3.65,3.65,0,0,1-2.36-.46l-3.92-2.61a2.73,2.73,0,0,0-2.3-.21l-5.9,2.45a.86.86,0,0,0-.34,1.46l2.64,2.85a1.16,1.16,0,0,1-.19,1.74,15.42,15.42,0,0,0-1.62,1.47,3.33,3.33,0,0,1-2.18,1l-6.71-.19a1.85,1.85,0,0,0-1.71,1.23l-1.06,3.3a1.11,1.11,0,0,0,.88,1.48l6.37,1a2.11,2.11,0,0,1,1.54,1.5,10,10,0,0,0,.47,1.28,1.33,1.33,0,0,1-.56,1.76l-4.74,2.45a.81.81,0,0,0-.18,1.44l3.71,3.12a2.65,2.65,0,0,0,2.25.43l5.73-1.89a4,4,0,0,1,2.43.13,28.17,28.17,0,0,0,3.05,1.11,1.59,1.59,0,0,1,1.08,1.67l-.37,2.83a1.26,1.26,0,0,0,1.12,1.44l7.33.69a2.11,2.11,0,0,0,1.91-1.06l1.5-2.91a2.62,2.62,0,0,1,1.91-1.28c1.28-.11,2.56-.29,3.81-.52a3.58,3.58,0,0,1,2.36.45L449,365a2.73,2.73,0,0,0,2.3.22l5.9-2.46a.85.85,0,0,0,.34-1.46l-2.63-2.84a1.16,1.16,0,0,1,.18-1.74,15.58,15.58,0,0,0,1.62-1.48,3.4,3.4,0,0,1,2.19-1l6.71.2a1.84,1.84,0,0,0,1.7-1.23l1.06-3.3a1.1,1.1,0,0,0-.88-1.48l-6.37-1a2.13,2.13,0,0,1-1.54-1.5,9,9,0,0,0-.47-1.28,1.33,1.33,0,0,1,.56-1.76l4.74-2.45a.82.82,0,0,0,.18-1.45l-3.71-3.12A2.59,2.59,0,0,0,458.6,335.41Zm-11.13,8.32c4.37,3.67,2.73,8.8-3.67,11.46s-15.12,1.84-19.5-1.83-2.73-8.81,3.67-11.47S443.1,340.05,447.47,343.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.08,330.14h.07l7.33.69a.53.53,0,0,1,.37.2.59.59,0,0,1,.11.43l-.37,2.83a2.31,2.31,0,0,0,1.59,2.45,29.53,29.53,0,0,1,3,1.08,4.52,4.52,0,0,0,1.75.32,3.83,3.83,0,0,0,1.18-.16l5.74-1.89a1.4,1.4,0,0,1,.43-.06,1.9,1.9,0,0,1,1.13.35l3.71,3.12a.36.36,0,0,1,.11.13.5.5,0,0,1-.16.13l-4.74,2.45a2,2,0,0,0-.88,2.69,9.34,9.34,0,0,1,.43,1.18,2.84,2.84,0,0,0,2.11,2l6.38,1a.39.39,0,0,1,.28.17.48.48,0,0,1,0,.38l-1.06,3.3a1.13,1.13,0,0,1-1,.73h0l-6.71-.2h-.07a4,4,0,0,0-2.65,1.19,15.18,15.18,0,0,1-1.56,1.4,2,2,0,0,0-.76,1.4,1.84,1.84,0,0,0,.5,1.4l2.63,2.84a.3.3,0,0,1,.1.17.31.31,0,0,1-.18.14L451,364.5a1.69,1.69,0,0,1-.63.11,2,2,0,0,1-1-.25l-3.92-2.62a4.27,4.27,0,0,0-2.26-.61,4,4,0,0,0-.63.05c-1.22.23-2.47.4-3.74.52a3.32,3.32,0,0,0-2.49,1.66l-1.5,2.91a1.44,1.44,0,0,1-1.13.68h-.07l-7.33-.69a.52.52,0,0,1-.37-.19.61.61,0,0,1-.11-.44l.37-2.83a2.32,2.32,0,0,0-1.58-2.45,26.16,26.16,0,0,1-3-1.08,4.65,4.65,0,0,0-1.74-.32,3.88,3.88,0,0,0-1.19.17L413,361a1.35,1.35,0,0,1-.43.06,1.9,1.9,0,0,1-1.13-.35l-3.71-3.12c-.08-.07-.1-.12-.11-.12a.39.39,0,0,1,.16-.13l4.74-2.46a2,2,0,0,0,.88-2.69,8.74,8.74,0,0,1-.42-1.18,2.85,2.85,0,0,0-2.12-2l-6.37-1a.39.39,0,0,1-.29-.18.43.43,0,0,1,0-.37l1.05-3.3a1.16,1.16,0,0,1,1-.73h0l6.7.19H413a4.08,4.08,0,0,0,2.65-1.18,15.25,15.25,0,0,1,1.56-1.41,2,2,0,0,0,.76-1.39,1.83,1.83,0,0,0-.5-1.4l-2.63-2.84c-.08-.09-.1-.16-.09-.18s.06-.08.18-.13l5.9-2.46a1.61,1.61,0,0,1,.62-.1,1.87,1.87,0,0,1,1,.25l3.92,2.61a4.3,4.3,0,0,0,2.26.62,3.24,3.24,0,0,0,.64-.06,37.62,37.62,0,0,1,3.73-.51,3.34,3.34,0,0,0,2.49-1.67l1.5-2.9a1.41,1.41,0,0,1,1.13-.68m-2.56,27.33a22.61,22.61,0,0,0,8.56-1.61c3.71-1.54,6.07-4,6.49-6.7a6.5,6.5,0,0,0-2.64-6c-2.7-2.27-6.95-3.57-11.68-3.57a22.5,22.5,0,0,0-8.56,1.62c-3.71,1.54-6.07,4-6.49,6.69a6.52,6.52,0,0,0,2.64,6c2.7,2.26,7,3.56,11.68,3.56m2.56-28.05a2.15,2.15,0,0,0-1.77,1.07l-1.49,2.9a2.63,2.63,0,0,1-1.92,1.28c-1.28.12-2.55.29-3.81.53a2.6,2.6,0,0,1-.5,0,3.56,3.56,0,0,1-1.86-.5l-3.92-2.61a2.66,2.66,0,0,0-1.4-.37,2.36,2.36,0,0,0-.9.16l-5.9,2.45a.86.86,0,0,0-.34,1.46l2.64,2.85a1.16,1.16,0,0,1-.19,1.74,15.42,15.42,0,0,0-1.62,1.47,3.35,3.35,0,0,1-2.14,1h0l-6.71-.19h0a1.85,1.85,0,0,0-1.67,1.23l-1.06,3.3a1.11,1.11,0,0,0,.88,1.48l6.37,1a2.11,2.11,0,0,1,1.54,1.5,10,10,0,0,0,.47,1.28,1.33,1.33,0,0,1-.56,1.76l-4.74,2.45a.81.81,0,0,0-.18,1.44l3.71,3.12a2.59,2.59,0,0,0,1.59.52,2.29,2.29,0,0,0,.66-.09l5.73-1.89a3.25,3.25,0,0,1,1-.13,3.88,3.88,0,0,1,1.46.26,28.17,28.17,0,0,0,3.05,1.11,1.59,1.59,0,0,1,1.08,1.67l-.37,2.83a1.26,1.26,0,0,0,1.12,1.44l7.33.69h.14a2.11,2.11,0,0,0,1.77-1.06l1.5-2.91a2.62,2.62,0,0,1,1.91-1.28c1.28-.11,2.56-.29,3.81-.52a2.6,2.6,0,0,1,.5,0,3.6,3.6,0,0,1,1.86.49L449,365a2.6,2.6,0,0,0,1.4.38,2.53,2.53,0,0,0,.9-.16l5.9-2.46a.85.85,0,0,0,.34-1.46l-2.63-2.84a1.16,1.16,0,0,1,.18-1.74,15.58,15.58,0,0,0,1.62-1.48,3.41,3.41,0,0,1,2.14-1h.05l6.71.2h0a1.85,1.85,0,0,0,1.66-1.23l1.06-3.3a1.1,1.1,0,0,0-.88-1.48l-6.37-1a2.13,2.13,0,0,1-1.54-1.5,9,9,0,0,0-.47-1.28,1.33,1.33,0,0,1,.56-1.76l4.74-2.45a.82.82,0,0,0,.18-1.45l-3.71-3.12a2.66,2.66,0,0,0-1.59-.52,2.21,2.21,0,0,0-.65.1l-5.74,1.88a3.18,3.18,0,0,1-1,.14,3.93,3.93,0,0,1-1.47-.27,28.17,28.17,0,0,0-3.05-1.11,1.56,1.56,0,0,1-1.07-1.66l.37-2.83a1.26,1.26,0,0,0-1.13-1.44l-7.33-.69Zm-2.56,27.34c-4.35,0-8.58-1.18-11.22-3.4-4.37-3.67-2.73-8.81,3.67-11.47a21.89,21.89,0,0,1,8.28-1.56c4.35,0,8.58,1.18,11.22,3.4,4.37,3.67,2.73,8.8-3.67,11.46a21.71,21.71,0,0,1-8.28,1.57Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears-1--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.36,75.39h0l-6.73-3.86h0a.76.76,0,0,0-.69,0l-4.59,2.07a2,2,0,0,1,.14-1.11l5.3-10.69a1.21,1.21,0,0,0-.47-1.56l-5.76-3.32h0l-6.69-3.85a1.2,1.2,0,0,0-1.58.37l-6.61,9.94a2,2,0,0,1-.87.67l-.51-5a.77.77,0,0,0-.33-.61h0L94.2,54.53h0a.72.72,0,0,0-.73.06l-8.93,5.16a2.42,2.42,0,0,0-1.07,1.67l-.9,9.95a3.22,3.22,0,0,1-.93,1.85,54.06,54.06,0,0,0-5,5.26,1.73,1.73,0,0,1-1.76.5l-5.73-2a1.4,1.4,0,0,0-1.61.6L61,89a1.42,1.42,0,0,0,.29,1.7l4.61,4a1.71,1.71,0,0,1,.44,1.77,54.71,54.71,0,0,0-2.07,6.93,3.29,3.29,0,0,1-1.14,1.73L55,110.8a2.43,2.43,0,0,0-.91,1.76v10.32a.71.71,0,0,0,.32.66h0l6.73,3.86h0a.73.73,0,0,0,.69,0l4.59-2.07a2,2,0,0,1-.14,1.12l-5.3,10.69a1.22,1.22,0,0,0,.47,1.56l8.08,4.64h0l4.39,2.54a1.2,1.2,0,0,0,1.58-.38l6.61-9.93a2,2,0,0,1,.87-.67l.51,5a.76.76,0,0,0,.34.61h0l6.72,3.85h0a.74.74,0,0,0,.74,0l8.94-5.16a2.41,2.41,0,0,0,1.06-1.67l.9-9.95a3.28,3.28,0,0,1,.93-1.86,52.75,52.75,0,0,0,5-5.25,1.73,1.73,0,0,1,1.76-.5l5.73,2a1.4,1.4,0,0,0,1.62-.59L123.73,110a1.4,1.4,0,0,0-.29-1.69l-4.6-4a1.69,1.69,0,0,1-.45-1.77,55.06,55.06,0,0,0,2.07-6.92,3.31,3.31,0,0,1,1.14-1.74l8.17-5.75a2.41,2.41,0,0,0,.91-1.75V76.06A.73.73,0,0,0,130.36,75.39ZM80.62,110.11c0-9.63,6.77-21.34,15.11-26.15,3.26-1.88,6.27-2.43,8.74-1.82,1.27,1.77,2,4.47,2,8,0,9.63-6.76,21.34-15.1,26.16-3.26,1.88-6,2.49-8.21,2C81.55,116.43,80.62,113.66,80.62,110.11Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.36,75.39h0l-6.73-3.86h0a.76.76,0,0,0-.69,0l-4.59,2.07a2,2,0,0,1,.14-1.11l5.3-10.69a1.21,1.21,0,0,0-.47-1.56l-5.76-3.32h0l-6.69-3.85a1.2,1.2,0,0,0-1.58.37l-6.61,9.94a2,2,0,0,1-.87.67l-.51-5a.77.77,0,0,0-.33-.61h0L94.2,54.53h0a.72.72,0,0,0-.73.06l-8.93,5.16a2.42,2.42,0,0,0-1.07,1.67l-.9,9.95a3.22,3.22,0,0,1-.93,1.85,54.06,54.06,0,0,0-5,5.26,1.73,1.73,0,0,1-1.76.5l-5.73-2a1.4,1.4,0,0,0-1.61.6L61,89a1.42,1.42,0,0,0,.29,1.7l4.61,4a1.71,1.71,0,0,1,.44,1.77,54.71,54.71,0,0,0-2.07,6.93,3.29,3.29,0,0,1-1.14,1.73L55,110.8a2.43,2.43,0,0,0-.91,1.76v10.32a.71.71,0,0,0,.32.66h0l6.73,3.86h0a.73.73,0,0,0,.69,0l4.59-2.07a2,2,0,0,1-.14,1.12l-5.3,10.69a1.22,1.22,0,0,0,.47,1.56l8.08,4.64h0l4.39,2.54a1.2,1.2,0,0,0,1.58-.38l6.61-9.93a2,2,0,0,1,.87-.67l.51,5a.76.76,0,0,0,.34.61h0l6.72,3.85h0a.74.74,0,0,0,.74,0l8.94-5.16a2.41,2.41,0,0,0,1.06-1.67l.9-9.95a3.28,3.28,0,0,1,.93-1.86,52.75,52.75,0,0,0,5-5.25,1.73,1.73,0,0,1,1.76-.5l5.73,2a1.4,1.4,0,0,0,1.62-.59L123.73,110a1.4,1.4,0,0,0-.29-1.69l-4.6-4a1.69,1.69,0,0,1-.45-1.77,55.06,55.06,0,0,0,2.07-6.92,3.31,3.31,0,0,1,1.14-1.74l8.17-5.75a2.41,2.41,0,0,0,.91-1.75V76.06A.73.73,0,0,0,130.36,75.39ZM80.62,110.11c0-9.63,6.77-21.34,15.11-26.15,3.26-1.88,6.27-2.43,8.74-1.82,1.27,1.77,2,4.47,2,8,0,9.63-6.76,21.34-15.1,26.16-3.26,1.88-6,2.49-8.21,2C81.55,116.43,80.62,113.66,80.62,110.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.07,124.42a.93.93,0,0,0-1.32-.61l-3.35,1.51a2,2,0,0,1-.15,1.12l-5.31,10.69a1.22,1.22,0,0,0,.47,1.56l8.08,4.64-1.36-.79a1.2,1.2,0,0,1-.47-1.55L73,130.3a2.19,2.19,0,0,0-.13-1.93A18.32,18.32,0,0,1,71.07,124.42Zm19.38,19.94a.9.9,0,0,1-.27-.57l-.87-8.69a1,1,0,0,0-1.2-.84,17.6,17.6,0,0,1-4.3.44,2.08,2.08,0,0,0-.86.18l.51,5.05a.69.69,0,0,0,.34.6h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,92.68c0,9.63-6.75,21.34-15.09,26.15-5.27,3-9.91,2.61-12.62-.56,2.17.53,5-.09,8.22-2,8.34-4.82,15.1-16.53,15.1-26.16,0-3.52-.68-6.22-2-8C108.32,83.07,110.82,86.82,110.82,92.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,53.07a1.19,1.19,0,0,0-1.58.38l-6.61,9.93a1.77,1.77,0,0,1-.44.42l6.73,3.87a1.67,1.67,0,0,0,.44-.44L116,57.3a1.23,1.23,0,0,1,1.45-.44Zm12.79,18.45h0a.79.79,0,0,0-.69,0l-4.6,2.08a2.28,2.28,0,0,0,.27.81,17,17,0,0,1,1.7,3.75,1.07,1.07,0,0,1,.07.19,1.11,1.11,0,0,0,.24.41l.11.11A.87.87,0,0,0,121,79a1,1,0,0,0,.49,0,.94.94,0,0,0,.22-.07l8-3.59a.8.8,0,0,1,.2-.07.45.45,0,0,1,.28,0,.53.53,0,0,1,.22.08h0Zm-29.44-17a.73.73,0,0,0-.72.07l-8.93,5.16a2.31,2.31,0,0,0-.9,1.08l6.71,3.86a2.37,2.37,0,0,1,.9-1.08l8.94-5.17a.79.79,0,0,1,.69-.08ZM63.76,104.39a2.85,2.85,0,0,1-.63.66L55,110.8a2.37,2.37,0,0,0-.55.62l6.71,3.85a2,2,0,0,1,.56-.61l8.16-5.75a2.67,2.67,0,0,0,.63-.66Zm5-27.47a1.41,1.41,0,0,0-1.15.66L61,89a1.39,1.39,0,0,0-.15.83l6.72,3.87a1.35,1.35,0,0,1,.15-.84L74.3,81.43a1.37,1.37,0,0,1,1.06-.65Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,53.07a1.19,1.19,0,0,0-1.58.38l-6.61,9.93a1.77,1.77,0,0,1-.44.42l6.73,3.87a1.67,1.67,0,0,0,.44-.44L116,57.3a1.23,1.23,0,0,1,1.45-.44Zm12.79,18.45h0a.79.79,0,0,0-.69,0l-4.6,2.08a2.28,2.28,0,0,0,.27.81,17,17,0,0,1,1.7,3.75,1.07,1.07,0,0,1,.07.19,1.11,1.11,0,0,0,.24.41l.11.11A.87.87,0,0,0,121,79a1,1,0,0,0,.49,0,.94.94,0,0,0,.22-.07l8-3.59a.8.8,0,0,1,.2-.07.45.45,0,0,1,.28,0,.53.53,0,0,1,.22.08h0Zm-29.44-17a.73.73,0,0,0-.72.07l-8.93,5.16a2.31,2.31,0,0,0-.9,1.08l6.71,3.86a2.37,2.37,0,0,1,.9-1.08l8.94-5.17a.79.79,0,0,1,.69-.08ZM63.76,104.39a2.85,2.85,0,0,1-.63.66L55,110.8a2.37,2.37,0,0,0-.55.62l6.71,3.85a2,2,0,0,1,.56-.61l8.16-5.75a2.67,2.67,0,0,0,.63-.66Zm5-27.47a1.41,1.41,0,0,0-1.15.66L61,89a1.39,1.39,0,0,0-.15.83l6.72,3.87a1.35,1.35,0,0,1,.15-.84L74.3,81.43a1.37,1.37,0,0,1,1.06-.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,86.38V76.06a.67.67,0,0,0-1-.66l-8,3.58a.94.94,0,0,1-1.33-.61,17.77,17.77,0,0,0-1.77-3.94,2.16,2.16,0,0,1-.12-1.93l5.3-10.69a1.21,1.21,0,0,0-.47-1.56l-5.76-3.32a1.19,1.19,0,0,0-1.58.37l-6.61,9.94a2.22,2.22,0,0,1-1.73.86,17.58,17.58,0,0,0-4.3.43,1,1,0,0,1-1.2-.84L101.27,59a.66.66,0,0,0-1.07-.55l-8.94,5.16a2.38,2.38,0,0,0-1.07,1.67l-.89,9.94a3.4,3.4,0,0,1-.93,1.86,54,54,0,0,0-5,5.25,1.71,1.71,0,0,1-1.76.5l-5.73-2a1.37,1.37,0,0,0-1.61.6L67.72,92.82A1.42,1.42,0,0,0,68,94.51l4.61,4a1.71,1.71,0,0,1,.44,1.77A54.71,54.71,0,0,0,71,107.18a3.29,3.29,0,0,1-1.14,1.73l-8.16,5.75a2.39,2.39,0,0,0-.92,1.76v10.32a.67.67,0,0,0,1,.65l8-3.58a.93.93,0,0,1,1.32.61,18.06,18.06,0,0,0,1.77,4,2.17,2.17,0,0,1,.13,1.92L67.66,141a1.2,1.2,0,0,0,.47,1.55l5.76,3.33a1.2,1.2,0,0,0,1.58-.38l6.61-9.93a2.16,2.16,0,0,1,1.73-.86,18.06,18.06,0,0,0,4.3-.44,1,1,0,0,1,1.2.84l.87,8.68a.67.67,0,0,0,1.08.56l8.94-5.16a2.41,2.41,0,0,0,1.06-1.67l.9-9.95a3.28,3.28,0,0,1,.93-1.86,52.75,52.75,0,0,0,5-5.25,1.73,1.73,0,0,1,1.76-.5l5.73,2a1.4,1.4,0,0,0,1.62-.59L123.73,110a1.4,1.4,0,0,0-.29-1.69l-4.6-4a1.69,1.69,0,0,1-.45-1.77,55.06,55.06,0,0,0,2.07-6.92,3.31,3.31,0,0,1,1.14-1.74l8.17-5.75A2.41,2.41,0,0,0,130.68,86.38ZM95.73,118.83c-8.34,4.82-15.11.91-15.11-8.72S87.39,88.77,95.73,84s15.1-.91,15.1,8.72S104.07,114,95.73,118.83Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,86.38V76.06a.67.67,0,0,0-1-.66l-8,3.58a.94.94,0,0,1-1.33-.61,17.77,17.77,0,0,0-1.77-3.94,2.16,2.16,0,0,1-.12-1.93l5.3-10.69a1.21,1.21,0,0,0-.47-1.56l-5.76-3.32a1.19,1.19,0,0,0-1.58.37l-6.61,9.94a2.22,2.22,0,0,1-1.73.86,17.58,17.58,0,0,0-4.3.43,1,1,0,0,1-1.2-.84L101.27,59a.66.66,0,0,0-1.07-.55l-8.94,5.16a2.38,2.38,0,0,0-1.07,1.67l-.89,9.94a3.4,3.4,0,0,1-.93,1.86,54,54,0,0,0-5,5.25,1.71,1.71,0,0,1-1.76.5l-5.73-2a1.37,1.37,0,0,0-1.61.6L67.72,92.82A1.42,1.42,0,0,0,68,94.51l4.61,4a1.71,1.71,0,0,1,.44,1.77A54.71,54.71,0,0,0,71,107.18a3.29,3.29,0,0,1-1.14,1.73l-8.16,5.75a2.39,2.39,0,0,0-.92,1.76v10.32a.67.67,0,0,0,1,.65l8-3.58a.93.93,0,0,1,1.32.61,18.06,18.06,0,0,0,1.77,4,2.17,2.17,0,0,1,.13,1.92L67.66,141a1.2,1.2,0,0,0,.47,1.55l5.76,3.33a1.2,1.2,0,0,0,1.58-.38l6.61-9.93a2.16,2.16,0,0,1,1.73-.86,18.06,18.06,0,0,0,4.3-.44,1,1,0,0,1,1.2.84l.87,8.68a.67.67,0,0,0,1.08.56l8.94-5.16a2.41,2.41,0,0,0,1.06-1.67l.9-9.95a3.28,3.28,0,0,1,.93-1.86,52.75,52.75,0,0,0,5-5.25,1.73,1.73,0,0,1,1.76-.5l5.73,2a1.4,1.4,0,0,0,1.62-.59L123.73,110a1.4,1.4,0,0,0-.29-1.69l-4.6-4a1.69,1.69,0,0,1-.45-1.77,55.06,55.06,0,0,0,2.07-6.92,3.31,3.31,0,0,1,1.14-1.74l8.17-5.75A2.41,2.41,0,0,0,130.68,86.38ZM95.73,118.83c-8.34,4.82-15.11.91-15.11-8.72S87.39,88.77,95.73,84s15.1-.91,15.1,8.72S104.07,114,95.73,118.83Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117,57.53a.46.46,0,0,1,.2,0l5.76,3.33a.43.43,0,0,1,.17.56l-5.3,10.69a2.92,2.92,0,0,0,.15,2.66,17.38,17.38,0,0,1,1.7,3.78,1.71,1.71,0,0,0,1.63,1.24,1.88,1.88,0,0,0,.73-.16l7.9-3.57V86.38a1.7,1.7,0,0,1-.59,1.14l-8.16,5.74a4.11,4.11,0,0,0-1.45,2.19,53.27,53.27,0,0,1-2,6.83,2.47,2.47,0,0,0,.66,2.61l4.6,4a.66.66,0,0,1,.13.75L116.5,121a.68.68,0,0,1-.54.28.47.47,0,0,1-.17,0l-5.73-2a2.18,2.18,0,0,0-.72-.12,2.45,2.45,0,0,0-1.87.85,54,54,0,0,1-4.9,5.18,4.09,4.09,0,0,0-1.17,2.34l-.89,10a1.71,1.71,0,0,1-.69,1.08l-8.89,5.13L90.06,135a1.69,1.69,0,0,0-1.7-1.56,1.92,1.92,0,0,0-.41.05,17.48,17.48,0,0,1-3.73.42h-.45a2.94,2.94,0,0,0-2.32,1.2l-6.61,9.93a.44.44,0,0,1-.37.19.46.46,0,0,1-.2,0l-5.76-3.32a.46.46,0,0,1-.17-.57l5.3-10.69a2.92,2.92,0,0,0-.15-2.66,17.16,17.16,0,0,1-1.7-3.78A1.68,1.68,0,0,0,70.17,123a1.76,1.76,0,0,0-.74.16l-7.9,3.56V116.42a1.66,1.66,0,0,1,.59-1.14l8.17-5.75a4.1,4.1,0,0,0,1.44-2.19,54.92,54.92,0,0,1,2-6.83,2.43,2.43,0,0,0-.66-2.6l-4.6-4a.66.66,0,0,1-.13-.74L75,81.81a.68.68,0,0,1,.55-.28l.16,0,5.73,2A2.48,2.48,0,0,0,84,82.83a52.87,52.87,0,0,1,4.9-5.18,4.06,4.06,0,0,0,1.17-2.35l.9-10a1.63,1.63,0,0,1,.69-1.08l8.88-5.13.87,8.63a1.69,1.69,0,0,0,1.7,1.55,1.84,1.84,0,0,0,.41,0,17.48,17.48,0,0,1,3.73-.42h.45A3,3,0,0,0,110,67.66l6.61-9.94a.44.44,0,0,1,.37-.19h0M89,121.65a14.46,14.46,0,0,0,7.13-2.16c8.53-4.93,15.47-17,15.47-26.81a13.42,13.42,0,0,0-2.48-8.43,8.21,8.21,0,0,0-6.63-3.11,14.39,14.39,0,0,0-7.12,2.16c-8.54,4.93-15.48,17-15.48,26.81,0,7,3.58,11.54,9.11,11.54m28-64.88a1.21,1.21,0,0,0-1,.53l-6.61,9.94a2.2,2.2,0,0,1-1.69.86h-.45a17.85,17.85,0,0,0-3.89.44l-.25,0a.94.94,0,0,1-1-.87L101.27,59c0-.44-.3-.69-.63-.69a.87.87,0,0,0-.44.14l-8.94,5.16a2.38,2.38,0,0,0-1.07,1.67l-.89,9.94a3.4,3.4,0,0,1-.93,1.86,54,54,0,0,0-5,5.25,1.72,1.72,0,0,1-1.29.58,1.5,1.5,0,0,1-.47-.08l-5.73-2a1.18,1.18,0,0,0-.41-.07,1.38,1.38,0,0,0-1.2.67L67.72,92.82A1.42,1.42,0,0,0,68,94.51l4.61,4a1.71,1.71,0,0,1,.44,1.77A54.71,54.71,0,0,0,71,107.18a3.29,3.29,0,0,1-1.14,1.73l-8.16,5.75a2.39,2.39,0,0,0-.92,1.76v10.32c0,.46.26.74.63.74a.85.85,0,0,0,.39-.09l8-3.58a.92.92,0,0,1,.42-.1,1,1,0,0,1,.9.71,18.06,18.06,0,0,0,1.77,4,2.17,2.17,0,0,1,.13,1.92L67.66,141a1.2,1.2,0,0,0,.47,1.55l5.76,3.33a1.2,1.2,0,0,0,1.58-.38l6.61-9.93a2.17,2.17,0,0,1,1.69-.86h.45a17.78,17.78,0,0,0,3.89-.44l.25,0a.94.94,0,0,1,1,.87l.87,8.68c0,.44.3.69.63.69a.91.91,0,0,0,.45-.13l8.94-5.16a2.41,2.41,0,0,0,1.06-1.67l.9-9.95a3.28,3.28,0,0,1,.93-1.86,52.75,52.75,0,0,0,5-5.25,1.72,1.72,0,0,1,1.29-.57,1.49,1.49,0,0,1,.47.07l5.73,2a1.23,1.23,0,0,0,.42.07,1.42,1.42,0,0,0,1.2-.66L123.73,110a1.4,1.4,0,0,0-.29-1.69l-4.6-4a1.69,1.69,0,0,1-.45-1.77,55.06,55.06,0,0,0,2.07-6.92,3.31,3.31,0,0,1,1.14-1.74l8.17-5.75a2.41,2.41,0,0,0,.91-1.75V76.06c0-.47-.26-.75-.63-.75a1,1,0,0,0-.39.09l-8,3.58a.94.94,0,0,1-1.33-.61,17.77,17.77,0,0,0-1.77-3.94,2.19,2.19,0,0,1-.12-1.93l5.3-10.69a1.21,1.21,0,0,0-.47-1.56l-5.76-3.32a1.1,1.1,0,0,0-.58-.16ZM89,120.9c-5,0-8.36-4-8.36-10.79,0-9.63,6.77-21.34,15.11-26.15a13.66,13.66,0,0,1,6.74-2.06c5,0,8.36,3.95,8.36,10.78,0,9.63-6.76,21.34-15.1,26.15A13.74,13.74,0,0,1,89,120.9Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.38,71.66a3.87,3.87,0,0,1,1-2.1l4.23-3.88a2.58,2.58,0,0,0,.71-2.08l-.8-4.61a.83.83,0,0,0-.4-.64h0l-5-2.88h0a.82.82,0,0,0-.88.08l-1.81,1.2L179.21,52a1,1,0,0,0-.48-1.31h0l-5-2.89h0a1.71,1.71,0,0,0-.34-.13l-3.18-.71a1.72,1.72,0,0,0-1.8.83l-3,5.71a3,3,0,0,1-1.2,1.1l-.13-.46a.92.92,0,0,0-.41-.55h0l-5-2.9h0a.81.81,0,0,0-.94.13L153,54.55a2.65,2.65,0,0,0-.9,2l.28,4.54a3.62,3.62,0,0,1-.74,2.19q-1.17,1.41-2.22,2.94a2.47,2.47,0,0,1-1.94,1l-3.06-.15a2,2,0,0,0-1.76,1.08l-2.89,6.46a1.23,1.23,0,0,0,.5,1.55h0l3.4,2a1.48,1.48,0,0,1,.08.88c-.23,1-.41,2.07-.53,3.08a3.87,3.87,0,0,1-1,2.1l-4.23,3.88a2.58,2.58,0,0,0-.71,2.08l.8,4.61a.88.88,0,0,0,.38.63h0l5,2.91h0a.82.82,0,0,0,.87-.08l1.81-1.2-1.75,4.75a1.06,1.06,0,0,0,.42,1.29h0l5,2.91v0a1.07,1.07,0,0,0,.36.16l3.18.71a1.72,1.72,0,0,0,1.8-.83l3-5.71a3,3,0,0,1,1.2-1.1l.13.46a.94.94,0,0,0,.41.56h0l5,2.87h0l.06,0h0a.83.83,0,0,0,.92-.14l4.77-3.75a2.65,2.65,0,0,0,.9-2l-.28-4.54a3.62,3.62,0,0,1,.74-2.19q1.17-1.41,2.22-2.94a2.47,2.47,0,0,1,1.94-1l3.06.15a2,2,0,0,0,1.76-1.08l2.89-6.46a1.24,1.24,0,0,0-.65-1.64l-2.47-1a1.53,1.53,0,0,1-.85-1.71C180.08,73.7,180.26,72.67,180.38,71.66Zm-25.45,14c-.94-5.43,2.49-13.12,7.66-17.19A10.47,10.47,0,0,1,168,66.07a7.88,7.88,0,0,1,.59,2c.94,5.43-2.49,13.12-7.66,17.19a10.5,10.5,0,0,1-5.42,2.42A7.69,7.69,0,0,1,154.93,85.68Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38,71.66a3.87,3.87,0,0,1,1-2.1l4.23-3.88a2.58,2.58,0,0,0,.71-2.08l-.8-4.61a.83.83,0,0,0-.4-.64h0l-5-2.88h0a.82.82,0,0,0-.88.08l-1.81,1.2L179.21,52a1,1,0,0,0-.48-1.31h0l-5-2.89h0a1.71,1.71,0,0,0-.34-.13l-3.18-.71a1.72,1.72,0,0,0-1.8.83l-3,5.71a3,3,0,0,1-1.2,1.1l-.13-.46a.92.92,0,0,0-.41-.55h0l-5-2.9h0a.81.81,0,0,0-.94.13L153,54.55a2.65,2.65,0,0,0-.9,2l.28,4.54a3.62,3.62,0,0,1-.74,2.19q-1.17,1.41-2.22,2.94a2.47,2.47,0,0,1-1.94,1l-3.06-.15a2,2,0,0,0-1.76,1.08l-2.89,6.46a1.23,1.23,0,0,0,.5,1.55h0l3.4,2a1.48,1.48,0,0,1,.08.88c-.23,1-.41,2.07-.53,3.08a3.87,3.87,0,0,1-1,2.1l-4.23,3.88a2.58,2.58,0,0,0-.71,2.08l.8,4.61a.88.88,0,0,0,.38.63h0l5,2.91h0a.82.82,0,0,0,.87-.08l1.81-1.2-1.75,4.75a1.06,1.06,0,0,0,.42,1.29h0l5,2.91v0a1.07,1.07,0,0,0,.36.16l3.18.71a1.72,1.72,0,0,0,1.8-.83l3-5.71a3,3,0,0,1,1.2-1.1l.13.46a.94.94,0,0,0,.41.56h0l5,2.87h0l.06,0h0a.83.83,0,0,0,.92-.14l4.77-3.75a2.65,2.65,0,0,0,.9-2l-.28-4.54a3.62,3.62,0,0,1,.74-2.19q1.17-1.41,2.22-2.94a2.47,2.47,0,0,1,1.94-1l3.06.15a2,2,0,0,0,1.76-1.08l2.89-6.46a1.24,1.24,0,0,0-.65-1.64l-2.47-1a1.53,1.53,0,0,1-.85-1.71C180.08,73.7,180.26,72.67,180.38,71.66Zm-25.45,14c-.94-5.43,2.49-13.12,7.66-17.19A10.47,10.47,0,0,1,168,66.07a7.88,7.88,0,0,1,.59,2c.94,5.43-2.49,13.12-7.66,17.19a10.5,10.5,0,0,1-5.42,2.42A7.69,7.69,0,0,1,154.93,85.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,95.81a1.21,1.21,0,0,0-1.69-.38L146.09,97l-1.76,4.75a1.06,1.06,0,0,0,.43,1.29l5,2.86a1,1,0,0,1-.37-1.26l2.15-5.82a2.11,2.11,0,0,0-.49-2A8.27,8.27,0,0,1,150.19,95.81Zm14.68,7.27a1,1,0,0,1-.4-.55L163.4,99a1.1,1.1,0,0,0-1.51-.69,12.15,12.15,0,0,1-2,.65,2.49,2.49,0,0,0-.62.26l.14.46a.94.94,0,0,0,.41.55h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,88.15c-4.46,3.51-8.76,3.17-10.44-.48A10.51,10.51,0,0,0,161,85.26c5.16-4.07,8.6-11.76,7.67-17.19a7.78,7.78,0,0,0-.61-2c2.84-.25,5,1.45,5.63,4.88C174.58,76.4,171.15,84.09,166,88.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,67a2,2,0,0,1-.87.19l-3.08-.15a2,2,0,0,0-1.27.46l5,2.9A1.91,1.91,0,0,1,149.4,70l3.07.14a2.12,2.12,0,0,0,.87-.16Zm10.35-16.36a.8.8,0,0,0-.93.12L153,54.55a2.62,2.62,0,0,0-.79,1.25l5,2.89a2.64,2.64,0,0,1,.79-1.25l4.77-3.74a.79.79,0,0,1,.94-.13h0ZM142.09,84.23l-4.18,3.84a2.45,2.45,0,0,0-.64,1.2l5,2.89a2.33,2.33,0,0,1,.66-1.19l4.17-3.83Zm31.65-36.45a.93.93,0,0,0-.34-.13l-3.18-.71a1.72,1.72,0,0,0-1.8.83l-3,5.7a2.72,2.72,0,0,1-.68.77l5,2.9a2.86,2.86,0,0,0,.68-.77l3-5.7a1.72,1.72,0,0,1,1.8-.84l3.18.72a1.61,1.61,0,0,1,.33.12Zm6.41,7.67h0a.82.82,0,0,0-.88.08l-1.81,1.2-.41,1.08a2.09,2.09,0,0,0,.51,2,8.14,8.14,0,0,1,.81,1,1.7,1.7,0,0,0,.22.24l.19.14a1.1,1.1,0,0,0,.42.17,1.07,1.07,0,0,0,.56,0,.85.85,0,0,0,.31-.14l4.22-2.77a1.3,1.3,0,0,1,.32-.15.6.6,0,0,1,.35,0,.66.66,0,0,1,.2.06Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,67a2,2,0,0,1-.87.19l-3.08-.15a2,2,0,0,0-1.27.46l5,2.9A1.91,1.91,0,0,1,149.4,70l3.07.14a2.12,2.12,0,0,0,.87-.16Zm10.35-16.36a.8.8,0,0,0-.93.12L153,54.55a2.62,2.62,0,0,0-.79,1.25l5,2.89a2.64,2.64,0,0,1,.79-1.25l4.77-3.74a.79.79,0,0,1,.94-.13h0ZM142.09,84.23l-4.18,3.84a2.45,2.45,0,0,0-.64,1.2l5,2.89a2.33,2.33,0,0,1,.66-1.19l4.17-3.83Zm31.65-36.45a.93.93,0,0,0-.34-.13l-3.18-.71a1.72,1.72,0,0,0-1.8.83l-3,5.7a2.72,2.72,0,0,1-.68.77l5,2.9a2.86,2.86,0,0,0,.68-.77l3-5.7a1.72,1.72,0,0,1,1.8-.84l3.18.72a1.61,1.61,0,0,1,.33.12Zm6.41,7.67h0a.82.82,0,0,0-.88.08l-1.81,1.2-.41,1.08a2.09,2.09,0,0,0,.51,2,8.14,8.14,0,0,1,.81,1,1.7,1.7,0,0,0,.22.24l.19.14a1.1,1.1,0,0,0,.42.17,1.07,1.07,0,0,0,.56,0,.85.85,0,0,0,.31-.14l4.22-2.77a1.3,1.3,0,0,1,.32-.15.6.6,0,0,1,.35,0,.66.66,0,0,1,.2.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,63.6l-.8-4.61a.76.76,0,0,0-1.26-.55l-4.22,2.78a1.22,1.22,0,0,1-1.69-.38,8.27,8.27,0,0,0-.83-1,2.1,2.1,0,0,1-.49-2L179.21,52a1.06,1.06,0,0,0-.79-1.44l-3.18-.72a1.73,1.73,0,0,0-1.8.84l-3,5.7a3.18,3.18,0,0,1-1.81,1.36,16,16,0,0,0-2,.65,1.09,1.09,0,0,1-1.51-.69l-1.07-3.57a.8.8,0,0,0-1.35-.42L158,57.44a2.67,2.67,0,0,0-.9,2l.28,4.54a3.62,3.62,0,0,1-.74,2.19c-.78.94-1.52,1.92-2.22,2.93a2.48,2.48,0,0,1-1.94,1L149.4,70a2,2,0,0,0-1.76,1.08l-2.89,6.46a1.22,1.22,0,0,0,.65,1.63l2.47,1.06a1.52,1.52,0,0,1,.85,1.71c-.23,1-.41,2.07-.53,3.08a3.8,3.8,0,0,1-1,2.09L142.93,91a2.58,2.58,0,0,0-.71,2.08l.8,4.61a.76.76,0,0,0,1.26.55l4.22-2.78a1.21,1.21,0,0,1,1.69.38,9.1,9.1,0,0,0,.83,1,2.1,2.1,0,0,1,.49,2l-2.15,5.82a1.06,1.06,0,0,0,.79,1.45l3.18.71a1.72,1.72,0,0,0,1.8-.83l3-5.71a3.16,3.16,0,0,1,1.81-1.35,16,16,0,0,0,2-.65,1.09,1.09,0,0,1,1.51.69l1.07,3.57a.8.8,0,0,0,1.35.42l4.77-3.75a2.65,2.65,0,0,0,.9-2l-.28-4.54a3.62,3.62,0,0,1,.74-2.19q1.17-1.41,2.22-2.94a2.47,2.47,0,0,1,1.94-1l3.06.15a2,2,0,0,0,1.76-1.08l2.89-6.46a1.24,1.24,0,0,0-.65-1.64l-2.47-1a1.53,1.53,0,0,1-.85-1.71c.23-1,.41-2.07.53-3.08a3.87,3.87,0,0,1,1-2.1l4.23-3.88A2.58,2.58,0,0,0,186.35,63.6ZM166,88.15c-5.17,4.07-10.12,3-11-2.47s2.49-13.12,7.66-17.19,10.12-2.95,11,2.48S171.15,84.09,166,88.15Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,63.6l-.8-4.61a.76.76,0,0,0-1.26-.55l-4.22,2.78a1.22,1.22,0,0,1-1.69-.38,8.27,8.27,0,0,0-.83-1,2.1,2.1,0,0,1-.49-2L179.21,52a1.06,1.06,0,0,0-.79-1.44l-3.18-.72a1.73,1.73,0,0,0-1.8.84l-3,5.7a3.18,3.18,0,0,1-1.81,1.36,16,16,0,0,0-2,.65,1.09,1.09,0,0,1-1.51-.69l-1.07-3.57a.8.8,0,0,0-1.35-.42L158,57.44a2.67,2.67,0,0,0-.9,2l.28,4.54a3.62,3.62,0,0,1-.74,2.19c-.78.94-1.52,1.92-2.22,2.93a2.48,2.48,0,0,1-1.94,1L149.4,70a2,2,0,0,0-1.76,1.08l-2.89,6.46a1.22,1.22,0,0,0,.65,1.63l2.47,1.06a1.52,1.52,0,0,1,.85,1.71c-.23,1-.41,2.07-.53,3.08a3.8,3.8,0,0,1-1,2.09L142.93,91a2.58,2.58,0,0,0-.71,2.08l.8,4.61a.76.76,0,0,0,1.26.55l4.22-2.78a1.21,1.21,0,0,1,1.69.38,9.1,9.1,0,0,0,.83,1,2.1,2.1,0,0,1,.49,2l-2.15,5.82a1.06,1.06,0,0,0,.79,1.45l3.18.71a1.72,1.72,0,0,0,1.8-.83l3-5.71a3.16,3.16,0,0,1,1.81-1.35,16,16,0,0,0,2-.65,1.09,1.09,0,0,1,1.51.69l1.07,3.57a.8.8,0,0,0,1.35.42l4.77-3.75a2.65,2.65,0,0,0,.9-2l-.28-4.54a3.62,3.62,0,0,1,.74-2.19q1.17-1.41,2.22-2.94a2.47,2.47,0,0,1,1.94-1l3.06.15a2,2,0,0,0,1.76-1.08l2.89-6.46a1.24,1.24,0,0,0-.65-1.64l-2.47-1a1.53,1.53,0,0,1-.85-1.71c.23-1,.41-2.07.53-3.08a3.87,3.87,0,0,1,1-2.1l4.23-3.88A2.58,2.58,0,0,0,186.35,63.6ZM166,88.15c-5.17,4.07-10.12,3-11-2.47s2.49-13.12,7.66-17.19,10.12-2.95,11,2.48S171.15,84.09,166,88.15Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.93,50.56h0l.15,0,3.18.71a.31.31,0,0,1,.23.16.3.3,0,0,1,0,.28l-2.15,5.82a2.85,2.85,0,0,0,.65,2.8,8.36,8.36,0,0,1,.75.92,2.08,2.08,0,0,0,1.68.91,1.94,1.94,0,0,0,1.06-.32l4.22-2.78.07,0a.15.15,0,0,1,0,.08l.8,4.6a1.84,1.84,0,0,1-.48,1.4L180.9,69a4.6,4.6,0,0,0-1.28,2.57,28.09,28.09,0,0,1-.51,3,2.31,2.31,0,0,0,1.29,2.58l2.48,1a.49.49,0,0,1,.25.26.48.48,0,0,1,0,.37l-2.88,6.46a1.24,1.24,0,0,1-1,.63h0l-3.07-.15H176a3.21,3.21,0,0,0-2.49,1.32c-.69,1-1.42,2-2.17,2.87a4.35,4.35,0,0,0-.92,2.73l.29,4.54a2,2,0,0,1-.62,1.37l-4.77,3.75-.1.07a.61.61,0,0,1-.05-.11l-1.07-3.57a1.82,1.82,0,0,0-1.76-1.33,2,2,0,0,0-.76.15,14.11,14.11,0,0,1-1.87.62,3.85,3.85,0,0,0-2.29,1.74l-3,5.7a1,1,0,0,1-.82.47l-.15,0-3.18-.71a.34.34,0,0,1-.23-.16.31.31,0,0,1,0-.28l2.15-5.83a2.86,2.86,0,0,0-.65-2.8,7.51,7.51,0,0,1-.75-.92,2.09,2.09,0,0,0-1.68-.9,1.94,1.94,0,0,0-1.06.32l-4.22,2.78-.07,0a.19.19,0,0,1,0-.08l-.8-4.61a1.83,1.83,0,0,1,.48-1.39l4.22-3.89A4.54,4.54,0,0,0,149,85.08a28.09,28.09,0,0,1,.51-3,2.3,2.3,0,0,0-1.29-2.58l-2.48-1.06a.46.46,0,0,1-.25-.26.45.45,0,0,1,0-.36l2.88-6.46a1.25,1.25,0,0,1,1-.64h0l3.07.16h.11A3.21,3.21,0,0,0,155,69.56c.69-1,1.42-2,2.17-2.87a4.35,4.35,0,0,0,.92-2.73l-.29-4.54a2,2,0,0,1,.62-1.38l4.77-3.75.1-.06a.38.38,0,0,1,.05.11l1.07,3.57a1.82,1.82,0,0,0,1.76,1.33,2,2,0,0,0,.76-.16,14.52,14.52,0,0,1,1.87-.61,3.89,3.89,0,0,0,2.29-1.74l3-5.71a1,1,0,0,1,.82-.46M160,91.36a10.69,10.69,0,0,0,6.41-2.61c5.36-4.21,8.92-12.25,7.94-17.91-.6-3.48-2.79-5.56-5.86-5.56a10.71,10.71,0,0,0-6.41,2.62c-5.35,4.21-8.92,12.24-7.94,17.91.59,3.48,2.79,5.55,5.86,5.55M174.93,49.8a1.74,1.74,0,0,0-1.49.87l-3,5.7a3.18,3.18,0,0,1-1.81,1.36,16,16,0,0,0-2,.65,1.36,1.36,0,0,1-.48.09,1.06,1.06,0,0,1-1-.78l-1.07-3.57a.81.81,0,0,0-.76-.65.94.94,0,0,0-.59.23L158,57.44a2.67,2.67,0,0,0-.9,2l.28,4.54a3.62,3.62,0,0,1-.74,2.19c-.78.94-1.52,1.92-2.22,2.93a2.46,2.46,0,0,1-1.86,1h-.08L149.4,70h-.07a2,2,0,0,0-1.69,1.09l-2.89,6.46a1.22,1.22,0,0,0,.65,1.63l2.47,1.06a1.52,1.52,0,0,1,.85,1.71c-.23,1-.41,2.07-.53,3.08a3.8,3.8,0,0,1-1,2.09L142.93,91a2.58,2.58,0,0,0-.71,2.08l.8,4.61c.08.46.36.73.72.73a1,1,0,0,0,.54-.18l4.22-2.78a1.1,1.1,0,0,1,.64-.2,1.28,1.28,0,0,1,1.05.58,9.1,9.1,0,0,0,.83,1,2.1,2.1,0,0,1,.49,2l-2.15,5.82a1.06,1.06,0,0,0,.79,1.45l3.18.71a1.06,1.06,0,0,0,.31,0,1.74,1.74,0,0,0,1.49-.87l3-5.71a3.16,3.16,0,0,1,1.81-1.35,16,16,0,0,0,2-.65,1.18,1.18,0,0,1,.48-.1,1.07,1.07,0,0,1,1,.79l1.07,3.57a.81.81,0,0,0,.76.65.94.94,0,0,0,.59-.23l4.77-3.75a2.65,2.65,0,0,0,.9-2l-.28-4.54a3.62,3.62,0,0,1,.74-2.19q1.17-1.41,2.22-2.94a2.47,2.47,0,0,1,1.86-1h.08l3.06.15h.07a2,2,0,0,0,1.69-1.08l2.89-6.46a1.24,1.24,0,0,0-.65-1.64l-2.47-1a1.53,1.53,0,0,1-.85-1.71c.23-1,.41-2.07.53-3.08a3.87,3.87,0,0,1,1-2.1l4.23-3.88a2.58,2.58,0,0,0,.71-2.08l-.8-4.61c-.08-.47-.36-.73-.72-.73a1,1,0,0,0-.54.18l-4.22,2.78a1.18,1.18,0,0,1-.64.2,1.31,1.31,0,0,1-1.05-.58,8.27,8.27,0,0,0-.83-1,2.1,2.1,0,0,1-.49-2L179.21,52a1.06,1.06,0,0,0-.79-1.44l-3.18-.72a1.55,1.55,0,0,0-.31,0ZM160,90.6c-2.59,0-4.56-1.7-5.11-4.92-.94-5.43,2.49-13.12,7.66-17.19A10,10,0,0,1,168.53,66c2.59,0,4.56,1.7,5.11,4.93.94,5.42-2.49,13.12-7.66,17.18A9.92,9.92,0,0,1,160,90.6Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "28.2 343.02 28.2 172.36 27.05 173.03 20.61 169.31 33.99 144.26 40.64 148.09 53.33 157.85 45.95 162.11 45.95 340.38 34.79 346.83 28.2 343.02",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.18,144.9l6.17,3.57,12.14,9.33L46,161.58l-.47.27V340.12l-10.69,6.17-6.13-3.54V171.56l-1.39.8-.22.13-5.82-3.36,13-24.23m-.37-1.28L20,169.49l7.06,4.07.68-.39V343.29l7.06,4.07,11.62-6.71V162.38l7.75-4.47L40.87,147.69l-7.06-4.07Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--down-arrow--inject-19",
    points: "34.79 347.36 46.41 340.65 46.41 162.38 54.16 157.91 40.87 147.69 27.05 173.56 34.79 169.09 34.79 347.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.73 343.29 34.79 347.36 34.79 169.09 27.73 173.16 27.73 343.29",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.72,352.57c0,3.11,2.33,5.1,5.2,6.76L198.6,427.28a11.48,11.48,0,0,0,10.4,0L398.86,317.67c2.87-1.66,5.2-3.79,5.2-6.91s-2.33-5-5.2-6.69L281.17,236.13a11.48,11.48,0,0,0-10.4,0L80.92,345.74C78.05,347.4,75.72,349.46,75.72,352.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92,351.74,198.6,419.69a11.48,11.48,0,0,0,10.4,0L398.86,310.08c2.87-1.66,2.87-4.35,0-6L281.17,236.13a11.48,11.48,0,0,0-10.4,0L80.92,345.74C78.05,347.4,78.05,350.08,80.92,351.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.81,420.94v7.58a10.58,10.58,0,0,1-5.2-1.24L80.92,359.33c-2.87-1.65-5.2-3.65-5.2-6.76,0-2.92,2.09-4.95,4.79-6.6-2.23,1.58-2.27,4.22.41,5.77l117.69,67.95A10.58,10.58,0,0,0,203.81,420.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,346.62,271.44,245.89a5.44,5.44,0,0,1,4.91,0l6.35,3.57c1.36.78,1.36,2,0,2.83L108.21,353a5.44,5.44,0,0,1-4.91,0L97,349.45C95.62,348.67,95.62,347.4,97,346.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.11,356.73,288.58,256a5,5,0,0,1,4.48-.25L338.47,282c1.12.65.93,1.81-.43,2.59L163.78,385.15a5,5,0,0,1-4.48.25l-45.61-26.09C112.57,358.66,112.76,357.51,114.11,356.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.29,298.31l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.45l5.22,3A.9.9,0,0,0,265.29,298.31Zm-8-10.92-5.46,3.16c-.23.13-.25.34,0,.45l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.22-3A.9.9,0,0,0,257.31,287.39Zm-17.65,10.19-9.24,5.34c-.23.13-.25.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l9.25-5.34c.23-.13.25-.34,0-.46l-5.22-3A.94.94,0,0,0,239.66,297.58Zm9.67-5.58-5.46,3.16c-.24.13-.26.34-.05.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3A.88.88,0,0,0,249.33,292ZM227.9,304.37l-5.46,3.16c-.24.13-.26.34-.05.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34,0-.45l-5.23-3A.88.88,0,0,0,227.9,304.37Zm-8,4.61-5.46,3.16c-.23.13-.25.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3A.9.9,0,0,0,219.91,309ZM240.4,321.3l5.46-3.16c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.46l5.22,3A.9.9,0,0,0,240.4,321.3Zm-8,4.61,5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,232.41,325.91Zm-8,4.61,5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.26.34-.05.45l5.23,3A.88.88,0,0,0,224.43,330.52Zm-8,4.6,5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.45l5.22,3A.87.87,0,0,0,216.45,335.12Zm40.85-32.21,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.45l5.23,3A.85.85,0,0,0,257.3,302.91Zm-8.92,13.78,12.19-7c.23-.13.25-.34,0-.46l-12.69-7.32a.88.88,0,0,0-.79,0l-6.3,3.64c-.24.14-.26.34-.05.46l6.72,3.88c.2.12.18.32-.05.46l-5,2.91c-.23.13-.25.34,0,.46l5.23,3A.88.88,0,0,0,248.38,316.69Zm-36.45-3.1-5.46,3.16c-.23.13-.26.34-.05.46l5.23,3a.88.88,0,0,0,.79,0L217.9,317c.24-.13.26-.34,0-.46l-5.23-3A.88.88,0,0,0,211.93,313.59Zm-8,4.61-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,204,318.2Zm-44.18,49.22a.88.88,0,0,0,.79,0l5.46-3.15c.23-.14.26-.34,0-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.26.34-.05.46Zm-19.69-12.34-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.23-3A.85.85,0,0,0,140.08,355.08Zm10.12,9.24a.85.85,0,0,0,.79,0l5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0L145,360.85c-.23.13-.25.33-.05.45Zm22,4.95,5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3A.87.87,0,0,0,172.23,369.27Zm-8.78,4.64a.85.85,0,0,0,.79,0l5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.45Zm-15.39-23.44-5.46,3.15c-.24.14-.26.34,0,.46l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.14.26-.34.05-.46l-5.23-3A.88.88,0,0,0,148.06,350.47ZM188,327.42l-5.46,3.16c-.24.13-.26.33-.05.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,188,327.42ZM156,345.86,150.58,349c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3A.9.9,0,0,0,156,345.86ZM196,322.81,190.5,326c-.23.13-.25.34-.05.45l5.23,3a.85.85,0,0,0,.79,0l5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3A.9.9,0,0,0,196,322.81ZM180,332l-5.47,3.16c-.23.13-.25.33,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.22-3A.92.92,0,0,0,180,332Zm-8,4.61-5.46,3.16c-.23.13-.25.33-.05.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,172,336.64Zm-8,4.61-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0L170,344.7c.23-.14.25-.34.05-.46l-5.23-3A.88.88,0,0,0,164,341.25Zm36.45,3.09,5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34,0,.46l5.23,3A.85.85,0,0,0,200.48,344.34ZM275,277.2l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,275,277.2Zm-9.66,5.58-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,265.3,282.78Zm17.64-10.19-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3A.9.9,0,0,0,282.94,272.59Zm-44.12,41,5.46-3.15c.23-.14.25-.34,0-.46l-5.22-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46l5.22,3A.9.9,0,0,0,238.82,313.59ZM291.72,268a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46Zm-83.26,71.77,5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33-.05.45l5.23,3A.85.85,0,0,0,208.46,339.73Zm97.91-56.52,5.46-3.16c.23-.13.26-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.26.34,0,.46l5.23,3A.88.88,0,0,0,306.37,283.21Zm-15.45.3,5.46-3.16c.23-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0L285,280.06c-.23.13-.26.34-.05.46l5.23,3A.88.88,0,0,0,290.92,283.51Zm8.27-11.24a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.45Zm1.68-1,12.69,7.33a.92.92,0,0,0,.79,0l5.47-3.16c.23-.13.25-.33,0-.45l-12.69-7.33a.85.85,0,0,0-.79,0l-5.47,3.15C300.68,271,300.66,271.18,300.87,271.3Zm-18.44,10.21L277,284.67c-.23.13-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0L288.4,285c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,282.43,281.51Zm-60.09,34.7-5.46,3.15c-.24.13-.26.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.33.05-.45l-5.23-3A.85.85,0,0,0,222.34,316.21Zm75.25-28.37a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.46ZM230.32,311.6l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.33.05-.45l-5.23-3A.85.85,0,0,0,230.32,311.6Zm-62.57,51.21a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46Zm-9.28-9.73L153,356.24c-.23.13-.25.33,0,.45l5.22,3a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3A.92.92,0,0,0,158.47,353.08Zm18.06,5.09L182,355c.23-.14.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46l5.22,3A.87.87,0,0,0,176.53,358.17Zm8-4.61,5.46-3.15c.24-.14.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.23,3A.85.85,0,0,0,184.51,353.56Zm8-4.61L198,345.8c.23-.14.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.22,3A.87.87,0,0,0,192.5,349Zm-26.05-.48L161,351.63c-.23.13-.25.34-.05.45l5.23,3a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.23-3A.88.88,0,0,0,166.45,348.47Zm8-4.61L169,347c-.23.13-.25.34-.05.45l5.23,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3A.9.9,0,0,0,174.43,343.86Zm31.94-18.43-5.46,3.15c-.24.13-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.26-.34,0-.46l-5.23-3A.85.85,0,0,0,206.37,325.43Zm-8,4.6-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34,0-.46l-5.23-3A.88.88,0,0,0,198.39,330Zm16-9.21L208.89,324c-.23.13-.25.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.45l-5.22-3A.87.87,0,0,0,214.35,320.82Zm-31.93,18.43L177,342.41c-.24.13-.26.34-.05.45l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3A.88.88,0,0,0,182.42,339.25Zm8-4.61-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34,0-.46l-5.22-3A.9.9,0,0,0,190.4,334.64Zm-10.19,30,5.46-3.16c.24-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,180.21,364.67Zm-42.1-2-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.15C138.3,363,138.32,362.8,138.11,362.68Zm10.41,2.61-5.23-3a.88.88,0,0,0-.79,0l-8.4,4.85c-.24.14-.26.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l8.4-4.85C148.7,365.61,148.72,365.41,148.52,365.29Zm-18.21-8.57-5.22-3a.87.87,0,0,0-.8,0l-6.72,3.88c-.23.13-.25.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l6.72-3.88C130.5,357,130.52,356.84,130.31,356.72Zm5.16-3a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34,0,.46Zm22.62,14.65-5.23-3a.85.85,0,0,0-.79,0l-10.51,6.06c-.23.14-.25.34-.05.46l5.23,3a.85.85,0,0,0,.79,0L158,368.85C158.27,368.71,158.29,368.51,158.09,368.39Zm3.68,6.49-5.23-3a.92.92,0,0,0-.79,0L149,375.77c-.24.14-.26.34-.05.46l5.23,3a.85.85,0,0,0,.79,0l6.72-3.88C162,375.21,162,375,161.77,374.88Zm33.06-55.41a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0L189.65,316c-.24.13-.26.34-.05.45Zm-16,9.22a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.33-.05.45Zm-35.41,20.44a.88.88,0,0,0,.79,0l5.47-3.16c.23-.13.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46Zm43.39-25.05a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.45Zm-16,9.22a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34.05-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34,0,.46Zm-5.18,41.9a.92.92,0,0,0-.79,0l-8.41,4.85c-.23.14-.25.34,0,.46l5.22,3a.87.87,0,0,0,.8,0l8.4-4.85c.23-.13.25-.34,0-.46Zm-6.27-35.28a.92.92,0,0,0,.79,0l5.46-3.16c.24-.13.26-.33.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.25.34-.05.46Zm-8,4.6a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46ZM313.6,289.81a.85.85,0,0,0-.79,0l-13.45,7.76c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l13.45-7.77c.23-.13.25-.34.05-.45ZM296,300a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.46ZM188.2,360.06l5.46-3.16c.23-.13.25-.34,0-.46l-5.22-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.46l5.22,3A.9.9,0,0,0,188.2,360.06ZM280,309.22a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34,0-.46Zm41.6-24a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.33.05-.45Zm13.21-1.59-12.69-7.33a.85.85,0,0,0-.79,0l-5.46,3.15c-.24.13-.26.34-.05.46l12.69,7.33a.88.88,0,0,0,.79,0l5.47-3.16C335,283.93,335,283.73,334.79,283.61Zm-84.64,42.83a.85.85,0,0,0-.79,0l-6.73,3.88c-.23.13-.25.34,0,.46l5.22,3a.94.94,0,0,0,.8,0l6.72-3.88c.23-.14.25-.34,0-.46Zm20.17-11.64a.88.88,0,0,0-.79,0l-8.41,4.86c-.23.13-.25.33,0,.45l5.22,3a.87.87,0,0,0,.8,0l8.4-4.85c.23-.13.25-.34.05-.46Zm-38.66,22.32a.88.88,0,0,0-.79,0l-45,26c-.23.14-.26.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l45-26c.23-.13.25-.34,0-.46Zm-47.48,27.41a.85.85,0,0,0-.79,0l-6.73,3.88c-.23.13-.25.34,0,.46l5.22,3a.88.88,0,0,0,.79,0l6.73-3.88c.23-.14.25-.34,0-.46Zm56.73-32.75a.87.87,0,0,0-.8,0l-6.72,3.88c-.23.13-.25.34,0,.46l5.23,3a.88.88,0,0,0,.79,0l6.73-3.89c.23-.13.25-.33,0-.45Zm-66,38.09a.88.88,0,0,0-.79,0l-6.72,3.89c-.23.13-.26.34,0,.45l5.23,3a.85.85,0,0,0,.79,0l6.72-3.88c.24-.13.26-.34,0-.46ZM259.4,321.1a.94.94,0,0,0-.8,0L251.88,325c-.23.14-.25.34,0,.46l5.23,3a.85.85,0,0,0,.79,0l6.72-3.88c.24-.13.26-.34.05-.46ZM288,304.61a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.46l5.22,3a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34,0-.46Zm17.88-12.48,5.46-3.16c.24-.13.26-.34.05-.45l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,305.85,292.13Zm-32.58,1.57,5.46-3.16c.24-.13.26-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,273.27,293.7Zm-21.2,29.48L268,314c.24-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-16,9.22c-.23.14-.25.34,0,.46l5.22,3A.9.9,0,0,0,252.07,323.18Zm45-26.42a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.16c-.23.13-.25.34,0,.46Zm-6.67-4.33,5.46-3.16c.24-.13.26-.34.05-.46l-5.22-3a.9.9,0,0,0-.8,0L284.43,289c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,290.4,292.43Zm-46.32,35.36,5.46-3.15c.24-.14.26-.34.05-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34-.05.46l5.23,3A.88.88,0,0,0,244.08,327.79ZM279.43,307a.88.88,0,0,0,.79,0l5.46-3.16c.23-.13.25-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.16c-.24.13-.26.34-.05.46Zm-75.27,43.89,5.47-3.16c.23-.13.25-.34,0-.45l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.46l5.23,3A.88.88,0,0,0,204.16,350.84Zm8-4.61,5.46-3.16c.23-.13.25-.34,0-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46l5.22,3A.9.9,0,0,0,212.15,346.23Zm-16,9.22,5.46-3.16c.23-.13.26-.34.05-.46l-5.23-3a.88.88,0,0,0-.79,0L190.21,352c-.24.13-.26.34-.05.46l5.23,3A.88.88,0,0,0,196.18,355.45ZM228.11,337l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.87.87,0,0,0-.8,0l-5.46,3.15c-.23.13-.25.34,0,.46l5.22,3A.88.88,0,0,0,228.11,337Zm-8,4.61,5.46-3.16c.24-.13.26-.33,0-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.13-.26.34,0,.46l5.23,3A.92.92,0,0,0,220.13,341.62Zm16-9.22,5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0L230.13,329c-.24.13-.26.34,0,.46l5.22,3A.9.9,0,0,0,236.1,332.4Zm43.57-64.12a.92.92,0,0,0,.79,0l5.46-3.16c.23-.13.26-.33.05-.45l-1.39-.81a.9.9,0,0,0-.8,0L278.32,267c-.23.14-.25.34,0,.46ZM240,293.4a.87.87,0,0,0,.8,0l5.46-3.15c.23-.13.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46Zm16-9.22a.85.85,0,0,0,.79,0l5.47-3.15c.23-.13.25-.34,0-.46l-5.22-3a.94.94,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34,0,.45ZM230.23,299a.87.87,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34,0-.46l-5.23-3a.88.88,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46ZM248,288.79a.85.85,0,0,0,.79,0l5.46-3.15c.24-.13.26-.34.05-.46l-5.23-3a.92.92,0,0,0-.79,0l-5.46,3.16c-.23.13-.25.33,0,.45Zm-33.7,19.46a.88.88,0,0,0,.79,0l5.46-3.15c.24-.14.26-.34,0-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.46,3.15c-.23.14-.25.34-.05.46Zm8-4.61a.88.88,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.15c-.23.14-.25.34,0,.46Zm41.45-26.15a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.45l-1.39-.81a.88.88,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46Zm23.95-13.82a.92.92,0,0,0,.79,0l5.47-3.15c.23-.14.25-.34,0-.46l-1.39-.81a.88.88,0,0,0-.79,0l-5.46,3.15c-.24.14-.26.34-.05.46Zm11,6.33a.88.88,0,0,0,.79,0l5.46-3.16c.24-.13.26-.34.05-.45l-5.22-3a.9.9,0,0,0-.8,0l-5.46,3.16c-.23.13-.25.34-.05.46Zm15.21,17.52,5.46-3.16c.23-.13.25-.34.05-.45l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.13-.25.34,0,.46l5.22,3A.94.94,0,0,0,313.84,287.52Zm-42.16-14.64a.9.9,0,0,0,.8,0l5.46-3.16c.23-.13.25-.34.05-.45l-1.4-.81a.88.88,0,0,0-.79,0l-5.46,3.15c-.23.14-.26.34,0,.46Zm-65.4,40a.9.9,0,0,0,.8,0l5.46-3.15c.23-.14.25-.34.05-.46l-5.23-3a.85.85,0,0,0-.79,0l-5.47,3.15c-.23.14-.25.34,0,.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "229.15 358.29 230.34 358.98 261.89 377.19 317.99 344.79 319.16 344.13 286.42 325.23 229.15 358.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.27 345.21 286.42 327.41 231.06 359.39 261.89 377.19 317.27 345.21",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.51,347.07c-2.13-1.14-2.6-3-2.6-6.35l0-155.13a11.5,11.5,0,0,1,5.2-9L264.94,67c2.87-1.66,4.95-2.55,7.39-.61s2.42,3,2.42,6.3l0,155.13a11.5,11.5,0,0,1-5.2,9L79.71,346.41C76.84,348.07,75.24,348.54,72.51,347.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.75,72.65c0-3.31-2.33-4.65-5.2-3L79.69,179.27A10.53,10.53,0,0,0,76,183.16l-4.61-2.7h0a10.7,10.7,0,0,1,3.69-3.88L264.93,67c2.88-1.66,5-2.57,7.39-.61S274.75,69.34,274.75,72.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,346.63c-2.62,1.55-4.22,1.71-6.82.44-2-1-2.6-3-2.6-6.35l0-155.14a10.44,10.44,0,0,1,1.52-5.11L76,183.14h0a10.66,10.66,0,0,0-1.53,5.12l0,155.14C74.51,346.48,76.87,348.08,79.33,346.63Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.49,185.27,265.19,79.81c1.73-1,3.12-.19,3.12,1.8l0,144.73a6.86,6.86,0,0,1-3.12,5.4L82.51,337.19c-1.72,1-3.12.19-3.12-1.8l0-144.72A6.89,6.89,0,0,1,82.49,185.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,185.27a6.89,6.89,0,0,0-3.12,5.4l0,142.31L260.05,228.74a6.92,6.92,0,0,0,3.12-5.41l0-142.31Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.85,139.57,175.39,143l.84,2.34,5.4-2L152.7,204.62l-30.14-5.8-30.72,48,2.09,1.34,29.81-46.56,30.38,5.84,29.81-63.11,2,5.57,2.33-.84Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,266.12,94.4,276.71v25.85l3.49,2.34,18.34-10.59V268.46Zm27.51-43-18.34,10.59v53L125.4,289l18.35-10.59v-53Zm58.52-50.61-3.49-2.34L177,180.77V254.9l3.48,2.35,18.35-10.59Zm-31,55.91L149.43,239v31.77l3.49,2.34,18.34-10.59V230.77Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,236.07V289l18.35-10.59v-53Zm-27.51,43V304.9l18.34-10.59V268.46ZM198.78,172.52l-18.35,10.59v74.14l18.35-10.59Zm-45.86,68.84v31.77l18.34-10.59V230.77Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,276.71l3.49,2.34,18.34-10.59-3.48-2.34Zm27.52-43,3.48,2.35,18.35-10.59-3.49-2.35Zm27.51,5.3,3.49,2.34,18.34-10.59-3.48-2.34Zm45.86-68.84L177,180.77l3.48,2.34,18.35-10.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.53,390a18.92,18.92,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.69,0a19,19,0,0,0-7,6.51H17.17v6h0c.21,4.19,3.08,8.34,8.61,11.53,11.52,6.65,30.18,6.65,41.69,0,5.53-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.53,390a18.92,18.92,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.69,0a19,19,0,0,0-7,6.51H17.17v6h0c.21,4.19,3.08,8.34,8.61,11.53,11.52,6.65,30.18,6.65,41.69,0,5.53-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65,378.52c-7.55,0-15.09,1.66-20.85,5a19,19,0,0,0-7,6.51H17.17v6h0c.21,4.19,3.08,8.34,8.61,11.53,5.76,3.33,13.3,5,20.85,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55,381.28a32.35,32.35,0,0,0-4.75,2.23,19,19,0,0,0-7,6.51H17.17v6h0c.21,4.19,3.08,8.34,8.61,11.53a32.32,32.32,0,0,0,4.75,2.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.74,381.28a31.87,31.87,0,0,1,4.75,2.23,18.92,18.92,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.1,8.34-8.63,11.53a31.84,31.84,0,0,1-4.75,2.22Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,378c-11.51,6.64-11.51,17.42,0,24.06,10.08,5.82,25.62,6.55,37.06,2.18h0l.45-.17a32.12,32.12,0,0,0,4.17-2c9.6-5.54,11.19-13.95,4.78-20.45h0A22.56,22.56,0,0,0,67.49,378C56,371.34,37.32,371.34,25.8,378Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,378c-11.51,6.64-11.51,17.42,0,24.06,10.08,5.82,25.62,6.55,37.06,2.18h0l.45-.17a32.12,32.12,0,0,0,4.17-2c9.6-5.54,11.19-13.95,4.78-20.45h0A22.56,22.56,0,0,0,67.49,378C56,371.34,37.32,371.34,25.8,378Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.27,381.6a12.9,12.9,0,0,1,3.08,10.5c-1,5.85-9.21,10.77-12,12a32.12,32.12,0,0,0,4.17-2C77.09,396.51,78.68,388.1,72.27,381.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,398.44a12.9,12.9,0,0,1-3.08-10.5c1-5.85,9.21-10.77,12-12a32,32,0,0,0-4.16,2C16.21,383.53,14.61,391.94,21,398.44Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.66,
    cy: 390,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.66,
    cy: 390,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.81,394.72c2.21-4.07,1.49-8.56-2.15-12.36a18,18,0,0,0-2.32-2,25.86,25.86,0,0,0-2.22-1.46c-.44-.25-.88-.5-1.35-.73,1.14,1.87.72,3.88-5.73,4.26-12.63.74,3.38,12.8,3.38,12.8S70.56,391.26,72.81,394.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.51,391.38c1.89-.21,2.83-2.16,2.1-4.35s-2.87-3.8-4.77-3.59-2.83,2.17-2.1,4.36S69.61,391.59,71.51,391.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,401.44c-.62-4.69-21.12-17.67-21.12-17.67s-4.54-1.83-3-5a24.47,24.47,0,0,0-2.2,1.41c-.47.35-.91.7-1.33,1.06-6.1,5.28-6.11,12.22,0,17.51.42.36.86.72,1.33,1.06a22.4,22.4,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14.6.28,1.22.55,1.85.8s1.26.48,1.92.69a39.78,39.78,0,0,0,6.11,1.47l1.38.2a46,46,0,0,0,6.11.38,46.63,46.63,0,0,0,7.49-.61S51,404.52,51.53,401.44Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,401.44c-.62-4.69-21.12-17.67-21.12-17.67s-4.54-1.83-3-5a24.47,24.47,0,0,0-2.2,1.41c-.47.35-.91.7-1.33,1.06-6.1,5.28-6.11,12.22,0,17.51.42.36.86.72,1.33,1.06a22.4,22.4,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14.6.28,1.22.55,1.85.8s1.26.48,1.92.69a39.78,39.78,0,0,0,6.11,1.47l1.38.2a46,46,0,0,0,6.11.38,46.63,46.63,0,0,0,7.49-.61S51,404.52,51.53,401.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.21,381.66c-7.64,4.42-7.95,11.46-.93,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.07,0-16.67c-.32-.19-.66-.37-1-.54C52.06,377.07,39.86,377.25,32.21,381.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.21,381.66c-7.64,4.42-7.95,11.46-.93,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.07,0-16.67c-.32-.19-.66-.37-1-.54C52.06,377.07,39.86,377.25,32.21,381.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.66,
    cy: 390,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.66,
    cy: 390,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86,385.17c7.62-4.4,20-4.4,27.6,0,3.11,1.8,4.95,4.06,5.52,6.4-.57,2.34-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-4.95-4-5.52-6.39C27.91,389.23,29.75,387,32.86,385.17Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86,385.17c7.62-4.4,20-4.4,27.6,0,3.11,1.8,4.95,4.06,5.52,6.4-.57,2.34-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-4.95-4-5.52-6.39C27.91,389.23,29.75,387,32.86,385.17Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.94,393.39c0-.38,0-1.93,0-2.33,0-.95-.67-1.88-2.09-2.71a.05.05,0,0,0,0,0,9.94,9.94,0,0,0-7.73-.71h0c-1,.26-2,.59-2.88.9a31.56,31.56,0,0,1-3.1,1h0a5.56,5.56,0,0,1-1.47.14,3.25,3.25,0,0,1-1.22-.32l.1-.07a2.2,2.2,0,0,1,.3-.19,9,9,0,0,1,.82-.41,5.64,5.64,0,0,1,4.34-.09l2.5-2.53v-2.31a11.8,11.8,0,0,0-6.84-.25,13.4,13.4,0,0,0-2.18.75l-2.5-1.44-3,1.72v2.31l1,.6a2.48,2.48,0,0,0-.44,1.35c0,.38,0,1.92,0,2.31,0,.95.69,1.88,2.13,2.71a8.63,8.63,0,0,0,4.12,1.18h.83A16,16,0,0,0,46,394l.86-.29-2.52,2.52v2.32A12.28,12.28,0,0,0,54,398.1l2.47,1.43,3-1.73v-2.31l-1-.6A2.64,2.64,0,0,0,58.94,393.39Zm-6.29-.2a7.46,7.46,0,0,1-.69.35,6.47,6.47,0,0,1-4.89.07c2.34-.83,4.29-1.55,6-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.08,387.61h0c-1,.26-2,.59-2.88.9a31.56,31.56,0,0,1-3.1,1h0a5.56,5.56,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.29l.3-.19a8.79,8.79,0,0,1,.82-.4,5.6,5.6,0,0,1,4.34-.1l2.5-2.52a11.8,11.8,0,0,0-6.84-.25,13.4,13.4,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.76,8.76,0,0,0,4.12,1.19h0a7.63,7.63,0,0,0,.83,0,16.32,16.32,0,0,0,4.43-.95c2.86-1,5.18-2.09,7.11-1,1.3.75.94,1.69-.48,2.51a7.46,7.46,0,0,1-.69.35,6.44,6.44,0,0,1-5,0l-2.62,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72L57,394.06c2.49-1.92,2.77-4-.13-5.71a.05.05,0,0,0,0,0A9.94,9.94,0,0,0,49.08,387.61Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.08,387.61h0c-1,.26-2,.59-2.88.9a31.56,31.56,0,0,1-3.1,1h0a5.56,5.56,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.29l.3-.19a8.79,8.79,0,0,1,.82-.4,5.6,5.6,0,0,1,4.34-.1l2.5-2.52a11.8,11.8,0,0,0-6.84-.25,13.4,13.4,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.76,8.76,0,0,0,4.12,1.19h0a7.63,7.63,0,0,0,.83,0,16.32,16.32,0,0,0,4.43-.95c2.86-1,5.18-2.09,7.11-1,1.3.75.94,1.69-.48,2.51a7.46,7.46,0,0,1-.69.35,6.44,6.44,0,0,1-5,0l-2.62,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72L57,394.06c2.49-1.92,2.77-4-.13-5.71a.05.05,0,0,0,0,0A9.94,9.94,0,0,0,49.08,387.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "33.93 384.47 36.94 383.1 39.41 384.19 36.91 382.75 33.93 384.47",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24,383.53a13.88,13.88,0,0,1,6.42.22l-1.73,2.46,2.5-2.52A11.9,11.9,0,0,0,41.24,383.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.81,388.32a.05.05,0,0,1,0,0c2.9,1.7,2.62,3.79.13,5.71,2.2-2.4,1.81-4.07-.58-5.45a11.27,11.27,0,0,0-7.33-1A9.94,9.94,0,0,1,56.81,388.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.99 394.06 58.89 395.51 56.48 397.21 59.47 395.49 56.99 394.06",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,393.54a6.43,6.43,0,0,1-4.76.41l-2.84,2.25L47,393.57A6.44,6.44,0,0,0,52,393.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.06,389.47a3.87,3.87,0,0,1-3.57-.34c-.87-.74-.31-1.54,1-2.23-1.4.92-1.26,1.73-.3,2.29a3.12,3.12,0,0,0,1.42.42A5.56,5.56,0,0,0,43.06,389.47Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.38,385.92c-.21.18-2,1.86-1.22,3.53s3.48,2.94,5.6,3.17h0a8.76,8.76,0,0,1-4.12-1.19C33.82,389.8,33.87,387.82,36.38,385.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.93,381.3a19,19,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51H20.58v6h0c.21,4.19,3.07,8.34,8.61,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.64-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,381.3a19,19,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51H20.58v6h0c.21,4.19,3.07,8.34,8.61,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.64-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.05,369.8c-7.54,0-15.09,1.67-20.84,5a19,19,0,0,0-7,6.51H20.58v6h0c.21,4.19,3.07,8.34,8.61,11.53,5.75,3.33,13.3,5,20.84,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,372.57a32.2,32.2,0,0,0-4.74,2.22,19,19,0,0,0-7,6.51H20.58v6h0c.21,4.19,3.07,8.34,8.61,11.53A32.23,32.23,0,0,0,34,401.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,372.57a31.72,31.72,0,0,1,4.74,2.22,19,19,0,0,1,7,6.51h1.6v6h0c-.22,4.19-3.1,8.34-8.64,11.53a31.76,31.76,0,0,1-4.74,2.23Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21,369.27c-11.51,6.64-11.51,17.42,0,24.07,10.07,5.81,25.62,6.54,37.06,2.18h0l.46-.18a32,32,0,0,0,4.16-2c9.6-5.55,11.2-14,4.78-20.46h0a22.31,22.31,0,0,0-4.78-3.61C59.38,362.62,40.72,362.62,29.21,369.27Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21,369.27c-11.51,6.64-11.51,17.42,0,24.07,10.07,5.81,25.62,6.54,37.06,2.18h0l.46-.18a32,32,0,0,0,4.16-2c9.6-5.55,11.2-14,4.78-20.46h0a22.31,22.31,0,0,0-4.78-3.61C59.38,362.62,40.72,362.62,29.21,369.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.67,372.88a12.89,12.89,0,0,1,3.09,10.5c-1,5.85-9.21,10.78-12,12a32,32,0,0,0,4.16-2C80.49,387.79,82.09,379.38,75.67,372.88Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.43,389.72a12.89,12.89,0,0,1-3.09-10.5c1-5.85,9.21-10.77,12-12a31.47,31.47,0,0,0-4.17,2C19.61,374.81,18,383.22,24.43,389.72Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.06,
    cy: 381.28,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.06,
    cy: 381.28,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.22,386c2.2-4.07,1.48-8.55-2.15-12.36a18.84,18.84,0,0,0-2.33-2,23.55,23.55,0,0,0-2.21-1.47c-.44-.25-.89-.5-1.35-.73,1.13,1.88.72,3.88-5.74,4.26-12.62.74,3.38,12.81,3.38,12.81S74,382.55,76.22,386Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.91,382.67c1.9-.22,2.84-2.17,2.1-4.36s-2.87-3.8-4.76-3.58-2.84,2.16-2.1,4.35S73,382.88,74.91,382.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.94,392.72c-.62-4.69-21.12-17.67-21.12-17.67s-4.55-1.82-3-5a21.19,21.19,0,0,0-2.19,1.42,16.21,16.21,0,0,0-1.33,1c-6.11,5.29-6.11,12.23,0,17.52.41.36.86.71,1.33,1,.63.46,1.3.9,2,1.33s1.42.78,2.17,1.13,1.22.55,1.85.8,1.27.48,1.92.69a39.9,39.9,0,0,0,6.12,1.47l1.37.2a46.24,46.24,0,0,0,6.12.38,45.3,45.3,0,0,0,7.48-.61S54.35,395.81,54.94,392.72Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.94,392.72c-.62-4.69-21.12-17.67-21.12-17.67s-4.55-1.82-3-5a21.19,21.19,0,0,0-2.19,1.42,16.21,16.21,0,0,0-1.33,1c-6.11,5.29-6.11,12.23,0,17.52.41.36.86.71,1.33,1,.63.46,1.3.9,2,1.33s1.42.78,2.17,1.13,1.22.55,1.85.8,1.27.48,1.92.69a39.9,39.9,0,0,0,6.12,1.47l1.37.2a46.24,46.24,0,0,0,6.12.38,45.3,45.3,0,0,0,7.48-.61S54.35,395.81,54.94,392.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62,372.94c-7.65,4.42-8,11.46-.94,16.09.3.2.62.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.66l-1-.55C55.47,368.35,43.26,368.53,35.62,372.94Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62,372.94c-7.65,4.42-8,11.46-.94,16.09.3.2.62.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.66l-1-.55C55.47,368.35,43.26,368.53,35.62,372.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.27,373.31c-7.62,4.4-7.62,11.53,0,15.93s20,4.4,27.59,0,7.62-11.53,0-15.93S43.89,368.91,36.27,373.31Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.27,373.31c-7.62,4.4-7.62,11.53,0,15.93s20,4.4,27.59,0,7.62-11.53,0-15.93S43.89,368.91,36.27,373.31Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.27,376.45c7.62-4.39,20-4.39,27.59,0,3.12,1.8,5,4.06,5.52,6.4-.56,2.34-2.4,4.59-5.52,6.39-7.62,4.4-20,4.4-27.59,0-3.12-1.8-5-4.05-5.53-6.39C31.31,380.51,33.15,378.25,36.27,376.45Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.27,376.45c7.62-4.39,20-4.39,27.59,0,3.12,1.8,5,4.06,5.52,6.4-.56,2.34-2.4,4.59-5.52,6.39-7.62,4.4-20,4.4-27.59,0-3.12-1.8-5-4.05-5.53-6.39C31.31,380.51,33.15,378.25,36.27,376.45Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35,384.67v-2.33c0-.95-.66-1.88-2.08-2.71l-.05,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.6-2.89.9a29,29,0,0,1-3.1,1h0a5.24,5.24,0,0,1-1.48.14,3.07,3.07,0,0,1-1.22-.32l.1-.07.31-.19a6.07,6.07,0,0,1,.81-.4,5.6,5.6,0,0,1,4.34-.1l2.5-2.53V375a11.88,11.88,0,0,0-6.84-.25,14.32,14.32,0,0,0-2.17.75L40.32,374l-3,1.72v2.32l1,.59a2.48,2.48,0,0,0-.44,1.35c0,.38,0,1.92,0,2.31,0,1,.68,1.88,2.12,2.71a8.83,8.83,0,0,0,4.13,1.19h0c.27,0,.55,0,.82,0a16.32,16.32,0,0,0,4.43-.95l.86-.3-2.52,2.52v2.32a12.28,12.28,0,0,0,9.65-.42l2.47,1.43,3-1.73v-2.31l-1-.59A2.71,2.71,0,0,0,62.35,384.67Zm-6.3-.2a7.46,7.46,0,0,1-.69.35,6.39,6.39,0,0,1-4.88.07c2.34-.82,4.29-1.54,6-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,378.89h0c-1,.26-2,.6-2.89.9a29,29,0,0,1-3.1,1h0a5.24,5.24,0,0,1-1.48.14,3.16,3.16,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.28l.31-.19a6.16,6.16,0,0,1,.81-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a11.88,11.88,0,0,0-6.84-.25,14.32,14.32,0,0,0-2.17.75L40.32,374l-3,1.72,2.47,1.43,0,0c-2.51,1.91-2.56,3.88.26,5.51a8.71,8.71,0,0,0,4.13,1.19h0c.27,0,.55,0,.82,0a16.71,16.71,0,0,0,4.43-1c2.87-1,5.19-2.09,7.12-1,1.29.74.93,1.68-.49,2.5a7.46,7.46,0,0,1-.69.35,6.37,6.37,0,0,1-5,0l-2.63,2.63a12.28,12.28,0,0,0,9.65-.41l2.47,1.42,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l-.05,0A10,10,0,0,0,52.48,378.89Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.48,378.89h0c-1,.26-2,.6-2.89.9a29,29,0,0,1-3.1,1h0a5.24,5.24,0,0,1-1.48.14,3.16,3.16,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.28l.31-.19a6.16,6.16,0,0,1,.81-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a11.88,11.88,0,0,0-6.84-.25,14.32,14.32,0,0,0-2.17.75L40.32,374l-3,1.72,2.47,1.43,0,0c-2.51,1.91-2.56,3.88.26,5.51a8.71,8.71,0,0,0,4.13,1.19h0c.27,0,.55,0,.82,0a16.71,16.71,0,0,0,4.43-1c2.87-1,5.19-2.09,7.12-1,1.29.74.93,1.68-.49,2.5a7.46,7.46,0,0,1-.69.35,6.37,6.37,0,0,1-5,0l-2.63,2.63a12.28,12.28,0,0,0,9.65-.41l2.47,1.42,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l-.05,0A10,10,0,0,0,52.48,378.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "37.33 375.75 40.35 374.39 42.82 375.47 40.32 374.03 37.33 375.75",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.65,374.81a14.11,14.11,0,0,1,6.41.22l-1.73,2.46,2.5-2.52A12,12,0,0,0,44.65,374.81Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.22,379.6l.05,0c2.9,1.7,2.61,3.79.13,5.71,2.2-2.4,1.8-4.07-.59-5.45a11.32,11.32,0,0,0-7.33-1A10,10,0,0,1,60.22,379.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.4 385.34 62.29 386.8 59.88 388.49 62.87 386.77 60.4 385.34",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.36,384.82a6.43,6.43,0,0,1-4.76.41l-2.84,2.25,2.63-2.63A6.37,6.37,0,0,0,55.36,384.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47,380.75a3.86,3.86,0,0,1-3.58-.34c-.86-.74-.31-1.53,1-2.22-1.4.91-1.26,1.72-.3,2.28a3.16,3.16,0,0,0,1.42.42A5.24,5.24,0,0,0,46.47,380.75Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78,377.2c-.21.19-2,1.86-1.21,3.54s3.47,2.93,5.6,3.16h0A8.71,8.71,0,0,1,40,382.71C37.22,381.08,37.27,379.11,39.78,377.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4,372.3a18.92,18.92,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51H15v6h0c.22,4.19,3.08,8.34,8.62,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4,372.3a18.92,18.92,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51H15v6h0c.22,4.19,3.08,8.34,8.62,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,360.8c-7.54,0-15.09,1.66-20.84,5a19,19,0,0,0-7,6.51H15v6h0c.22,4.19,3.08,8.34,8.62,11.53,5.75,3.33,13.3,5,20.84,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.42,363.57a31.72,31.72,0,0,0-4.74,2.22,19,19,0,0,0-7,6.51H15v6h0c.22,4.19,3.08,8.34,8.62,11.53a32.78,32.78,0,0,0,4.74,2.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.62,363.57a32.2,32.2,0,0,1,4.74,2.22,18.92,18.92,0,0,1,7,6.51H74v6h0c-.21,4.19-3.1,8.34-8.63,11.53a33.29,33.29,0,0,1-4.74,2.23Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.68,360.27c-11.52,6.64-11.51,17.42,0,24.06,10.07,5.82,25.61,6.55,37.05,2.19h0l.45-.17a32.12,32.12,0,0,0,4.17-2c9.6-5.54,11.19-13.95,4.78-20.45h0a22.56,22.56,0,0,0-4.78-3.61C53.85,353.62,35.19,353.62,23.68,360.27Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.68,360.27c-11.52,6.64-11.51,17.42,0,24.06,10.07,5.82,25.61,6.55,37.05,2.19h0l.45-.17a32.12,32.12,0,0,0,4.17-2c9.6-5.54,11.19-13.95,4.78-20.45h0a22.56,22.56,0,0,0-4.78-3.61C53.85,353.62,35.19,353.62,23.68,360.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.14,363.88a12.86,12.86,0,0,1,3.08,10.5c-1,5.85-9.2,10.77-12,12a32.12,32.12,0,0,0,4.17-2C75,378.79,76.55,370.38,70.14,363.88Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.89,380.72a12.9,12.9,0,0,1-3.08-10.5c1-5.85,9.21-10.77,12-12a30.71,30.71,0,0,0-4.16,2C14.08,365.81,12.48,374.22,18.89,380.72Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.53,
    cy: 372.28,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.53,
    cy: 372.28,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,377c2.21-4.07,1.49-8.56-2.15-12.36a18,18,0,0,0-2.32-2A25.86,25.86,0,0,0,64,361.14c-.43-.25-.88-.5-1.35-.73,1.14,1.87.72,3.88-5.73,4.26-12.63.74,3.38,12.81,3.38,12.81S68.43,373.55,70.68,377Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,373.66c1.9-.21,2.83-2.16,2.1-4.35s-2.87-3.8-4.77-3.58-2.83,2.16-2.09,4.35S67.49,373.88,69.38,373.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.41,383.72c-.63-4.69-21.13-17.67-21.13-17.67s-4.54-1.83-3-5a24.47,24.47,0,0,0-2.2,1.41c-.47.35-.91.7-1.33,1.06-6.1,5.28-6.11,12.23,0,17.52q.61.54,1.32,1a22.4,22.4,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14.6.28,1.22.55,1.85.8s1.26.48,1.92.69a40.06,40.06,0,0,0,6.11,1.47l1.38.2a46,46,0,0,0,6.12.38,46.5,46.5,0,0,0,7.48-.61S48.82,386.81,49.41,383.72Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.41,383.72c-.63-4.69-21.13-17.67-21.13-17.67s-4.54-1.83-3-5a24.47,24.47,0,0,0-2.2,1.41c-.47.35-.91.7-1.33,1.06-6.1,5.28-6.11,12.23,0,17.52q.61.54,1.32,1a22.4,22.4,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14.6.28,1.22.55,1.85.8s1.26.48,1.92.69a40.06,40.06,0,0,0,6.11,1.47l1.38.2a46,46,0,0,0,6.12.38,46.5,46.5,0,0,0,7.48-.61S48.82,386.81,49.41,383.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.08,363.94c-7.64,4.42-7.95,11.46-.93,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.67l-1-.54C49.93,359.35,37.73,359.53,30.08,363.94Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.08,363.94c-7.64,4.42-7.95,11.46-.93,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.67l-1-.54C49.93,359.35,37.73,359.53,30.08,363.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.53,
    cy: 372.28,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.53,
    cy: 372.28,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.73,367.45c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.06,5.52,6.4-.57,2.34-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-4.95-4.05-5.52-6.39C25.78,371.51,27.62,369.25,30.73,367.45Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.73,367.45c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.06,5.52,6.4-.57,2.34-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-4.95-4.05-5.52-6.39C25.78,371.51,27.62,369.25,30.73,367.45Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.82,375.67c0-.38,0-1.93,0-2.33,0-.95-.66-1.88-2.09-2.71l0,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.59-2.89.9a29,29,0,0,1-3.1,1h0a5.14,5.14,0,0,1-1.47.14,3.07,3.07,0,0,1-1.22-.32l.1-.07.3-.19a9,9,0,0,1,.82-.41,5.64,5.64,0,0,1,4.34-.09l2.5-2.53V366a11.8,11.8,0,0,0-6.84-.25,14,14,0,0,0-2.17.75L34.78,365l-3,1.72v2.32l1,.59a2.48,2.48,0,0,0-.44,1.35c0,.38,0,1.92,0,2.31,0,1,.68,1.88,2.12,2.71a8.79,8.79,0,0,0,4.12,1.19h0a7.48,7.48,0,0,0,.82,0,16,16,0,0,0,4.43-1l.86-.29-2.52,2.52v2.32a12.28,12.28,0,0,0,9.65-.42l2.47,1.43,3-1.73v-2.31l-1-.59A2.79,2.79,0,0,0,56.82,375.67Zm-6.3-.2a7.46,7.46,0,0,1-.69.35,6.47,6.47,0,0,1-4.89.07c2.34-.82,4.29-1.55,6-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,369.89h0c-1,.26-2,.59-2.89.9a29,29,0,0,1-3.1,1h0a5.14,5.14,0,0,1-1.47.14,3.16,3.16,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.29l.3-.19a8.79,8.79,0,0,1,.82-.4,5.69,5.69,0,0,1,4.34-.1L46.3,366a11.8,11.8,0,0,0-6.84-.25,14,14,0,0,0-2.17.75L34.78,365l-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.68,8.68,0,0,0,4.12,1.19h0c.27,0,.55,0,.82,0a16.71,16.71,0,0,0,4.43-1c2.86-1,5.18-2.09,7.11-1,1.3.74.94,1.68-.48,2.5a7.46,7.46,0,0,1-.69.35,6.4,6.4,0,0,1-5,0l-2.62,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.14-5.71l0,0A10,10,0,0,0,47,369.89Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,369.89h0c-1,.26-2,.59-2.89.9a29,29,0,0,1-3.1,1h0a5.14,5.14,0,0,1-1.47.14,3.16,3.16,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.29l.3-.19a8.79,8.79,0,0,1,.82-.4,5.69,5.69,0,0,1,4.34-.1L46.3,366a11.8,11.8,0,0,0-6.84-.25,14,14,0,0,0-2.17.75L34.78,365l-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.68,8.68,0,0,0,4.12,1.19h0c.27,0,.55,0,.82,0a16.71,16.71,0,0,0,4.43-1c2.86-1,5.18-2.09,7.11-1,1.3.74.94,1.68-.48,2.5a7.46,7.46,0,0,1-.69.35,6.4,6.4,0,0,1-5,0l-2.62,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.14-5.71l0,0A10,10,0,0,0,47,369.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.8 366.75 34.81 365.38 37.29 366.47 34.78 365.03 31.8 366.75",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.11,365.81a14,14,0,0,1,6.42.22l-1.73,2.46L46.3,366A12,12,0,0,0,39.11,365.81Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.69,370.6l0,0c2.91,1.7,2.62,3.79.14,5.71,2.2-2.4,1.8-4.07-.59-5.45a11.27,11.27,0,0,0-7.33-1A10,10,0,0,1,54.69,370.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.87 376.34 56.76 377.8 54.35 379.49 57.34 377.77 54.87 376.34",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,375.82a6.43,6.43,0,0,1-4.76.41l-2.84,2.25,2.62-2.63A6.4,6.4,0,0,0,49.83,375.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.93,371.75a3.87,3.87,0,0,1-3.57-.34c-.87-.74-.31-1.54,1-2.23-1.4.92-1.26,1.73-.3,2.29a3.16,3.16,0,0,0,1.42.42A5.14,5.14,0,0,0,40.93,371.75Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25,368.2c-.21.19-2,1.86-1.22,3.53s3.48,2.94,5.61,3.17h0a8.68,8.68,0,0,1-4.12-1.19C31.69,372.08,31.74,370.1,34.25,368.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.92,362.9a18.92,18.92,0,0,1,7-6.51c11.51-6.65,30.18-6.65,41.69,0a19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53-11.51,6.65-30.18,6.65-41.69,0-5.53-3.19-8.42-7.34-8.63-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92,362.9a18.92,18.92,0,0,1,7-6.51c11.51-6.65,30.18-6.65,41.69,0a19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53-11.51,6.65-30.18,6.65-41.69,0-5.53-3.19-8.42-7.34-8.63-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,351.4c7.55,0,15.09,1.66,20.85,5a19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53-5.76,3.33-13.3,5-20.85,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9,354.17a32.32,32.32,0,0,1,4.75,2.22,19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53a33.41,33.41,0,0,1-4.75,2.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.71,354.17A31.84,31.84,0,0,0,26,356.39a18.92,18.92,0,0,0-7,6.51H17.33v6h0c.21,4.19,3.1,8.34,8.63,11.53a32.9,32.9,0,0,0,4.75,2.23Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.65,350.87c11.51,6.64,11.51,17.42,0,24.06-10.08,5.82-25.62,6.55-37.06,2.19h0l-.46-.17a30.88,30.88,0,0,1-4.17-2c-9.6-5.54-11.19-13.95-4.78-20.45h0A22.56,22.56,0,0,1,26,350.87C37.47,344.22,56.14,344.22,67.65,350.87Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.65,350.87c11.51,6.64,11.51,17.42,0,24.06-10.08,5.82-25.62,6.55-37.06,2.19h0l-.46-.17a30.88,30.88,0,0,1-4.17-2c-9.6-5.54-11.19-13.95-4.78-20.45h0A22.56,22.56,0,0,1,26,350.87C37.47,344.22,56.14,344.22,67.65,350.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.18,354.48A12.9,12.9,0,0,0,18.1,365c1,5.85,9.21,10.77,12,12a30.88,30.88,0,0,1-4.17-2C16.36,369.39,14.77,361,21.18,354.48Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.43,371.32a12.9,12.9,0,0,0,3.08-10.5c-1-5.85-9.21-10.77-12-11.95a32.72,32.72,0,0,1,4.17,2C77.24,356.41,78.84,364.82,72.43,371.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.82,
    cy: 362.88,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.82,
    cy: 362.88,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.66,367.6c-2.2-4.07-1.48-8.56,2.15-12.36a18,18,0,0,1,2.32-2,25.86,25.86,0,0,1,2.22-1.46c.44-.25.89-.5,1.35-.73-1.14,1.88-.72,3.88,5.73,4.26,12.63.74-3.37,12.81-3.37,12.81S22.92,364.15,20.66,367.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,364.26c-1.89-.21-2.83-2.16-2.1-4.35s2.87-3.8,4.77-3.58,2.83,2.16,2.1,4.35S23.86,364.48,22,364.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.94,374.32c.62-4.69,21.12-17.67,21.12-17.67s4.54-1.82,3-5a22.32,22.32,0,0,1,2.19,1.42c.47.34.92.69,1.33,1.05,6.1,5.28,6.11,12.23,0,17.52-.41.36-.86.71-1.33,1.05a23.67,23.67,0,0,1-2,1.32c-.7.41-1.43.79-2.18,1.14-.59.29-1.21.55-1.84.8s-1.27.48-1.93.69a39.78,39.78,0,0,1-6.11,1.47l-1.38.2a47.53,47.53,0,0,1-13.59-.23S42.52,377.41,41.94,374.32Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.94,374.32c.62-4.69,21.12-17.67,21.12-17.67s4.54-1.82,3-5a22.32,22.32,0,0,1,2.19,1.42c.47.34.92.69,1.33,1.05,6.1,5.28,6.11,12.23,0,17.52-.41.36-.86.71-1.33,1.05a23.67,23.67,0,0,1-2,1.32c-.7.41-1.43.79-2.18,1.14-.59.29-1.21.55-1.84.8s-1.27.48-1.93.69a39.78,39.78,0,0,1-6.11,1.47l-1.38.2a47.53,47.53,0,0,1-13.59-.23S42.52,377.41,41.94,374.32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,354.54c7.65,4.42,8,11.46.93,16.09-.3.2-.61.39-.93.58-8,4.6-20.9,4.6-28.87,0s-8-12.06,0-16.67l1-.54C41.41,350,53.61,350.13,61.26,354.54Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,354.54c7.65,4.42,8,11.46.93,16.09-.3.2-.61.39-.93.58-8,4.6-20.9,4.6-28.87,0s-8-12.06,0-16.67l1-.54C41.41,350,53.61,350.13,61.26,354.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.81,
    cy: 362.88,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.81,
    cy: 362.88,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61,358.05c-7.62-4.4-20-4.4-27.59,0-3.12,1.8-5,4.06-5.53,6.4.57,2.34,2.41,4.59,5.53,6.39,7.62,4.4,20,4.4,27.59,0,3.12-1.8,5-4,5.52-6.39C65.57,362.11,63.73,359.85,60.61,358.05Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61,358.05c-7.62-4.4-20-4.4-27.59,0-3.12,1.8-5,4.06-5.53,6.4.57,2.34,2.41,4.59,5.53,6.39,7.62,4.4,20,4.4,27.59,0,3.12-1.8,5-4,5.52-6.39C65.57,362.11,63.73,359.85,60.61,358.05Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,366.27c0-.38,0-1.93,0-2.33,0-.95-.66-1.88-2.08-2.71l-.05,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.59-2.89.9a27.7,27.7,0,0,1-3.1,1h0a5.17,5.17,0,0,1-1.47.14,3,3,0,0,1-1.22-.32l.09-.07.31-.19a5.63,5.63,0,0,1,.82-.4,5.58,5.58,0,0,1,4.33-.1l2.51-2.53v-2.31a11.81,11.81,0,0,0-6.84-.25,14.06,14.06,0,0,0-2.18.75l-2.5-1.44-3,1.72v2.32l1,.59a2.4,2.4,0,0,0-.44,1.35v2.31c0,1,.69,1.88,2.13,2.71a8.76,8.76,0,0,0,4.12,1.19h0a7.66,7.66,0,0,0,.83,0,16.25,16.25,0,0,0,4.42-.95l.87-.3-2.52,2.52v2.32a12.29,12.29,0,0,0,9.65-.42l2.47,1.43,3-1.73v-2.31l-1-.59A2.77,2.77,0,0,0,59.1,366.27Zm-6.29-.2a7.61,7.61,0,0,1-.7.35,6.39,6.39,0,0,1-4.88.07c2.34-.82,4.29-1.55,6-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,360.49h0c-1,.26-2,.59-2.89.9a27.7,27.7,0,0,1-3.1,1h0a5.17,5.17,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.56-1.1-1.37.29-2.29l.31-.18a6.07,6.07,0,0,1,5.15-.51l2.51-2.52a11.81,11.81,0,0,0-6.84-.25,14.06,14.06,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.48,1.43,0,0c-2.51,1.9-2.56,3.88.27,5.51a8.64,8.64,0,0,0,4.12,1.19h.83a16.64,16.64,0,0,0,4.42-1c2.87-1,5.19-2.09,7.12-1,1.29.74.93,1.68-.48,2.5a7.61,7.61,0,0,1-.7.35,6.37,6.37,0,0,1-5,0l-2.62,2.63a12.29,12.29,0,0,0,9.65-.41l2.47,1.42,3-1.72-2.47-1.43c2.49-1.92,2.77-4-.13-5.71l-.05,0A10,10,0,0,0,49.23,360.49Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.23,360.49h0c-1,.26-2,.59-2.89.9a27.7,27.7,0,0,1-3.1,1h0a5.17,5.17,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.56-1.1-1.37.29-2.29l.31-.18a6.07,6.07,0,0,1,5.15-.51l2.51-2.52a11.81,11.81,0,0,0-6.84-.25,14.06,14.06,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.48,1.43,0,0c-2.51,1.9-2.56,3.88.27,5.51a8.64,8.64,0,0,0,4.12,1.19h.83a16.64,16.64,0,0,0,4.42-1c2.87-1,5.19-2.09,7.12-1,1.29.74.93,1.68-.48,2.5a7.61,7.61,0,0,1-.7.35,6.37,6.37,0,0,1-5,0l-2.62,2.63a12.29,12.29,0,0,0,9.65-.41l2.47,1.42,3-1.72-2.47-1.43c2.49-1.92,2.77-4-.13-5.71l-.05,0A10,10,0,0,0,49.23,360.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.09 357.35 37.1 355.99 39.57 357.07 37.07 355.63 34.09 357.35",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,356.41a14,14,0,0,1,6.42.22l-1.74,2.46,2.51-2.52A12,12,0,0,0,41.4,356.41Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,361.2l.05,0c2.9,1.7,2.62,3.79.13,5.71,2.2-2.4,1.8-4.07-.59-5.45a11.26,11.26,0,0,0-7.33-1A10,10,0,0,1,57,361.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.15 366.94 59.05 368.4 56.64 370.09 59.62 368.37 57.15 366.94",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,366.42a6.43,6.43,0,0,1-4.76.41l-2.83,2.25,2.62-2.63A6.37,6.37,0,0,0,52.11,366.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.22,362.35a3.89,3.89,0,0,1-3.58-.34c-.86-.74-.31-1.54,1-2.23-1.39.92-1.25,1.73-.29,2.29a3.12,3.12,0,0,0,1.42.42A5.17,5.17,0,0,0,43.22,362.35Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.53,358.8c-.21.19-2,1.86-1.21,3.54s3.48,2.93,5.6,3.16h0a8.64,8.64,0,0,1-4.12-1.19C34,362.68,34,360.7,36.53,358.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.51,353a19.08,19.08,0,0,0-7-6.51c-11.52-6.64-30.18-6.64-41.69,0a19,19,0,0,0-7,6.51H22.15v6h0c.21,4.18,3.08,8.33,8.61,11.53,11.51,6.64,30.17,6.64,41.69,0,5.53-3.2,8.42-7.35,8.63-11.54h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.51,353a19.08,19.08,0,0,0-7-6.51c-11.52-6.64-30.18-6.64-41.69,0a19,19,0,0,0-7,6.51H22.15v6h0c.21,4.18,3.08,8.33,8.61,11.53,11.51,6.64,30.17,6.64,41.69,0,5.53-3.2,8.42-7.35,8.63-11.54h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.63,341.53c-7.55,0-15.09,1.66-20.85,5a19,19,0,0,0-7,6.51H22.15v6h0c.21,4.18,3.08,8.33,8.61,11.53,5.76,3.32,13.3,5,20.85,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53,344.29a31.84,31.84,0,0,0-4.75,2.22,19,19,0,0,0-7,6.51H22.15v6h0c.21,4.18,3.08,8.33,8.61,11.53a31.84,31.84,0,0,0,4.75,2.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,344.29a32.32,32.32,0,0,1,4.75,2.22,19.08,19.08,0,0,1,7,6.51H81.1v6h0c-.21,4.19-3.1,8.34-8.63,11.54a32.32,32.32,0,0,1-4.75,2.22Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,341c-11.51,6.65-11.51,17.42,0,24.07,10.07,5.81,25.62,6.54,37.06,2.18h0l.46-.18a32.72,32.72,0,0,0,4.17-2c9.59-5.54,11.19-14,4.78-20.45h0A22.56,22.56,0,0,0,72.47,341C61,334.35,42.29,334.35,30.78,341Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,341c-11.51,6.65-11.51,17.42,0,24.07,10.07,5.81,25.62,6.54,37.06,2.18h0l.46-.18a32.72,32.72,0,0,0,4.17-2c9.59-5.54,11.19-14,4.78-20.45h0A22.56,22.56,0,0,0,72.47,341C61,334.35,42.29,334.35,30.78,341Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.25,344.61a12.9,12.9,0,0,1,3.08,10.5c-1,5.85-9.21,10.77-12,11.95a32.72,32.72,0,0,0,4.17-2C82.06,359.52,83.66,351.1,77.25,344.61Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,361.44a12.88,12.88,0,0,1-3.08-10.5c1-5.84,9.21-10.77,12-11.95a32.08,32.08,0,0,0-4.17,2C21.18,346.53,19.59,355,26,361.44Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 353,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 353,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,357.73c2.2-4.07,1.48-8.56-2.15-12.37a18.72,18.72,0,0,0-2.32-2,21.86,21.86,0,0,0-2.22-1.46c-.44-.26-.89-.5-1.35-.73,1.14,1.87.72,3.88-5.73,4.25-12.63.74,3.37,12.81,3.37,12.81S75.53,354.27,77.79,357.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.49,354.39c1.89-.21,2.83-2.16,2.09-4.35s-2.87-3.8-4.76-3.59-2.84,2.16-2.1,4.35S74.59,354.6,76.49,354.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,364.45c-.62-4.69-21.12-17.68-21.12-17.68s-4.55-1.82-3-5a23,23,0,0,0-2.19,1.42c-.47.34-.92.69-1.33,1.05-6.1,5.29-6.11,12.23,0,17.52.41.36.86.71,1.33,1.06.63.45,1.3.9,2,1.32s1.43.78,2.18,1.14c.59.28,1.21.55,1.84.79s1.27.48,1.92.7a41.41,41.41,0,0,0,6.12,1.47l1.38.19a47.73,47.73,0,0,0,6.11.39,46.41,46.41,0,0,0,7.48-.62S55.92,367.53,56.51,364.45Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.51,364.45c-.62-4.69-21.12-17.68-21.12-17.68s-4.55-1.82-3-5a23,23,0,0,0-2.19,1.42c-.47.34-.92.69-1.33,1.05-6.1,5.29-6.11,12.23,0,17.52.41.36.86.71,1.33,1.06.63.45,1.3.9,2,1.32s1.43.78,2.18,1.14c.59.28,1.21.55,1.84.79s1.27.48,1.92.7a41.41,41.41,0,0,0,6.12,1.47l1.38.19a47.73,47.73,0,0,0,6.11.39,46.41,46.41,0,0,0,7.48-.62S55.92,367.53,56.51,364.45Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.19,344.67c-7.65,4.41-8,11.46-.93,16.09.3.19.61.39.93.57,8,4.61,20.9,4.61,28.87,0s8-12.07,0-16.67c-.32-.19-.66-.37-1-.54C57,340.07,44.84,340.25,37.19,344.67Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.19,344.67c-7.65,4.41-8,11.46-.93,16.09.3.19.61.39.93.57,8,4.61,20.9,4.61,28.87,0s8-12.07,0-16.67c-.32-.19-.66-.37-1-.54C57,340.07,44.84,340.25,37.19,344.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84,345c-7.62,4.4-7.62,11.53,0,15.93s20,4.4,27.59,0,7.62-11.53,0-15.93S45.46,340.64,37.84,345Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84,345c-7.62,4.4-7.62,11.53,0,15.93s20,4.4,27.59,0,7.62-11.53,0-15.93S45.46,340.64,37.84,345Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84,348.18c7.62-4.4,20-4.4,27.59,0,3.12,1.8,5,4.05,5.53,6.39-.57,2.34-2.41,4.6-5.53,6.4-7.62,4.4-20,4.4-27.59,0-3.12-1.8-5-4.06-5.53-6.4C32.88,352.23,34.72,350,37.84,348.18Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84,348.18c7.62-4.4,20-4.4,27.59,0,3.12,1.8,5,4.05,5.53,6.39-.57,2.34-2.41,4.6-5.53,6.4-7.62,4.4-20,4.4-27.59,0-3.12-1.8-5-4.06-5.53-6.4C32.88,352.23,34.72,350,37.84,348.18Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92,356.39c0-.38,0-1.93,0-2.32,0-1-.66-1.89-2.08-2.72l-.05,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.59-2.89.89a26.31,26.31,0,0,1-3.1,1h0a6,6,0,0,1-1.47.14,3.16,3.16,0,0,1-1.22-.33l.09-.07.31-.18a6.07,6.07,0,0,1,5.15-.51L53.41,349v-2.32a12,12,0,0,0-6.84-.25,14.12,14.12,0,0,0-2.18.76l-2.5-1.45-3,1.73v2.31l1,.59a2.45,2.45,0,0,0-.44,1.35V354c0,1,.69,1.88,2.13,2.71a8.64,8.64,0,0,0,4.12,1.19h.83A16.64,16.64,0,0,0,51,357l.87-.3-2.52,2.53v2.31a12.29,12.29,0,0,0,9.65-.41l2.47,1.42,3-1.72v-2.32l-1-.59A2.74,2.74,0,0,0,63.92,356.39Zm-6.29-.19a7.48,7.48,0,0,1-.7.34,6.39,6.39,0,0,1-4.88.07c2.34-.82,4.29-1.54,6-.66A3.41,3.41,0,0,1,57.63,356.2Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.05,350.61h0c-1,.26-2,.59-2.89.89a26.31,26.31,0,0,1-3.1,1h0a6,6,0,0,1-1.47.14,3.13,3.13,0,0,1-1.42-.43c-1-.55-1.1-1.37.29-2.28l.31-.19a7,7,0,0,1,.82-.41,5.62,5.62,0,0,1,4.33-.09l2.51-2.53a12,12,0,0,0-6.84-.25,14.12,14.12,0,0,0-2.18.76l-2.5-1.45-3,1.73,2.48,1.42,0,0c-2.5,1.91-2.56,3.89.27,5.52a8.63,8.63,0,0,0,4.12,1.18h.83a15.89,15.89,0,0,0,4.42-1c2.87-1,5.19-2.08,7.12-1,1.29.75.93,1.69-.48,2.51a7.48,7.48,0,0,1-.7.34,6.42,6.42,0,0,1-5,0l-2.62,2.63a12.29,12.29,0,0,0,9.65-.42l2.47,1.43,3-1.73L62,357.07c2.48-1.93,2.77-4-.13-5.72l-.05,0A10,10,0,0,0,54.05,350.61Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.05,350.61h0c-1,.26-2,.59-2.89.89a26.31,26.31,0,0,1-3.1,1h0a6,6,0,0,1-1.47.14,3.13,3.13,0,0,1-1.42-.43c-1-.55-1.1-1.37.29-2.28l.31-.19a7,7,0,0,1,.82-.41,5.62,5.62,0,0,1,4.33-.09l2.51-2.53a12,12,0,0,0-6.84-.25,14.12,14.12,0,0,0-2.18.76l-2.5-1.45-3,1.73,2.48,1.42,0,0c-2.5,1.91-2.56,3.89.27,5.52a8.63,8.63,0,0,0,4.12,1.18h.83a15.89,15.89,0,0,0,4.42-1c2.87-1,5.19-2.08,7.12-1,1.29.75.93,1.69-.48,2.51a7.48,7.48,0,0,1-.7.34,6.42,6.42,0,0,1-5,0l-2.62,2.63a12.29,12.29,0,0,0,9.65-.42l2.47,1.43,3-1.73L62,357.07c2.48-1.93,2.77-4-.13-5.72l-.05,0A10,10,0,0,0,54.05,350.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "38.91 347.48 41.92 346.11 44.39 347.2 41.89 345.75 38.91 347.48",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,346.54a14,14,0,0,1,6.42.21l-1.74,2.47,2.51-2.53A11.9,11.9,0,0,0,46.22,346.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,351.32l.05,0c2.9,1.7,2.61,3.79.13,5.72,2.2-2.4,1.8-4.07-.59-5.45a11.27,11.27,0,0,0-7.33-1A10,10,0,0,1,61.79,351.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.97 357.07 63.87 358.52 61.46 360.22 64.44 358.49 61.97 357.07",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,356.54a6.41,6.41,0,0,1-4.76.42l-2.83,2.25L52,356.58A6.42,6.42,0,0,0,56.93,356.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,352.48a3.92,3.92,0,0,1-3.58-.34c-.86-.75-.31-1.54,1-2.23-1.39.91-1.25,1.73-.29,2.28a3.13,3.13,0,0,0,1.42.43A6,6,0,0,0,48,352.48Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.35,348.92c-.21.19-2,1.86-1.21,3.54s3.48,2.93,5.6,3.16h0a8.63,8.63,0,0,1-4.12-1.18C38.79,352.81,38.85,350.83,41.35,348.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1,344a19,19,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51h-1.6v6h0c.21,4.19,3.07,8.34,8.61,11.54,11.51,6.64,30.17,6.64,41.68,0,5.54-3.2,8.42-7.35,8.63-11.54h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1,344a19,19,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51h-1.6v6h0c.21,4.19,3.07,8.34,8.61,11.54,11.51,6.64,30.17,6.64,41.68,0,5.54-3.2,8.42-7.35,8.63-11.54h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.22,332.53c-7.54,0-15.09,1.66-20.84,5a19,19,0,0,0-7,6.51h-1.6v6h0c.22,4.19,3.08,8.34,8.62,11.54,5.75,3.32,13.3,5,20.84,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,335.29a31.72,31.72,0,0,0-4.74,2.22,19,19,0,0,0-7,6.51h-1.6v6h0c.22,4.19,3.08,8.34,8.62,11.54a31.72,31.72,0,0,0,4.74,2.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.32,335.29a31.72,31.72,0,0,1,4.74,2.22,19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.09,8.34-8.63,11.54a31.72,31.72,0,0,1-4.74,2.22Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.38,332c-11.51,6.65-11.51,17.42,0,24.07,10.07,5.81,25.62,6.54,37.06,2.18h0l.45-.18a31.47,31.47,0,0,0,4.17-2c9.6-5.54,11.2-14,4.78-20.45h0A22.31,22.31,0,0,0,69.06,332C57.55,325.35,38.89,325.34,27.38,332Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.38,332c-11.51,6.65-11.51,17.42,0,24.07,10.07,5.81,25.62,6.54,37.06,2.18h0l.45-.18a31.47,31.47,0,0,0,4.17-2c9.6-5.54,11.2-14,4.78-20.45h0A22.31,22.31,0,0,0,69.06,332C57.55,325.35,38.89,325.34,27.38,332Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.84,335.61a12.87,12.87,0,0,1,3.09,10.5c-1,5.84-9.21,10.77-12,11.95a31.47,31.47,0,0,0,4.17-2C78.66,350.52,80.26,342.1,73.84,335.61Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6,352.44a12.87,12.87,0,0,1-3.09-10.5c1-5.85,9.21-10.77,12-11.95a32,32,0,0,0-4.16,2C17.78,337.53,16.18,346,22.6,352.44Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,355.19c10.7-6.18,10.7-16.2,0-22.38s-28-6.17-38.75,0-10.7,16.2,0,22.38S56.9,361.36,67.6,355.19Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,355.19c10.7-6.18,10.7-16.2,0-22.38s-28-6.17-38.75,0-10.7,16.2,0,22.38S56.9,361.36,67.6,355.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,348.73c2.2-4.08,1.48-8.56-2.16-12.37a18,18,0,0,0-2.32-2,20.8,20.8,0,0,0-2.22-1.46c-.43-.26-.88-.5-1.34-.74,1.13,1.88.72,3.89-5.74,4.26C48,337.13,64,349.2,64,349.2S72.13,345.27,74.39,348.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.08,345.39c1.9-.22,2.84-2.16,2.1-4.36s-2.87-3.79-4.77-3.58-2.83,2.16-2.09,4.35S71.19,345.6,73.08,345.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,355.44C52.49,350.76,32,337.77,32,337.77s-4.55-1.82-3-5a23,23,0,0,0-2.19,1.42c-.48.34-.92.69-1.34,1.05-6.1,5.29-6.11,12.23,0,17.52.41.36.86.71,1.33,1.06.63.45,1.3.89,2,1.32s1.42.78,2.17,1.14c.6.28,1.22.54,1.85.79s1.27.48,1.92.69a39.9,39.9,0,0,0,6.12,1.47c.45.08.91.14,1.37.2a47.89,47.89,0,0,0,6.12.39,46.41,46.41,0,0,0,7.48-.62S52.52,358.53,53.11,355.44Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,355.44C52.49,350.76,32,337.77,32,337.77s-4.55-1.82-3-5a23,23,0,0,0-2.19,1.42c-.48.34-.92.69-1.34,1.05-6.1,5.29-6.11,12.23,0,17.52.41.36.86.71,1.33,1.06.63.45,1.3.89,2,1.32s1.42.78,2.17,1.14c.6.28,1.22.54,1.85.79s1.27.48,1.92.69a39.9,39.9,0,0,0,6.12,1.47c.45.08.91.14,1.37.2a47.89,47.89,0,0,0,6.12.39,46.41,46.41,0,0,0,7.48-.62S52.52,358.53,53.11,355.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.79,335.67c-7.65,4.41-8,11.45-.94,16.09.3.19.61.39.94.57,8,4.61,20.89,4.61,28.86,0s8-12.06,0-16.66c-.33-.19-.67-.37-1-.54C53.64,331.07,41.43,331.25,33.79,335.67Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.79,335.67c-7.65,4.41-8,11.45-.94,16.09.3.19.61.39.94.57,8,4.61,20.89,4.61,28.86,0s8-12.06,0-16.66c-.33-.19-.67-.37-1-.54C53.64,331.07,41.43,331.25,33.79,335.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.23,
    cy: 344,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.23,
    cy: 344,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,339.18c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.05,5.52,6.39-.57,2.34-2.41,4.6-5.52,6.4-7.62,4.39-20,4.39-27.6,0-3.11-1.8-4.95-4.06-5.52-6.4C29.48,343.23,31.32,341,34.43,339.18Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,339.18c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.05,5.52,6.39-.57,2.34-2.41,4.6-5.52,6.4-7.62,4.39-20,4.39-27.6,0-3.11-1.8-4.95-4.06-5.52-6.4C29.48,343.23,31.32,341,34.43,339.18Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,347.39v-2.33c0-.95-.66-1.88-2.08-2.71l0,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.6-2.89.9a26.9,26.9,0,0,1-3.1,1h0a5.24,5.24,0,0,1-1.48.14,3.07,3.07,0,0,1-1.22-.32l.1-.07.31-.19a7.59,7.59,0,0,1,.81-.4,5.69,5.69,0,0,1,4.34-.1L50,340v-2.32a12,12,0,0,0-6.84-.25,15.51,15.51,0,0,0-2.17.75l-2.5-1.44-3,1.72v2.32l1,.59a2.51,2.51,0,0,0-.44,1.35c0,.39,0,1.92,0,2.31,0,1,.68,1.88,2.12,2.71a8.79,8.79,0,0,0,4.12,1.19h0a7.48,7.48,0,0,0,.82,0,16.32,16.32,0,0,0,4.43-.95l.86-.3-2.52,2.53v2.31a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72v-2.32l-1-.59A2.68,2.68,0,0,0,60.52,347.39Zm-6.3-.2a5.6,5.6,0,0,1-.69.35,6.39,6.39,0,0,1-4.88.07c2.33-.82,4.29-1.54,6-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.65,341.61h0c-1,.26-2,.6-2.89.9a26.9,26.9,0,0,1-3.1,1h0a5.24,5.24,0,0,1-1.48.14,3.16,3.16,0,0,1-1.42-.42c-1-.55-1.1-1.37.3-2.28a2.32,2.32,0,0,1,.31-.19,7.7,7.7,0,0,1,.81-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a12,12,0,0,0-6.84-.25,15.51,15.51,0,0,0-2.17.75l-2.5-1.44-3,1.72L38,339.9s0,0,0,0c-2.51,1.91-2.56,3.89.26,5.52a8.77,8.77,0,0,0,4.12,1.18h.83a16.33,16.33,0,0,0,4.43-1c2.87-1,5.19-2.08,7.12-1,1.29.75.93,1.68-.49,2.5a5.6,5.6,0,0,1-.69.35,6.42,6.42,0,0,1-5,0l-2.63,2.63a12.32,12.32,0,0,0,9.65-.42l2.47,1.42,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,50.65,341.61Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.65,341.61h0c-1,.26-2,.6-2.89.9a26.9,26.9,0,0,1-3.1,1h0a5.24,5.24,0,0,1-1.48.14,3.16,3.16,0,0,1-1.42-.42c-1-.55-1.1-1.37.3-2.28a2.32,2.32,0,0,1,.31-.19,7.7,7.7,0,0,1,.81-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a12,12,0,0,0-6.84-.25,15.51,15.51,0,0,0-2.17.75l-2.5-1.44-3,1.72L38,339.9s0,0,0,0c-2.51,1.91-2.56,3.89.26,5.52a8.77,8.77,0,0,0,4.12,1.18h.83a16.33,16.33,0,0,0,4.43-1c2.87-1,5.19-2.08,7.12-1,1.29.75.93,1.68-.49,2.5a5.6,5.6,0,0,1-.69.35,6.42,6.42,0,0,1-5,0l-2.63,2.63a12.32,12.32,0,0,0,9.65-.42l2.47,1.42,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,50.65,341.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "35.5 338.47 38.52 337.11 40.99 338.19 38.49 336.75 35.5 338.47",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.82,337.54a14,14,0,0,1,6.41.21l-1.73,2.46,2.5-2.52A11.87,11.87,0,0,0,42.82,337.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39,342.32l0,0c2.9,1.7,2.61,3.79.13,5.71,2.2-2.39,1.8-4.07-.59-5.45a11.33,11.33,0,0,0-7.33-1A10,10,0,0,1,58.39,342.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.57 348.06 60.46 349.52 58.05 351.21 61.04 349.49 58.57 348.06",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,347.54a6.46,6.46,0,0,1-4.76.42l-2.84,2.25,2.63-2.63A6.42,6.42,0,0,0,53.53,347.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64,343.47a3.86,3.86,0,0,1-3.58-.34c-.86-.74-.31-1.53,1-2.22-1.4.91-1.26,1.73-.3,2.28a3.16,3.16,0,0,0,1.42.42A5.24,5.24,0,0,0,44.64,343.47Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,339.92c-.21.19-2,1.86-1.21,3.54s3.47,2.93,5.6,3.16h0a8.77,8.77,0,0,1-4.12-1.18C35.39,343.81,35.44,341.83,38,339.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.62,334.62a19.08,19.08,0,0,1,7-6.51c11.51-6.65,30.18-6.65,41.69,0a19.08,19.08,0,0,1,7,6.51H80v6h0c-.21,4.19-3.08,8.34-8.61,11.54-11.51,6.64-30.18,6.64-41.69,0-5.53-3.2-8.42-7.35-8.63-11.54h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.62,334.62a19.08,19.08,0,0,1,7-6.51c11.51-6.65,30.18-6.65,41.69,0a19.08,19.08,0,0,1,7,6.51H80v6h0c-.21,4.19-3.08,8.34-8.61,11.54-11.51,6.64-30.18,6.64-41.69,0-5.53-3.2-8.42-7.35-8.63-11.54h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,323.13c7.55,0,15.09,1.66,20.85,5a19.08,19.08,0,0,1,7,6.51H80v6h0c-.21,4.19-3.08,8.34-8.61,11.54-5.76,3.32-13.3,5-20.85,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,325.89a32.32,32.32,0,0,1,4.75,2.22,19.08,19.08,0,0,1,7,6.51H80v6h0c-.21,4.19-3.08,8.34-8.61,11.54a32.32,32.32,0,0,1-4.75,2.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.41,325.89a32.32,32.32,0,0,0-4.75,2.22,19.08,19.08,0,0,0-7,6.51H21v6h0c.21,4.19,3.1,8.34,8.63,11.54a32.32,32.32,0,0,0,4.75,2.22Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.35,322.59c11.51,6.65,11.51,17.42,0,24.07-10.07,5.81-25.62,6.54-37.06,2.18h0l-.46-.18a32.72,32.72,0,0,1-4.17-2c-9.6-5.54-11.19-14-4.78-20.45h0a22.56,22.56,0,0,1,4.78-3.61C41.17,316,59.84,316,71.35,322.59Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.35,322.59c11.51,6.65,11.51,17.42,0,24.07-10.07,5.81-25.62,6.54-37.06,2.18h0l-.46-.18a32.72,32.72,0,0,1-4.17-2c-9.6-5.54-11.19-14-4.78-20.45h0a22.56,22.56,0,0,1,4.78-3.61C41.17,316,59.84,316,71.35,322.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.88,326.21a12.88,12.88,0,0,0-3.08,10.5c1,5.84,9.21,10.77,12,12a32.72,32.72,0,0,1-4.17-2C20.06,341.12,18.47,332.7,24.88,326.21Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.13,343a12.88,12.88,0,0,0,3.08-10.5c-1-5.85-9.21-10.77-12-12a32.08,32.08,0,0,1,4.17,2C81,328.13,82.54,336.55,76.13,343Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.52,
    cy: 334.6,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.52,
    cy: 334.6,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36,339.33c-2.2-4.07-1.48-8.56,2.15-12.37a18.72,18.72,0,0,1,2.32-2,21.86,21.86,0,0,1,2.22-1.46c.44-.26.89-.5,1.35-.74-1.14,1.88-.72,3.89,5.73,4.26,12.63.74-3.37,12.81-3.37,12.81S26.62,335.87,24.36,339.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.66,336c-1.89-.22-2.83-2.16-2.09-4.36s2.87-3.79,4.76-3.58,2.84,2.16,2.1,4.35S27.56,336.2,25.66,336Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64,346.05c.62-4.69,21.12-17.68,21.12-17.68s4.55-1.82,3-5A23,23,0,0,1,72,324.79c.47.34.92.69,1.33,1,6.1,5.29,6.11,12.23,0,17.52-.41.36-.86.71-1.33,1.06-.63.45-1.3.89-2,1.32s-1.42.78-2.17,1.14-1.22.54-1.85.79-1.27.48-1.92.69a40.19,40.19,0,0,1-6.12,1.47c-.46.08-.92.14-1.38.2a47.73,47.73,0,0,1-6.11.39,46.41,46.41,0,0,1-7.48-.62S46.23,349.13,45.64,346.05Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64,346.05c.62-4.69,21.12-17.68,21.12-17.68s4.55-1.82,3-5A23,23,0,0,1,72,324.79c.47.34.92.69,1.33,1,6.1,5.29,6.11,12.23,0,17.52-.41.36-.86.71-1.33,1.06-.63.45-1.3.89-2,1.32s-1.42.78-2.17,1.14-1.22.54-1.85.79-1.27.48-1.92.69a40.19,40.19,0,0,1-6.12,1.47c-.46.08-.92.14-1.38.2a47.73,47.73,0,0,1-6.11.39,46.41,46.41,0,0,1-7.48-.62S46.23,349.13,45.64,346.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,326.27c7.65,4.41,8,11.46.93,16.09-.29.19-.61.39-.93.57-8,4.61-20.9,4.61-28.87,0s-8-12.06,0-16.66c.32-.19.66-.37,1-.54C45.11,321.67,57.31,321.85,65,326.27Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,326.27c7.65,4.41,8,11.46.93,16.09-.29.19-.61.39-.93.57-8,4.61-20.9,4.61-28.87,0s-8-12.06,0-16.66c.32-.19.66-.37,1-.54C45.11,321.67,57.31,321.85,65,326.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.52,
    cy: 334.6,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.52,
    cy: 334.6,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.31,329.78c-7.62-4.4-20-4.4-27.59,0-3.12,1.8-5,4.05-5.53,6.39.57,2.34,2.41,4.6,5.53,6.4,7.62,4.4,20,4.4,27.59,0,3.12-1.8,5-4.06,5.53-6.4C69.27,333.83,67.43,331.58,64.31,329.78Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.31,329.78c-7.62-4.4-20-4.4-27.59,0-3.12,1.8-5,4.05-5.53,6.39.57,2.34,2.41,4.6,5.53,6.4,7.62,4.4,20,4.4,27.59,0,3.12-1.8,5-4.06,5.53-6.4C69.27,333.83,67.43,331.58,64.31,329.78Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,338c0-.38,0-1.93,0-2.32,0-1-.66-1.89-2.08-2.72l0,0a10,10,0,0,0-7.74-.71h0c-1,.25-2,.59-2.88.89a26.9,26.9,0,0,1-3.1,1h0a5.17,5.17,0,0,1-1.47.14,3.07,3.07,0,0,1-1.22-.32l.09-.07.31-.19a6.89,6.89,0,0,1,.82-.4,5.69,5.69,0,0,1,4.34-.1l2.5-2.52v-2.32a12,12,0,0,0-6.84-.25,15.2,15.2,0,0,0-2.18.75l-2.5-1.44-3,1.72v2.32l1,.59a2.51,2.51,0,0,0-.44,1.35v2.31c0,1,.69,1.88,2.13,2.71a8.64,8.64,0,0,0,4.12,1.19h0a7.66,7.66,0,0,0,.83,0,16.32,16.32,0,0,0,4.43-.95l.86-.3-2.52,2.53v2.31a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72v-2.32l-1-.59A2.67,2.67,0,0,0,62.8,338Zm-6.29-.2a5.08,5.08,0,0,1-.7.35,6.39,6.39,0,0,1-4.88.07c2.34-.82,4.29-1.54,6-.66C56.77,337.63,56.64,337.72,56.51,337.79Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.93,332.21h0c-1,.25-2,.59-2.88.89a26.9,26.9,0,0,1-3.1,1h0a5.17,5.17,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.55-1.1-1.37.29-2.28l.31-.19a7,7,0,0,1,.82-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a12,12,0,0,0-6.84-.25,15.2,15.2,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.91-2.56,3.89.26,5.52a8.74,8.74,0,0,0,4.12,1.18h.83a16.33,16.33,0,0,0,4.43-1c2.86-1,5.18-2.08,7.11-1,1.29.75.94,1.68-.48,2.5a5.08,5.08,0,0,1-.7.35,6.42,6.42,0,0,1-5,0l-2.62,2.63a12.33,12.33,0,0,0,9.65-.42l2.47,1.42,3-1.72-2.47-1.43c2.49-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,52.93,332.21Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.93,332.21h0c-1,.25-2,.59-2.88.89a26.9,26.9,0,0,1-3.1,1h0a5.17,5.17,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.55-1.1-1.37.29-2.28l.31-.19a7,7,0,0,1,.82-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a12,12,0,0,0-6.84-.25,15.2,15.2,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.91-2.56,3.89.26,5.52a8.74,8.74,0,0,0,4.12,1.18h.83a16.33,16.33,0,0,0,4.43-1c2.86-1,5.18-2.08,7.11-1,1.29.75.94,1.68-.48,2.5a5.08,5.08,0,0,1-.7.35,6.42,6.42,0,0,1-5,0l-2.62,2.63a12.33,12.33,0,0,0,9.65-.42l2.47,1.42,3-1.72-2.47-1.43c2.49-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,52.93,332.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "37.79 329.07 40.8 327.71 43.27 328.8 40.77 327.35 37.79 329.07",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1,328.14a14,14,0,0,1,6.42.21l-1.73,2.46,2.5-2.52A11.9,11.9,0,0,0,45.1,328.14Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.67,332.92l0,0c2.9,1.7,2.62,3.79.13,5.71,2.2-2.39,1.81-4.06-.58-5.45a11.35,11.35,0,0,0-7.34-1A10,10,0,0,1,60.67,332.92Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.85 338.66 62.75 340.12 60.34 341.81 63.32 340.09 60.85 338.66",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.81,338.14a6.44,6.44,0,0,1-4.75.42l-2.84,2.25,2.62-2.63A6.42,6.42,0,0,0,55.81,338.14Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.92,334.07a3.86,3.86,0,0,1-3.57-.33c-.87-.75-.31-1.54,1-2.23-1.39.91-1.25,1.73-.29,2.28a3.12,3.12,0,0,0,1.42.42A5.17,5.17,0,0,0,46.92,334.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.24,330.52c-.22.19-2,1.86-1.22,3.54s3.48,2.93,5.6,3.16h0A8.74,8.74,0,0,1,40.5,336C37.68,334.41,37.73,332.43,40.24,330.52Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.47 331.63 25.21 325.99 25.96 331.63 35.72 332.05 25.96 332.48 25.21 338.12 24.47 332.48 14.71 332.05 24.47 331.63",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.46,416.6a19,19,0,0,0-7-6.52c-11.51-6.64-30.17-6.64-41.68,0a19,19,0,0,0-7,6.52H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.46,416.6a19,19,0,0,0-7-6.52c-11.51-6.64-30.17-6.64-41.68,0a19,19,0,0,0-7,6.52H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.58,405.1c-7.54,0-15.09,1.66-20.84,5a19,19,0,0,0-7,6.52H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53,5.75,3.32,13.3,5,20.84,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.48,407.86a32.75,32.75,0,0,0-4.74,2.22,19,19,0,0,0-7,6.52H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53a31.72,31.72,0,0,0,4.74,2.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,407.86a33.25,33.25,0,0,1,4.74,2.22,19,19,0,0,1,7,6.52h1.59v6h0c-.21,4.19-3.09,8.34-8.63,11.53a32.2,32.2,0,0,1-4.74,2.22Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,404.57c-11.52,6.64-11.51,17.42,0,24.06,10.07,5.82,25.61,6.54,37.06,2.18h0l.45-.18a30.27,30.27,0,0,0,4.17-2c9.6-5.54,11.19-13.95,4.78-20.45h0a22.56,22.56,0,0,0-4.78-3.61C117.91,397.92,99.25,397.92,87.74,404.57Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,404.57c-11.52,6.64-11.51,17.42,0,24.06,10.07,5.82,25.61,6.54,37.06,2.18h0l.45-.18a30.27,30.27,0,0,0,4.17-2c9.6-5.54,11.19-13.95,4.78-20.45h0a22.56,22.56,0,0,0-4.78-3.61C117.91,397.92,99.25,397.92,87.74,404.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,408.18a12.89,12.89,0,0,1,3.09,10.5c-1,5.85-9.21,10.77-12,11.95a30.27,30.27,0,0,0,4.17-2C139,423.09,140.61,414.68,134.2,408.18Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,425a12.9,12.9,0,0,1-3.08-10.5c1-5.85,9.21-10.77,12-12a32,32,0,0,0-4.16,2C78.14,410.11,76.54,418.52,83,425Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.59,
    cy: 416.58,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.59,
    cy: 416.58,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74,421.3c2.21-4.07,1.49-8.56-2.15-12.36a17.34,17.34,0,0,0-2.32-2,25.86,25.86,0,0,0-2.22-1.46c-.43-.26-.88-.5-1.35-.73,1.14,1.87.73,3.88-5.73,4.26-12.63.73,3.38,12.8,3.38,12.8S132.49,417.84,134.74,421.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44,418c1.9-.21,2.84-2.16,2.1-4.35s-2.87-3.8-4.77-3.59-2.83,2.17-2.09,4.36S131.55,418.17,133.44,418Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,428c-.63-4.69-21.13-17.67-21.13-17.67s-4.54-1.83-3-5a22.94,22.94,0,0,0-2.19,1.41c-.48.34-.92.7-1.34,1.06-6.1,5.28-6.11,12.22,0,17.51a16.27,16.27,0,0,0,1.33,1.06,20.91,20.91,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14s1.22.55,1.85.8,1.26.47,1.92.69a40.06,40.06,0,0,0,6.11,1.47l1.38.2a47.6,47.6,0,0,0,13.6-.23S112.88,431.1,113.47,428Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,428c-.63-4.69-21.13-17.67-21.13-17.67s-4.54-1.83-3-5a22.94,22.94,0,0,0-2.19,1.41c-.48.34-.92.7-1.34,1.06-6.1,5.28-6.11,12.22,0,17.51a16.27,16.27,0,0,0,1.33,1.06,20.91,20.91,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14s1.22.55,1.85.8,1.26.47,1.92.69a40.06,40.06,0,0,0,6.11,1.47l1.38.2a47.6,47.6,0,0,0,13.6-.23S112.88,431.1,113.47,428Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.15,408.24c-7.65,4.42-8,11.46-.94,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.07,0-16.67c-.33-.19-.67-.37-1-.54C114,403.65,101.79,403.83,94.15,408.24Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.15,408.24c-7.65,4.42-8,11.46-.94,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.07,0-16.67c-.33-.19-.67-.37-1-.54C114,403.65,101.79,403.83,94.15,408.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,408.61c-7.62,4.4-7.62,11.53,0,15.93s20,4.4,27.6,0,7.62-11.53,0-15.93S102.41,404.21,94.79,408.61Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,408.61c-7.62,4.4-7.62,11.53,0,15.93s20,4.4,27.6,0,7.62-11.53,0-15.93S102.41,404.21,94.79,408.61Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,411.75c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.06,5.52,6.4-.57,2.33-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-5-4.06-5.52-6.39C89.84,415.81,91.68,413.55,94.79,411.75Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,411.75c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.06,5.52,6.4-.57,2.33-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-5-4.06-5.52-6.39C89.84,415.81,91.68,413.55,94.79,411.75Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88,420c0-.38,0-1.93,0-2.33,0-1-.66-1.88-2.08-2.71l0,0a10,10,0,0,0-7.74-.7h0c-1,.26-2,.59-2.89.9a31.56,31.56,0,0,1-3.1,1h0a5.53,5.53,0,0,1-1.47.14,3.25,3.25,0,0,1-1.22-.32l.1-.07a3,3,0,0,1,.3-.19,9,9,0,0,1,.82-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52v-2.32a11.88,11.88,0,0,0-6.84-.24,13,13,0,0,0-2.17.75l-2.5-1.45-3,1.73v2.31l1,.59a2.54,2.54,0,0,0-.44,1.36c0,.38,0,1.92,0,2.31,0,.95.68,1.88,2.12,2.71a8.77,8.77,0,0,0,4.12,1.18h.83a16.33,16.33,0,0,0,4.43-1l.86-.29-2.52,2.52v2.32a12.32,12.32,0,0,0,9.65-.42l2.47,1.42,3-1.72v-2.31l-1-.6A2.65,2.65,0,0,0,120.88,420Zm-6.3-.2a7.46,7.46,0,0,1-.69.35,6.44,6.44,0,0,1-4.88.07c2.33-.83,4.29-1.55,5.95-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,414.19h0c-1,.26-2,.59-2.89.9a31.56,31.56,0,0,1-3.1,1h0a5.53,5.53,0,0,1-1.47.14,3.17,3.17,0,0,1-1.42-.43c-1-.55-1.1-1.36.3-2.28l.3-.19a8.79,8.79,0,0,1,.82-.4,5.6,5.6,0,0,1,4.34-.1l2.5-2.53a11.88,11.88,0,0,0-6.84-.24,13,13,0,0,0-2.17.75l-2.5-1.45-3,1.73,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.79,8.79,0,0,0,4.12,1.19h0c.27,0,.55,0,.82,0a16.32,16.32,0,0,0,4.43-.95c2.86-1,5.19-2.09,7.11-1,1.3.75.94,1.69-.48,2.51a7.46,7.46,0,0,1-.69.35,6.42,6.42,0,0,1-5,0l-2.63,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,111,414.19Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111,414.19h0c-1,.26-2,.59-2.89.9a31.56,31.56,0,0,1-3.1,1h0a5.53,5.53,0,0,1-1.47.14,3.17,3.17,0,0,1-1.42-.43c-1-.55-1.1-1.36.3-2.28l.3-.19a8.79,8.79,0,0,1,.82-.4,5.6,5.6,0,0,1,4.34-.1l2.5-2.53a11.88,11.88,0,0,0-6.84-.24,13,13,0,0,0-2.17.75l-2.5-1.45-3,1.73,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.79,8.79,0,0,0,4.12,1.19h0c.27,0,.55,0,.82,0a16.32,16.32,0,0,0,4.43-.95c2.86-1,5.19-2.09,7.11-1,1.3.75.94,1.69-.48,2.51a7.46,7.46,0,0,1-.69.35,6.42,6.42,0,0,1-5,0l-2.63,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,111,414.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "95.86 411.05 98.87 409.68 101.35 410.77 98.85 409.32 95.86 411.05",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.17,410.11a13.88,13.88,0,0,1,6.42.22l-1.73,2.46,2.5-2.52A11.9,11.9,0,0,0,103.17,410.11Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,414.89l0,0c2.9,1.69,2.61,3.79.13,5.71,2.2-2.4,1.8-4.07-.59-5.45a11.27,11.27,0,0,0-7.33-1A10,10,0,0,1,118.75,414.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.93 420.64 120.82 422.09 118.41 423.79 121.4 422.06 118.93 420.64",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89,420.12a6.43,6.43,0,0,1-4.76.41l-2.84,2.25,2.63-2.63A6.42,6.42,0,0,0,113.89,420.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,416.05a3.87,3.87,0,0,1-3.57-.34c-.86-.74-.31-1.54,1-2.23-1.4.92-1.26,1.73-.3,2.28a3.17,3.17,0,0,0,1.42.43A5.53,5.53,0,0,0,105,416.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.31,412.5c-.21.18-2,1.86-1.22,3.53s3.48,2.94,5.61,3.17h0A8.79,8.79,0,0,1,98.57,418C95.75,416.38,95.8,414.4,98.31,412.5Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.87,407.88a19,19,0,0,0-7.05-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51H82.51v6h0c.21,4.19,3.08,8.34,8.61,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.43-7.34,8.64-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,407.88a19,19,0,0,0-7.05-6.51c-11.51-6.65-30.17-6.65-41.68,0a19,19,0,0,0-7,6.51H82.51v6h0c.21,4.19,3.08,8.34,8.61,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.43-7.34,8.64-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,396.38c-7.54,0-15.08,1.66-20.84,5a19,19,0,0,0-7,6.51H82.51v6h0c.21,4.19,3.08,8.34,8.61,11.53,5.76,3.33,13.3,5,20.84,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.88,399.15a32.2,32.2,0,0,0-4.74,2.22,19,19,0,0,0-7,6.51H82.51v6h0c.21,4.19,3.08,8.34,8.61,11.53a33.29,33.29,0,0,0,4.74,2.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.08,399.15a31.72,31.72,0,0,1,4.74,2.22,19,19,0,0,1,7.05,6.51h1.59v6h0c-.21,4.19-3.1,8.34-8.64,11.53a32.78,32.78,0,0,1-4.74,2.23Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,395.85c-11.51,6.64-11.51,17.42,0,24.06,10.07,5.82,25.62,6.55,37.06,2.19h0l.46-.18a30.75,30.75,0,0,0,4.16-2c9.6-5.54,11.2-14,4.79-20.45h0a22.31,22.31,0,0,0-4.78-3.61C121.31,389.2,102.65,389.2,91.14,395.85Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,395.85c-11.51,6.64-11.51,17.42,0,24.06,10.07,5.82,25.62,6.55,37.06,2.19h0l.46-.18a30.75,30.75,0,0,0,4.16-2c9.6-5.54,11.2-14,4.79-20.45h0a22.31,22.31,0,0,0-4.78-3.61C121.31,389.2,102.65,389.2,91.14,395.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.61,399.46a12.9,12.9,0,0,1,3.08,10.5c-1,5.85-9.21,10.77-12,12a30.75,30.75,0,0,0,4.16-2C142.42,414.37,144,406,137.61,399.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.36,416.3a12.9,12.9,0,0,1-3.08-10.5c1-5.85,9.21-10.77,12-11.95a32.08,32.08,0,0,0-4.17,2C81.54,401.39,80,409.8,86.36,416.3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,419c10.7-6.17,10.7-16.19,0-22.37s-28.05-6.18-38.75,0-10.7,16.2,0,22.37S120.67,425.22,131.37,419Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,419c10.7-6.17,10.7-16.19,0-22.37s-28.05-6.18-38.75,0-10.7,16.2,0,22.37S120.67,425.22,131.37,419Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15,412.58c2.2-4.07,1.48-8.56-2.15-12.36a19.48,19.48,0,0,0-2.32-2,23.73,23.73,0,0,0-2.22-1.47c-.44-.25-.89-.5-1.35-.73,1.14,1.88.72,3.88-5.73,4.26-12.63.74,3.37,12.81,3.37,12.81S135.89,409.13,138.15,412.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.85,409.24c1.89-.21,2.83-2.16,2.09-4.35s-2.87-3.8-4.76-3.58-2.84,2.16-2.1,4.35S135,409.46,136.85,409.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,419.3c-.62-4.69-21.12-17.67-21.12-17.67s-4.55-1.82-3-5a21.19,21.19,0,0,0-2.19,1.42c-.47.34-.92.69-1.33,1.05-6.11,5.28-6.11,12.23,0,17.52.41.36.86.71,1.33,1.05a22.21,22.21,0,0,0,2,1.32c.7.41,1.42.79,2.17,1.14.6.29,1.22.55,1.85.8s1.27.48,1.92.69a40.19,40.19,0,0,0,6.12,1.47l1.37.2a46.24,46.24,0,0,0,6.12.38,45.3,45.3,0,0,0,7.48-.61S116.28,422.39,116.87,419.3Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,419.3c-.62-4.69-21.12-17.67-21.12-17.67s-4.55-1.82-3-5a21.19,21.19,0,0,0-2.19,1.42c-.47.34-.92.69-1.33,1.05-6.11,5.28-6.11,12.23,0,17.52.41.36.86.71,1.33,1.05a22.21,22.21,0,0,0,2,1.32c.7.41,1.42.79,2.17,1.14.6.29,1.22.55,1.85.8s1.27.48,1.92.69a40.19,40.19,0,0,0,6.12,1.47l1.37.2a46.24,46.24,0,0,0,6.12.38,45.3,45.3,0,0,0,7.48-.61S116.28,422.39,116.87,419.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,399.52c-7.65,4.42-8,11.46-.93,16.09.29.2.61.39.93.58,8,4.6,20.89,4.6,28.87,0s8-12.06,0-16.67l-1-.54C117.4,394.93,105.2,395.11,97.55,399.52Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,399.52c-7.65,4.42-8,11.46-.93,16.09.29.2.61.39.93.58,8,4.6,20.89,4.6,28.87,0s8-12.06,0-16.67l-1-.54C117.4,394.93,105.2,395.11,97.55,399.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.99,
    cy: 407.86,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.99,
    cy: 407.86,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2,403c7.62-4.4,20-4.4,27.59,0,3.12,1.8,5,4.06,5.52,6.4-.56,2.34-2.4,4.59-5.52,6.39-7.62,4.4-20,4.4-27.59,0-3.12-1.8-5-4.05-5.53-6.39C93.24,407.09,95.08,404.83,98.2,403Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2,403c7.62-4.4,20-4.4,27.59,0,3.12,1.8,5,4.06,5.52,6.4-.56,2.34-2.4,4.59-5.52,6.39-7.62,4.4-20,4.4-27.59,0-3.12-1.8-5-4.05-5.53-6.39C93.24,407.09,95.08,404.83,98.2,403Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,411.25v-2.33c0-.95-.66-1.88-2.08-2.71l0,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.59-2.89.9a28.36,28.36,0,0,1-3.1,1h0a5.21,5.21,0,0,1-1.48.14,3.07,3.07,0,0,1-1.22-.32l.1-.07.31-.19a6.07,6.07,0,0,1,.81-.4,5.6,5.6,0,0,1,4.34-.1l2.5-2.53v-2.31a11.8,11.8,0,0,0-6.84-.25,14.32,14.32,0,0,0-2.17.75l-2.5-1.44-3,1.72v2.32l1,.59a2.4,2.4,0,0,0-.44,1.35v2.31c0,1,.69,1.88,2.13,2.71a8.76,8.76,0,0,0,4.12,1.19h0a7.48,7.48,0,0,0,.82,0,16.24,16.24,0,0,0,4.43-1l.86-.3-2.51,2.52v2.32a12.26,12.26,0,0,0,9.64-.42l2.47,1.43,3-1.73v-2.31l-1-.59A2.77,2.77,0,0,0,124.28,411.25Zm-6.3-.2a7.46,7.46,0,0,1-.69.35,6.39,6.39,0,0,1-4.88.07c2.34-.82,4.29-1.55,6-.66A4.2,4.2,0,0,1,118,411.05Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.41,405.47h0c-1,.26-2,.59-2.89.9a28.36,28.36,0,0,1-3.1,1h0a5.21,5.21,0,0,1-1.48.14,3.12,3.12,0,0,1-1.41-.42c-1-.56-1.1-1.37.29-2.29l.31-.18a6.16,6.16,0,0,1,.81-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a11.8,11.8,0,0,0-6.84-.25,14.32,14.32,0,0,0-2.17.75l-2.5-1.44-3,1.72,2.48,1.43,0,0c-2.51,1.91-2.56,3.88.27,5.51a8.64,8.64,0,0,0,4.12,1.19h.82a16.63,16.63,0,0,0,4.43-1c2.87-1,5.19-2.09,7.12-1,1.29.74.93,1.68-.49,2.5a7.46,7.46,0,0,1-.69.35,6.37,6.37,0,0,1-5,0l-2.62,2.63a12.26,12.26,0,0,0,9.64-.41l2.47,1.42,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,114.41,405.47Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.41,405.47h0c-1,.26-2,.59-2.89.9a28.36,28.36,0,0,1-3.1,1h0a5.21,5.21,0,0,1-1.48.14,3.12,3.12,0,0,1-1.41-.42c-1-.56-1.1-1.37.29-2.29l.31-.18a6.16,6.16,0,0,1,.81-.41,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a11.8,11.8,0,0,0-6.84-.25,14.32,14.32,0,0,0-2.17.75l-2.5-1.44-3,1.72,2.48,1.43,0,0c-2.51,1.91-2.56,3.88.27,5.51a8.64,8.64,0,0,0,4.12,1.19h.82a16.63,16.63,0,0,0,4.43-1c2.87-1,5.19-2.09,7.12-1,1.29.74.93,1.68-.49,2.5a7.46,7.46,0,0,1-.69.35,6.37,6.37,0,0,1-5,0l-2.62,2.63a12.26,12.26,0,0,0,9.64-.41l2.47,1.42,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,114.41,405.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "99.27 402.33 102.28 400.96 104.75 402.05 102.25 400.61 99.27 402.33",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.58,401.39a14.16,14.16,0,0,1,6.42.22l-1.74,2.46,2.51-2.52A12,12,0,0,0,106.58,401.39Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15,406.18l0,0c2.9,1.7,2.61,3.79.13,5.71,2.2-2.4,1.8-4.07-.59-5.45a11.26,11.26,0,0,0-7.33-1A10,10,0,0,1,122.15,406.18Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.33 411.92 124.22 413.38 121.81 415.07 124.8 413.35 122.33 411.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,411.4a6.43,6.43,0,0,1-4.76.41l-2.83,2.25,2.62-2.63A6.37,6.37,0,0,0,117.29,411.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,407.33a3.89,3.89,0,0,1-3.58-.34c-.86-.74-.31-1.54,1-2.23-1.39.92-1.26,1.73-.29,2.29a3.12,3.12,0,0,0,1.41.42A5.21,5.21,0,0,0,108.4,407.33Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,403.78c-.21.19-2,1.86-1.21,3.54s3.47,2.93,5.6,3.16h0a8.64,8.64,0,0,1-4.12-1.19C99.15,407.66,99.2,405.69,101.71,403.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.46,398.88a18.92,18.92,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a18.92,18.92,0,0,0-7,6.51H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.46,398.88a18.92,18.92,0,0,0-7-6.51c-11.51-6.65-30.17-6.65-41.68,0a18.92,18.92,0,0,0-7,6.51H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53,11.51,6.65,30.17,6.65,41.68,0,5.54-3.19,8.42-7.34,8.63-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.58,387.38c-7.54,0-15.09,1.66-20.84,5a18.92,18.92,0,0,0-7,6.51H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53,5.75,3.33,13.3,5,20.84,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.48,390.14a32.78,32.78,0,0,0-4.74,2.23,18.92,18.92,0,0,0-7,6.51H79.1v6h0c.22,4.19,3.08,8.34,8.62,11.53a31.72,31.72,0,0,0,4.74,2.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,390.14a33.29,33.29,0,0,1,4.74,2.23,18.92,18.92,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.09,8.34-8.63,11.53a32.2,32.2,0,0,1-4.74,2.22Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,386.85c-11.52,6.64-11.51,17.42,0,24.06,10.07,5.82,25.61,6.55,37.06,2.18h0l.45-.17a31.51,31.51,0,0,0,4.17-2c9.6-5.54,11.19-14,4.78-20.45h0a22.56,22.56,0,0,0-4.78-3.61C117.91,380.2,99.25,380.2,87.74,386.85Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,386.85c-11.52,6.64-11.51,17.42,0,24.06,10.07,5.82,25.61,6.55,37.06,2.18h0l.45-.17a31.51,31.51,0,0,0,4.17-2c9.6-5.54,11.19-14,4.78-20.45h0a22.56,22.56,0,0,0-4.78-3.61C117.91,380.2,99.25,380.2,87.74,386.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,390.46a12.89,12.89,0,0,1,3.09,10.5c-1,5.85-9.21,10.77-12,12a31.51,31.51,0,0,0,4.17-2C139,405.37,140.61,397,134.2,390.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,407.3a12.9,12.9,0,0,1-3.08-10.5c1-5.85,9.21-10.77,12-12a32,32,0,0,0-4.16,2C78.14,392.39,76.54,400.8,83,407.3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.59,
    cy: 398.86,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.59,
    cy: 398.86,
    rx: 27.4,
    ry: 15.82,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74,403.58c2.21-4.07,1.49-8.56-2.15-12.36a17.34,17.34,0,0,0-2.32-2,25.86,25.86,0,0,0-2.22-1.46c-.43-.25-.88-.5-1.35-.73,1.14,1.87.73,3.88-5.73,4.26-12.63.74,3.38,12.8,3.38,12.8S132.49,400.12,134.74,403.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44,400.24c1.9-.21,2.84-2.16,2.1-4.35s-2.87-3.8-4.77-3.58-2.83,2.16-2.09,4.35S131.55,400.46,133.44,400.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,410.3c-.63-4.69-21.13-17.67-21.13-17.67s-4.54-1.83-3-5A22.94,22.94,0,0,0,87.12,389c-.48.35-.92.7-1.34,1.06-6.1,5.28-6.11,12.22,0,17.52a16.21,16.21,0,0,0,1.33,1.05,20.91,20.91,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14s1.22.55,1.85.8,1.26.48,1.92.69a40.06,40.06,0,0,0,6.11,1.47l1.38.2a47.6,47.6,0,0,0,13.6-.23S112.88,413.38,113.47,410.3Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,410.3c-.63-4.69-21.13-17.67-21.13-17.67s-4.54-1.83-3-5A22.94,22.94,0,0,0,87.12,389c-.48.35-.92.7-1.34,1.06-6.1,5.28-6.11,12.22,0,17.52a16.21,16.21,0,0,0,1.33,1.05,20.91,20.91,0,0,0,2,1.32c.69.41,1.42.79,2.17,1.14s1.22.55,1.85.8,1.26.48,1.92.69a40.06,40.06,0,0,0,6.11,1.47l1.38.2a47.6,47.6,0,0,0,13.6-.23S112.88,413.38,113.47,410.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.15,390.52c-7.65,4.42-8,11.46-.94,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.67c-.33-.18-.67-.37-1-.54C114,385.93,101.79,386.11,94.15,390.52Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.15,390.52c-7.65,4.42-8,11.46-.94,16.09.3.2.61.39.94.58,8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.67c-.33-.18-.67-.37-1-.54C114,385.93,101.79,386.11,94.15,390.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.59,
    cy: 398.86,
    rx: 19.51,
    ry: 11.27,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.59,
    cy: 398.86,
    rx: 19.51,
    ry: 11.27,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,394c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.06,5.52,6.4-.57,2.34-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-5-4.05-5.52-6.39C89.84,398.09,91.68,395.83,94.79,394Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,394c7.62-4.4,20-4.4,27.6,0,3.11,1.8,5,4.06,5.52,6.4-.57,2.34-2.41,4.59-5.52,6.39-7.62,4.4-20,4.4-27.6,0-3.11-1.8-5-4.05-5.52-6.39C89.84,398.09,91.68,395.83,94.79,394Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88,402.25c0-.38,0-1.93,0-2.33,0-.95-.66-1.88-2.08-2.71l0,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.59-2.89.9a31.56,31.56,0,0,1-3.1,1h0a5.53,5.53,0,0,1-1.47.14,3.25,3.25,0,0,1-1.22-.32l.1-.07a3,3,0,0,1,.3-.19,9,9,0,0,1,.82-.41,5.64,5.64,0,0,1,4.34-.09l2.5-2.53v-2.31a11.8,11.8,0,0,0-6.84-.25,13,13,0,0,0-2.17.75l-2.5-1.44-3,1.72v2.32l1,.59a2.48,2.48,0,0,0-.44,1.35c0,.38,0,1.92,0,2.31,0,1,.68,1.88,2.12,2.71a8.66,8.66,0,0,0,4.12,1.18h0a7.48,7.48,0,0,0,.82,0,16,16,0,0,0,4.43-1l.86-.29-2.52,2.52v2.32a12.28,12.28,0,0,0,9.65-.42l2.47,1.43,3-1.73v-2.31l-1-.6A2.65,2.65,0,0,0,120.88,402.25Zm-6.3-.2a7.46,7.46,0,0,1-.69.35,6.44,6.44,0,0,1-4.88.07c2.33-.83,4.29-1.55,5.95-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,396.47h0c-1,.26-2,.59-2.89.9a31.56,31.56,0,0,1-3.1,1h0a5.53,5.53,0,0,1-1.47.14,3.16,3.16,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.29l.3-.19a8.79,8.79,0,0,1,.82-.4,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a11.8,11.8,0,0,0-6.84-.25,13,13,0,0,0-2.17.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.68,8.68,0,0,0,4.12,1.19h0a7.48,7.48,0,0,0,.82,0,16.32,16.32,0,0,0,4.43-1c2.86-1,5.19-2.09,7.11-1,1.3.74.94,1.68-.48,2.5a7.46,7.46,0,0,1-.69.35,6.42,6.42,0,0,1-5,0l-2.63,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,111,396.47Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111,396.47h0c-1,.26-2,.59-2.89.9a31.56,31.56,0,0,1-3.1,1h0a5.53,5.53,0,0,1-1.47.14,3.16,3.16,0,0,1-1.42-.42c-1-.56-1.1-1.37.3-2.29l.3-.19a8.79,8.79,0,0,1,.82-.4,5.69,5.69,0,0,1,4.34-.1l2.5-2.52a11.8,11.8,0,0,0-6.84-.25,13,13,0,0,0-2.17.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.56,3.88.26,5.51a8.68,8.68,0,0,0,4.12,1.19h0a7.48,7.48,0,0,0,.82,0,16.32,16.32,0,0,0,4.43-1c2.86-1,5.19-2.09,7.11-1,1.3.74.94,1.68-.48,2.5a7.46,7.46,0,0,1-.69.35,6.42,6.42,0,0,1-5,0l-2.63,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.48-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,111,396.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "95.86 393.33 98.87 391.96 101.35 393.05 98.85 391.61 95.86 393.33",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.17,392.39a13.88,13.88,0,0,1,6.42.22l-1.73,2.46,2.5-2.52A11.9,11.9,0,0,0,103.17,392.39Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,397.18l0,0c2.9,1.7,2.61,3.79.13,5.71,2.2-2.4,1.8-4.07-.59-5.45a11.27,11.27,0,0,0-7.33-1A10,10,0,0,1,118.75,397.18Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.93 402.92 120.82 404.38 118.41 406.07 121.4 404.35 118.93 402.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89,402.4a6.43,6.43,0,0,1-4.76.41l-2.84,2.25,2.63-2.63A6.42,6.42,0,0,0,113.89,402.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,398.33a3.87,3.87,0,0,1-3.57-.34c-.86-.74-.31-1.54,1-2.23-1.4.92-1.26,1.73-.3,2.29a3.16,3.16,0,0,0,1.42.42A5.53,5.53,0,0,0,105,398.33Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.31,394.78c-.21.18-2,1.86-1.22,3.53s3.48,2.94,5.61,3.17h0a8.68,8.68,0,0,1-4.12-1.19C95.75,398.66,95.8,396.68,98.31,394.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83,389.48A19,19,0,0,1,90,383c11.51-6.65,30.18-6.65,41.69,0a19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53-11.51,6.65-30.18,6.65-41.69,0-5.53-3.19-8.42-7.34-8.63-11.53h0v-6Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,389.48A19,19,0,0,1,90,383c11.51-6.65,30.18-6.65,41.69,0a19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53-11.51,6.65-30.18,6.65-41.69,0-5.53-3.19-8.42-7.34-8.63-11.53h0v-6Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,378c7.55,0,15.09,1.66,20.85,5a19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53-5.76,3.33-13.3,5-20.85,5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,380.74a33.41,33.41,0,0,1,4.75,2.23,19,19,0,0,1,7,6.51h1.59v6h0c-.21,4.19-3.08,8.34-8.61,11.53a33.41,33.41,0,0,1-4.75,2.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.77,380.74A33.41,33.41,0,0,0,90,383a19,19,0,0,0-7,6.51H81.39v6h0c.21,4.19,3.1,8.34,8.63,11.53a33.41,33.41,0,0,0,4.75,2.23Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,377.45c11.51,6.64,11.51,17.42,0,24.06-10.07,5.82-25.62,6.55-37.06,2.19h0l-.46-.17a32.12,32.12,0,0,1-4.17-2c-9.6-5.54-11.19-13.95-4.78-20.45h0A22.56,22.56,0,0,1,90,377.45C101.53,370.8,120.2,370.8,131.71,377.45Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,377.45c11.51,6.64,11.51,17.42,0,24.06-10.07,5.82-25.62,6.55-37.06,2.19h0l-.46-.17a32.12,32.12,0,0,1-4.17-2c-9.6-5.54-11.19-13.95-4.78-20.45h0A22.56,22.56,0,0,1,90,377.45C101.53,370.8,120.2,370.8,131.71,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.24,381.06a12.9,12.9,0,0,0-3.08,10.5c1,5.85,9.21,10.77,12,12a32.12,32.12,0,0,1-4.17-2C80.42,396,78.83,387.56,85.24,381.06Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,397.9a12.9,12.9,0,0,0,3.08-10.5c-1-5.85-9.21-10.77-12-12a32.76,32.76,0,0,1,4.17,2C141.31,383,142.9,391.4,136.49,397.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,400.64c-10.7-6.17-10.7-16.19,0-22.37s28.05-6.18,38.75,0,10.7,16.2,0,22.37S102.2,406.82,91.5,400.64Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,400.64c-10.7-6.17-10.7-16.19,0-22.37s28.05-6.18,38.75,0,10.7,16.2,0,22.37S102.2,406.82,91.5,400.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.72,394.18c-2.2-4.07-1.48-8.56,2.15-12.36a18,18,0,0,1,2.32-2,25.86,25.86,0,0,1,2.22-1.46c.44-.25.89-.5,1.35-.73-1.14,1.87-.72,3.88,5.73,4.26,12.63.74-3.37,12.8-3.37,12.8S87,390.73,84.72,394.18Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,390.84c-1.89-.21-2.83-2.16-2.09-4.35s2.87-3.8,4.76-3.58,2.83,2.16,2.1,4.35S87.92,391.06,86,390.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,400.9c.62-4.69,21.12-17.67,21.12-17.67s4.55-1.83,3-5a24.28,24.28,0,0,1,2.19,1.41c.47.35.92.7,1.33,1.06,6.1,5.28,6.11,12.23,0,17.52-.41.36-.86.71-1.33,1a22.21,22.21,0,0,1-2,1.32c-.7.41-1.43.79-2.18,1.14-.59.28-1.21.55-1.84.8s-1.27.48-1.92.69a40.19,40.19,0,0,1-6.12,1.47l-1.38.2a47.53,47.53,0,0,1-13.59-.23S106.58,404,106,400.9Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,400.9c.62-4.69,21.12-17.67,21.12-17.67s4.55-1.83,3-5a24.28,24.28,0,0,1,2.19,1.41c.47.35.92.7,1.33,1.06,6.1,5.28,6.11,12.23,0,17.52-.41.36-.86.71-1.33,1a22.21,22.21,0,0,1-2,1.32c-.7.41-1.43.79-2.18,1.14-.59.28-1.21.55-1.84.8s-1.27.48-1.92.69a40.19,40.19,0,0,1-6.12,1.47l-1.38.2a47.53,47.53,0,0,1-13.59-.23S106.58,404,106,400.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.32,381.12c7.65,4.42,8,11.46.93,16.09-.3.2-.61.39-.93.58-8,4.6-20.9,4.6-28.87,0s-8-12.06,0-16.67l1-.54C105.47,376.53,117.67,376.71,125.32,381.12Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.32,381.12c7.65,4.42,8,11.46.93,16.09-.3.2-.61.39-.93.58-8,4.6-20.9,4.6-28.87,0s-8-12.06,0-16.67l1-.54C105.47,376.53,117.67,376.71,125.32,381.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,381.49c7.62,4.4,7.62,11.53,0,15.93s-20,4.4-27.59,0-7.62-11.53,0-15.93S117.05,377.09,124.67,381.49Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,381.49c7.62,4.4,7.62,11.53,0,15.93s-20,4.4-27.59,0-7.62-11.53,0-15.93S117.05,377.09,124.67,381.49Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,384.63c-7.62-4.4-20-4.4-27.59,0-3.12,1.8-5,4.06-5.53,6.4.57,2.34,2.41,4.59,5.53,6.39,7.62,4.4,20,4.4,27.59,0,3.12-1.8,5-4.05,5.52-6.39C129.63,388.69,127.79,386.43,124.67,384.63Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,384.63c-7.62-4.4-20-4.4-27.59,0-3.12,1.8-5,4.06-5.53,6.4.57,2.34,2.41,4.59,5.53,6.39,7.62,4.4,20,4.4,27.59,0,3.12-1.8,5-4.05,5.52-6.39C129.63,388.69,127.79,386.43,124.67,384.63Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.16,392.85c0-.38,0-1.93,0-2.33,0-.95-.66-1.88-2.08-2.71l0,0a10,10,0,0,0-7.74-.71h0c-1,.26-2,.59-2.89.9a28.28,28.28,0,0,1-3.09,1h0a5.17,5.17,0,0,1-1.47.14,3.07,3.07,0,0,1-1.22-.32l.09-.07.31-.19a7,7,0,0,1,.82-.41,5.64,5.64,0,0,1,4.34-.09l2.5-2.53v-2.31a11.81,11.81,0,0,0-6.84-.25,14.06,14.06,0,0,0-2.18.75l-2.5-1.44-3,1.72v2.32l1,.59a2.48,2.48,0,0,0-.44,1.35v2.31c0,.95.69,1.88,2.13,2.71A8.76,8.76,0,0,0,105,394.4h0a7.66,7.66,0,0,0,.83,0,15.89,15.89,0,0,0,4.42-1l.87-.29-2.52,2.52V398a12.29,12.29,0,0,0,9.65-.42L120.7,399l3-1.73V395l-1-.6A2.71,2.71,0,0,0,123.16,392.85Zm-6.29-.2a7.61,7.61,0,0,1-.7.35,6.44,6.44,0,0,1-4.88.07c2.34-.82,4.29-1.55,6-.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,387.07h0c-1,.26-2,.59-2.89.9a28.28,28.28,0,0,1-3.09,1h0a5.17,5.17,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.56-1.1-1.37.29-2.29l.31-.19a6.89,6.89,0,0,1,.82-.4,5.67,5.67,0,0,1,4.33-.1l2.51-2.52a11.81,11.81,0,0,0-6.84-.25,14.06,14.06,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.57,3.88.26,5.51a8.64,8.64,0,0,0,4.12,1.19h0a7.66,7.66,0,0,0,.83,0,16.4,16.4,0,0,0,4.43-.95c2.86-1,5.18-2.09,7.11-1,1.29.74.94,1.68-.48,2.5a7.61,7.61,0,0,1-.7.35,6.42,6.42,0,0,1-5,0l-2.62,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.49-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,113.29,387.07Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.29,387.07h0c-1,.26-2,.59-2.89.9a28.28,28.28,0,0,1-3.09,1h0a5.17,5.17,0,0,1-1.47.14,3.12,3.12,0,0,1-1.42-.42c-1-.56-1.1-1.37.29-2.29l.31-.19a6.89,6.89,0,0,1,.82-.4,5.67,5.67,0,0,1,4.33-.1l2.51-2.52a11.81,11.81,0,0,0-6.84-.25,14.06,14.06,0,0,0-2.18.75l-2.5-1.44-3,1.72,2.47,1.43,0,0c-2.51,1.9-2.57,3.88.26,5.51a8.64,8.64,0,0,0,4.12,1.19h0a7.66,7.66,0,0,0,.83,0,16.4,16.4,0,0,0,4.43-.95c2.86-1,5.18-2.09,7.11-1,1.29.74.94,1.68-.48,2.5a7.61,7.61,0,0,1-.7.35,6.42,6.42,0,0,1-5,0l-2.62,2.63a12.24,12.24,0,0,0,9.65-.42l2.47,1.43,3-1.72-2.47-1.43c2.49-1.92,2.77-4-.13-5.71l0,0A10,10,0,0,0,113.29,387.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "98.15 383.93 101.16 382.56 103.63 383.65 101.13 382.21 98.15 383.93",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,383a14,14,0,0,1,6.42.22l-1.73,2.46,2.5-2.52A12,12,0,0,0,105.46,383Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,387.78l0,0c2.9,1.7,2.62,3.79.13,5.71,2.2-2.4,1.81-4.07-.59-5.45a11.26,11.26,0,0,0-7.33-1A10,10,0,0,1,121,387.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.21 393.52 123.11 394.98 120.7 396.67 123.68 394.95 121.21 393.52",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,393a6.43,6.43,0,0,1-4.76.41l-2.83,2.25L111.2,393A6.42,6.42,0,0,0,116.17,393Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.28,388.93a3.89,3.89,0,0,1-3.58-.34c-.86-.74-.3-1.54,1-2.23-1.39.92-1.25,1.73-.29,2.29a3.12,3.12,0,0,0,1.42.42A5.17,5.17,0,0,0,107.28,388.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,385.38c-.22.18-2,1.86-1.22,3.53s3.48,2.94,5.6,3.17h0a8.64,8.64,0,0,1-4.12-1.19C98,389.26,98.09,387.28,100.6,385.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.83 386.48 85.57 380.84 86.32 386.48 96.08 386.91 86.32 387.34 85.57 392.98 84.83 387.34 75.06 386.91 84.83 386.48",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.64,388.32c0-6.54-4.31-13.07-12.95-18.06-17.27-10-45.28-10-62.55,0-8.64,5-12.95,11.52-12.95,18.06h0v12c0,6.54,4.31,13.08,12.95,18.06,17.27,10,45.28,10,62.55,0,8.64-5,12.95-11.52,12.95-18.06v-12ZM325.28,374c7.71-4.45,18.06-6.9,29.14-6.9s21.42,2.45,29.13,6.9c7,4,10.82,9.13,10.82,14.36s-3.84,10.32-10.82,14.35c-7.71,4.45-18.06,6.91-29.13,6.91s-21.43-2.46-29.14-6.91c-7-4-10.82-9.12-10.82-14.35S318.3,378,325.28,374Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.14,406.37c17.27,10,45.27,10,62.55,0s17.27-26.14,0-36.11-45.28-10-62.55,0S305.86,396.4,323.14,406.37Zm-8.68-18.05c0-5.23,3.84-10.33,10.82-14.36,7.71-4.45,18.06-6.9,29.13-6.9s21.43,2.45,29.14,6.9c7,4,10.81,9.13,10.81,14.36s-3.84,10.32-10.81,14.35c-7.72,4.45-18.06,6.91-29.14,6.91s-21.42-2.46-29.13-6.91C318.3,398.64,314.46,393.55,314.46,388.32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.46,388.32a11.85,11.85,0,0,0,1.73,6c1.75-3,4.84-5.89,9.09-8.33,7.71-4.46,18.06-6.92,29.14-6.92s21.42,2.46,29.13,6.92c4.25,2.44,7.34,5.29,9.1,8.33a11.93,11.93,0,0,0,1.72-6c0-5.23-3.84-10.33-10.82-14.36-7.71-4.45-18.06-6.9-29.13-6.9S333,369.51,325.28,374C318.3,378,314.46,383.09,314.46,388.32Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.46,388.32a11.85,11.85,0,0,0,1.73,6c1.75-3,4.84-5.89,9.09-8.33,7.71-4.46,18.06-6.92,29.14-6.92s21.42,2.46,29.13,6.92c4.25,2.44,7.34,5.29,9.1,8.33a11.93,11.93,0,0,0,1.72-6c0-5.23-3.84-10.33-10.82-14.36-7.71-4.45-18.06-6.9-29.13-6.9S333,369.51,325.28,374C318.3,378,314.46,383.09,314.46,388.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.28,379.41c7.71-4.45,18.06-6.9,29.13-6.9s21.43,2.45,29.14,6.9c5.75,3.33,9.37,7.38,10.46,11.63-1.09,4.25-4.71,8.31-10.46,11.63-7.72,4.45-18.06,6.91-29.14,6.91s-21.42-2.46-29.13-6.91c-5.76-3.32-9.37-7.38-10.46-11.63C315.91,386.79,319.52,382.74,325.28,379.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,413.14v12a57.9,57.9,0,0,1-20.85-6.76c-8.64-5-13-11.52-13-18.06v-12a15.27,15.27,0,0,1,.53-3.95h0c-2.09,7.78,2,16,12.42,22A58.29,58.29,0,0,0,344,413.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.45,414a6.82,6.82,0,0,0-3.07-5.38,2.16,2.16,0,0,0-2.18-.23h0l-14.89,8.5h0a2.16,2.16,0,0,0-.91,2,6.84,6.84,0,0,0,3.07,5.38,2.18,2.18,0,0,0,2.19.23h0l14.89-8.5h0A2.15,2.15,0,0,0,324.45,414Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,416a2.15,2.15,0,0,0,.92-2,5.81,5.81,0,0,0-.52-2.32l-19.2,11a5.81,5.81,0,0,0,1.72,1.61,2.18,2.18,0,0,0,2.19.23l14.89-8.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,424.27a8.92,8.92,0,0,0-4-7,2.81,2.81,0,0,0-2.8-.31h0l0,0h0l-38.68,20.27,7.36,13,37-23.39A2.86,2.86,0,0,0,309,424.27Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.79,450.27l37-23.39a2.86,2.86,0,0,0,1.2-2.61,8.44,8.44,0,0,0-1.34-4.25L267,443.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.07,449.88a11.72,11.72,0,0,1-5.25-9.19c0-3.37,2.39-4.73,5.3-3a11.66,11.66,0,0,1,5.25,9.18C272.36,450.21,270,451.57,267.07,449.88Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.07,449.88a11.72,11.72,0,0,1-5.25-9.19c0-3.37,2.39-4.73,5.3-3a11.66,11.66,0,0,1,5.25,9.18C272.36,450.21,270,451.57,267.07,449.88Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Funnel--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--funnel--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.8,272.55c-5.76-3.32-13.08-5.18-20.61-5.58h0c-9.64-.51-19.58,1.37-26.95,5.64-13.13,7.6-13.11,19.89,0,27.46a40.56,40.56,0,0,0,10.1,4,56.75,56.75,0,0,0,28.36-.3q1.88-.52,3.66-1.2c.49-.19,1-.38,1.46-.59h0c.68-.29,1.35-.59,2-.91s1.33-.69,2-1.06C341,292.41,341,280.11,327.8,272.55Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.19,267c-9.64-.51-19.58,1.37-26.95,5.64-13.13,7.6-13.11,19.89,0,27.46a40.56,40.56,0,0,0,10.1,4h0c-1.26-1.74,0-7.38,2.42-7.64a79.78,79.78,0,0,1-9.33-4.06c-3.78-2.17-6.29-4.49-7.36-7.23-.92-2.34-1.53-3.06-.19-4.94a20.63,20.63,0,0,1,6.78-5.64c6.27-3.63,14.52-4.8,22.23-5.23A2.25,2.25,0,0,1,307.19,267Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.56,188.41s-28.93,21.79-74.46,21.85a143.54,143.54,0,0,1-24.58-2.07c-30.88-5.33-49.94-19.6-49.94-19.6,16.75,22.2,31.76,44.52,38.93,67.9,4,13.1,6.18,24.24,6.18,24.24h0c.4,4.33,3.58,8.47,9.06,11.57a37.84,37.84,0,0,0,12.05,4.12,47.65,47.65,0,0,0,8.38.73c7.29,0,14.65-1.63,20.42-4.9,5.48-3.11,8.65-7.26,9-11.59h0s2.14-11.15,6.13-24.26C346.91,233,361.87,210.65,378.56,188.41Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.56,188.41s-28.93,21.79-74.46,21.85a143.54,143.54,0,0,1-24.58-2.07c-30.88-5.33-49.94-19.6-49.94-19.6,16.75,22.2,31.76,44.52,38.93,67.9,4,13.1,6.18,24.24,6.18,24.24h0c.4,4.33,3.58,8.47,9.06,11.57a37.84,37.84,0,0,0,12.05,4.12,47.65,47.65,0,0,0,8.38.73c7.29,0,14.65-1.63,20.42-4.9,5.48-3.11,8.65-7.26,9-11.59h0s2.14-11.15,6.13-24.26C346.91,233,361.87,210.65,378.56,188.41Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.52,208.19c-30.88-5.33-49.94-19.6-49.94-19.6,16.75,22.2,31.76,44.52,38.93,67.9,4,13.1,6.18,24.24,6.18,24.24h0c.4,4.33,3.58,8.47,9.06,11.57a37.84,37.84,0,0,0,12.05,4.12C296.42,277.56,295.7,240.6,279.52,208.19Z",
    style: {
      fill: "#3B61E1",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,122.57c-16-9.24-36.45-14.42-57.4-15.53h0c-26.84-1.42-54.54,3.81-75.07,15.7-36.56,21.17-36.51,55.41.09,76.48A112.38,112.38,0,0,0,266,210.37c25.13,6.41,54.16,6.13,79-.84q5.25-1.47,10.21-3.34c1.37-.52,2.74-1.06,4.07-1.63h0q2.85-1.2,5.57-2.54c1.89-.94,3.73-1.91,5.51-2.95C406.88,177.89,406.85,143.65,370.23,122.57Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.82,107c-26.84-1.42-54.54,3.81-75.07,15.7-36.56,21.17-36.51,55.41.09,76.48A112.38,112.38,0,0,0,266,210.37h0c-3.5-4.87-5.82-16.47.9-17.2A101,101,0,0,1,242,183.24c-10.52-6.06-16.09-12.14-19.1-19.77-2.55-6.51-.87-14.37,2.86-19.6,4.21-5.91,10.23-10.68,18.91-15.72,17.46-10.11,40.44-13.36,61.91-14.57C306.53,113.58,306,107.92,312.82,107Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,128.05c-16.17-9.31-37.69-14.14-59.4-14.47-23.48-.37-47.21,4.5-64.67,14.62-8.68,5-15.2,11-18.81,17.29-3.73,6.46-4.32,13-1.76,19.56,3,7.63,10.14,14.86,20.66,20.92a101.41,101.41,0,0,0,24.93,9.92c3.44.91,7,1.67,10.57,2.3a147.31,147.31,0,0,0,19.27,2.08c1.34.06,2.67.1,4,.13,2.22,0,4.45.06,6.66,0a149.77,149.77,0,0,0,22.45-2.15l.25-.05a130.53,130.53,0,0,0,14.13-3.27q4.9-1.44,9.5-3.24c1.29-.5,2.55-1,3.79-1.58q2.24-1,4.4-2.08c1.39-.71,2.74-1.45,4.07-2.21,8.72-5,15.21-11,18.84-17.3C392.83,154.59,385.76,139.46,365.93,128.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.26,166.8c-13.65-7.85-31.81-11.93-50.14-12.21-19.83-.31-39.85,3.81-54.59,12.34-7.33,4.26-12.84,9.3-15.88,14.6l-.15.27A72.43,72.43,0,0,0,242,186a101.41,101.41,0,0,0,24.93,9.92c3.44.91,7,1.67,10.57,2.3a147.31,147.31,0,0,0,19.27,2.08c1.34.06,2.67.1,4,.13,2.22,0,4.45.06,6.66,0a149.77,149.77,0,0,0,22.45-2.15l.25-.05a130.53,130.53,0,0,0,14.13-3.27q4.9-1.44,9.5-3.24c1.29-.5,2.55-1,3.79-1.58q2.24-1,4.4-2.08c1.39-.71,2.74-1.45,4.07-2.21a68.83,68.83,0,0,0,6.35-4.13C369.38,176.34,364,171.24,356.26,166.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladder--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.53,220.81l-16.24,44.61c-.73,1.45,1.71,2.24,2.78,1.62a2.81,2.81,0,0,0,.76-.82l16-43.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.56 281.75 397.88 267.44 398.65 264.03 423.33 278.33 422.56 281.75",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,245.92,390.06,287c-.73,1.45,1.7,2.24,2.77,1.62a1.47,1.47,0,0,0,.75-.81h0l14.57-39.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.32 259.26 437.98 245.74 439.15 242.56 462.09 255.85 461.32 259.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.66,285.75a2.31,2.31,0,0,0,0-.32L456,226.16l-5-2.9,13.41,62.63a1,1,0,0,0,.52.61,3.64,3.64,0,0,0,3.3,0,.91.91,0,0,0,.51-.55A1.49,1.49,0,0,0,468.66,285.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.62,279.66l-13.91-8a1.87,1.87,0,0,1-.83-1.44v-.33a1.87,1.87,0,0,1,.83-1.44l41-23.77a1.8,1.8,0,0,1,1.66,0l13.9,8a1.81,1.81,0,0,1,.83,1.43v.33a1.83,1.83,0,0,1-.83,1.44l-41,23.78A1.86,1.86,0,0,1,427.62,279.66Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.86,253.3l-42.41,24.59L413.13,269a1.74,1.74,0,0,1,.58-.62l41-23.78a1.86,1.86,0,0,1,1.66,0l13.9,8A1.64,1.64,0,0,1,470.86,253.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.13,269a1.7,1.7,0,0,0-.25.82v.33a1.87,1.87,0,0,0,.83,1.44l13.91,8a1.72,1.72,0,0,0,.83.19v-2Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.45,277.89v2a1.72,1.72,0,0,0,.83-.19L446,270l24.31-14.14a1.83,1.83,0,0,0,.83-1.44v-.33a1.68,1.68,0,0,0-.24-.81Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.43,300.35l-13.91-8a1.81,1.81,0,0,1-.83-1.43v-.33a1.83,1.83,0,0,1,.83-1.44l41-23.78a1.84,1.84,0,0,1,1.65,0l13.91,8a1.84,1.84,0,0,1,.83,1.44v.33a1.84,1.84,0,0,1-.83,1.44l-41,23.77A1.8,1.8,0,0,1,432.43,300.35Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.67,274l-42.41,24.59-15.32-8.84a1.77,1.77,0,0,1,.58-.63l41-23.77a1.8,1.8,0,0,1,1.66,0l13.9,8A1.68,1.68,0,0,1,475.67,274Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,289.74a1.7,1.7,0,0,0-.25.82v.33a1.81,1.81,0,0,0,.83,1.43l13.91,8a1.62,1.62,0,0,0,.83.2v-2Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.26,298.58v2a1.62,1.62,0,0,0,.83-.2l16.68-9.63,24.31-14.14a1.84,1.84,0,0,0,.83-1.44v-.33a1.72,1.72,0,0,0-.24-.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.82,258.05l-23.11-13.34a1.81,1.81,0,0,1-.83-1.43V243a1.83,1.83,0,0,1,.83-1.44l41-23.78a1.86,1.86,0,0,1,1.66,0l23.11,13.34a1.86,1.86,0,0,1,.82,1.44v.33a1.86,1.86,0,0,1-.82,1.44l-41,23.77A1.8,1.8,0,0,1,421.82,258.05Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.65,256.29v2a1.62,1.62,0,0,0,.83-.2l16.68-9.63,24.32-14.14a1.86,1.86,0,0,0,.82-1.44v-.33a1.72,1.72,0,0,0-.24-.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.13,242.13a1.7,1.7,0,0,0-.25.82v.33a1.81,1.81,0,0,0,.83,1.43l23.11,13.34a1.62,1.62,0,0,0,.83.2v-2Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.06,231.7l-42.41,24.59-24.52-14.16a1.83,1.83,0,0,1,.58-.62l41-23.77a1.8,1.8,0,0,1,1.66,0l23.11,13.33A1.62,1.62,0,0,1,465.06,231.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.84,256.34l11,51.59a1.05,1.05,0,0,1,0,.34.92.92,0,0,1,0,.15,1,1,0,0,1-.51.56,3.45,3.45,0,0,1-1.66.39,3.35,3.35,0,0,1-1.65-.39,1.25,1.25,0,0,1-.47-.43l-.05-.17,0-.07-11.75-54.88",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-19",
    d: "M459.94,246.69a31,31,0,0,0-5.18-2.08L433.49,257a1.65,1.65,0,0,0,.25.15c4.09,2.15,5.56,3.82,9.12,5.59a13.28,13.28,0,0,0,6.91.91c5.39-.45,9.25-3.73,12.28-6.77a7.47,7.47,0,0,0,2.23-4.95C464.29,249.5,462.06,247.77,459.94,246.69ZM433,250.28l15.21-8.81.09-.43a2.9,2.9,0,0,0,.09-1.24,2.37,2.37,0,0,0-.57-1,11.18,11.18,0,0,0-4.38-2.63c-5.19-2.07-10.76-4-16.26-3a27.2,27.2,0,0,0-6.84,2.47,84,84,0,0,0-8.73,4.9c-1.68,1.08-4.08,3.06-3.05,5.34,1.77,3.92,7.54,4.7,11.25,4.9a73.67,73.67,0,0,0,11-.58A8.46,8.46,0,0,1,433,250.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.23,231.69a2.6,2.6,0,0,1-1.43,2.67,13.1,13.1,0,0,0-4.56,4.61,17.38,17.38,0,0,1-6.74,6.44c-2.38,1.06-7.83,1.14-9.78,0s-2-3.18-.53-4.39,4.13-2.68,5.56-4.33a20.24,20.24,0,0,0,3.54-6.94,20.53,20.53,0,0,0-.06-6.36c-.36-1.57-1.47-5.09-1.47-5.09l12-2.15.81,7.4C434,224.94,436.11,229,436.23,231.69Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.84,232.78a3,3,0,0,1,.06,1.48c-.43.71-1.22,1.2-3,2.39s-2.24,2.57-3,4.07a13.58,13.58,0,0,1-2.86,3.83,13.33,13.33,0,0,1-9.33,3.55c-4,.09-6.68-1.3-7.28-2.29a3.13,3.13,0,0,1-.18-1.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47,226.57c-1.09.28-.49,1.36-1.05,3.36a15.43,15.43,0,0,1-3.16,6.23,27.44,27.44,0,0,1-4.22,3.27s-4,2.72-1.84,4.73a11.37,11.37,0,0,0,10.85,1.93,13.52,13.52,0,0,0,7.6-6.84,13.26,13.26,0,0,1,4.51-4.58,4.59,4.59,0,0,0,1.68-1.89,16.87,16.87,0,0,0-.64-4.52,43.09,43.09,0,0,1-1.6-4.12.69.69,0,0,0-1-.59s.17,1,.18,1.33-.74,1.31-2.58,2.13-2.21,1.62-2.48,2.38c0,0,.67-1.43-.62-2A15.87,15.87,0,0,0,422.47,226.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.28,245.59a6.74,6.74,0,0,0-4.45-6.22c-3.22-1.35-4.52-.88-5.55-.39s-4.31,3-2.84,5.49C412.72,246.35,418.33,248.43,424.28,245.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.28,235.41l0-1.34.57-14.39-14.24.9s2.42,10.74,2.66,13.07a43,43,0,0,1,.29,9.79c-.48,3.42-1.15,6.51-2.67,8.37s-5.12,5-3.37,7,6.37,1.43,9.84-.38a13.2,13.2,0,0,0,6.18-7.37,28.65,28.65,0,0,1,2.9-6.22c1.18-1.86,1.28-2.9,0-5.37S461.28,236.36,461.28,235.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.69,242.42a3,3,0,0,1,.41,1.42c-.25.79-.89,1.46-2.33,3s-1.56,3-1.9,4.65a13.54,13.54,0,0,1-1.86,4.41,13.37,13.37,0,0,1-8.21,5.67c-3.89,1.05-6.8.34-7.62-.48a3.18,3.18,0,0,1-.56-1.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.83,238.24c-1,.53-.71,1.68-.89,3.76-.2,2.31-.52,6.1-1.66,8a36.61,36.61,0,0,1-3.14,4.29s-3.23,3.59-.65,5a11.37,11.37,0,0,0,11-.72,13.53,13.53,0,0,0,5.74-8.47,13.22,13.22,0,0,1,3.28-5.52,4.6,4.6,0,0,0,1.18-2.23,10.14,10.14,0,0,0-1.71-4.24,14.26,14.26,0,0,1-1.68-3.55c-.31-.91-1-.56-1-.56l0,1.34a10.37,10.37,0,0,1-2.45,2.75c-1.6,1.24-1.19,2.37-1.39,3.16,0,0,.06-2-1.27-2.5S451.67,237.79,450.83,238.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.56,257.86a6.76,6.76,0,0,0-5.81-5c-3.45-.54-4.6.23-5.48,1s-3.48,3.91-1.45,6C445.52,261.36,451.46,262,456.56,257.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.25,128.22c1.21,7.34,2.07,10.77,1.87,18.32-.26,10.1-2.78,42.94-2.78,42.94a36.19,36.19,0,0,1,2.82,11.17c.63,6.64-.55,29.56-.55,29.56a11.42,11.42,0,0,1-6.5,2.53c-3.9.2-5.51-1.05-5.51-1.05s-6.25-26.1-8.1-35-5.61-30.3-5.61-30.3l-9.21,17.85s1.35,1.58,3.24,7.79,3.29,26.38,3.29,26.38-1.54,1.74-5.48,2.42a13.07,13.07,0,0,1-6.5-.33s-9.43-23.66-12-31-3.05-8.9-.65-18.26c2.72-10.64,11.68-37.33,11.68-37.33l.41-5.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.89,166.37c-1.06-6.78-2-14.7-2-14.7s-6.33-2-10.24-5.77c1.38,4.72,7.27,8.12,7.27,8.12L433,165.46l-6.31,18.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.77,52.85a3.63,3.63,0,0,1,2.13.21,22.74,22.74,0,0,1,3,1.76c1.54.87,4,2.31,5.83,2.26.37,0,1.13-.14.63-.61a16.42,16.42,0,0,1-1.86-1.87,3.17,3.17,0,0,1-.69-2.48,1,1,0,0,1,.38-.67c.3-.22.51-.08.74.11a8.24,8.24,0,0,0,.8.5l1.68,1c3.24,2,6.48,4.28,8.35,7.68.28.49,1.9,4.36,3,6.55.86,2,7.39,15.1,7.39,15.1h18.77S403.75,96.76,397,97.13c-8.89.49-12.45.89-13.66-2.58a91.66,91.66,0,0,1-3.67-14.22c-1.24-6.24-1.79-8.67-2.73-10.39s-2.52-1.85-3.63-2.22a17.73,17.73,0,0,1-4.38-2,16.29,16.29,0,0,1-3.34-2.56,4.8,4.8,0,0,1-1.28-1.6,16.88,16.88,0,0,0-.29-1.68,17.52,17.52,0,0,1-1-1.73,5.89,5.89,0,0,1-.07-1.57,2.62,2.62,0,0,0-1.1-1.87,2.51,2.51,0,0,1-.71-.88C360.9,53.24,361.3,53,361.77,52.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.77,58.68a11.63,11.63,0,0,0,3.93,5.14,4.88,4.88,0,0,1-3-1.58A4.49,4.49,0,0,1,374.77,58.68Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,80.67c-3-.06-11.22,0-17.64.41-5.91.36-16.54,1.12-16.54,1.12s1.8,2.06,2,7.29c.17,5.6-2.16,7.75-2.16,7.75l9.73,0c6.55,0,13.58-.09,13.58-.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,81.64a19.54,19.54,0,0,0-3.79.16l.35.69A16.64,16.64,0,0,1,395.31,89c.31,3.64-1,7.57-2.18,8.39l-.9,0s0,.71,1,.67c1.9-.06,4.61-.11,5.32-.72.5-.43,2.34-2.35,1.94-7C400.05,84.72,398,81.81,396.61,81.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.72,107.11c-1.17-12.35-1.79-23,7.38-25.83a34,34,0,0,1,14-.46,58.26,58.26,0,0,1,14.31,4s3.77,2.23,5.89,22.28c1.3,12.32,1.33,17.18,2.5,30-8.28,4.59-37.08,6.24-42.7-2.54C419.21,126.84,419.1,121.7,417.72,107.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,80.83h0a38.3,38.3,0,0,1,6,.48,52.19,52.19,0,0,1,12.4,3.3l1.75.66c.35.29,3.7,3.57,5.63,21.88.73,6.91,1.06,11.53,1.42,16.42.27,3.84.56,7.8,1.06,13.25-4.05,2.09-12.56,3.54-20.93,3.54-10.5,0-18.23-2.22-20.75-5.94.13-7.48,0-12.69-1.36-27.36-1.25-13.18-1.48-22.71,7-25.3a28.62,28.62,0,0,1,7.72-.93m0-.5a28.9,28.9,0,0,0-7.86,1c-9.17,2.8-8.55,13.48-7.38,25.83,1.38,14.59,1.49,19.73,1.36,27.46,2.9,4.54,12,6.29,21.25,6.29,8.65,0,17.45-1.54,21.45-3.75-1.17-12.83-1.2-17.69-2.5-30-2.12-20-5.89-22.28-5.89-22.28a58.26,58.26,0,0,0-14.31-4,39.31,39.31,0,0,0-6.12-.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.58,85.58c-1.1,1.46-3.77,5.18-5.24,12.47-2,10.16-4.33,19.81-4.33,19.81-1,.32-15,9.94-20.93,10.74-2.08.22-4.08-.65-6.16-.58a14.5,14.5,0,0,1-2.94.11c-.42-.07-1.63-.21-2.05-.22-1.88,0-1,1.78,0,2.62s3.69.74,4.48,1.28-1,1.22-1.66,1.41a24.43,24.43,0,0,1-8,.66,6.22,6.22,0,0,0-4,.81c-.36.23-.54,1.17-.08,1.35.86.35,1.3.56,1.3.56a2,2,0,0,0,1.85,1.82c.41.08,0,1,1.5,1.78.5.24.7.86,1.13,1.21a10.53,10.53,0,0,0,5.55,1.15,21,21,0,0,0,8.41-1.82c1.67-.7,3-2.08,4.69-2.8,6.84-3.2,17.46-6.6,20.89-8.08,6.14-2.64,7.09-2.91,8.44-6.78.26-.75,1.09-3.36,1.36-4.36a136.93,136.93,0,0,0,4-18C462.48,95.47,461.17,87.78,453.58,85.58Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19,84.9c4.15,1.17,5.71,2.55,6.93,4.14,1.75,2.26,3.34,5,2.16,11.95s-4.86,20.19-4.86,20.19-7.38-3-12.94-5.11c0,0,1.61-9.19,2.28-12.72C447.64,98.73,449.14,89,453.19,84.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,117.86a14,14,0,0,1,6.77,1,12,12,0,0,1,5.68,4.2l-.31.86s.59.8,1.26-1,1.52-4.48,1.17-5.87-1.67-3.58-6.85-5.12c-3.54-1.06-6.41-.75-6.89.19s-2.14,5.51-1.3,5.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.3,76.37c.19-3.27,3-7,4.14-9.91s1.68-5,1.25-7.54c-.26-1.49-1.42-3.41-2.58-3.72A7,7,0,0,0,437,47.07a22.77,22.77,0,0,1-3.17-.52c-1.26-.37-1.64-1.31-2.7-2-1.83-1.24-4.66-1-5.5,1.31-1.27-1.32-2.78-1.12-4.48-.48A3,3,0,0,0,419.27,49a3.16,3.16,0,0,0-4.51,2.23c-.05,1,.26,1.86-.3,2.84a1.57,1.57,0,0,1-2.57.47c-.08,1.46.6,2.5,2.15,2.25a3.28,3.28,0,0,0-.1,2.79,3,3,0,0,0,2.92,1.77,4.62,4.62,0,0,0,3,3.57,32.52,32.52,0,0,0,7.74,1.2l3.09.29c.18,0,1.1,0,1.23.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.06,70.1a2.89,2.89,0,0,1-3.69.22l1.21,10.93c-.11,2.61-8.78,5.92-12.91,9.73a28.78,28.78,0,0,1-.37-9.31L428,79.19a27.18,27.18,0,0,1-3.66.24c-2.55-.07-4.67-1.9-5.68-4.54a28.51,28.51,0,0,1-1.49-10.74A9.41,9.41,0,0,0,417,61.5a12.44,12.44,0,0,1,.16-5.75c2.52-2.53,8.83-4,15.19-1-.3,3.62,1.38,6.28,4.11,7.35,0,1,.13,3.4,1.7,3.18,1.13-.15,1.05-1.58,2.08-3s3.7-2,5-.28A6.16,6.16,0,0,1,444.06,70.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,79.19c3.93-.91,7.08-1.68,8.83-4.79a24.75,24.75,0,0,0,1.89-5,19.52,19.52,0,0,1-1.06,6.11c-.8,2-3.25,4-9.44,5.27Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.05,63.64a1.13,1.13,0,1,0,1-1.31A1.16,1.16,0,0,0,428.05,63.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,59.93l2.65.75a1.45,1.45,0,0,0-1-1.75A1.35,1.35,0,0,0,428,59.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.39,61.38l2.58-1a1.31,1.31,0,0,0-1.75-.8A1.46,1.46,0,0,0,418.39,61.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.1,64a1.13,1.13,0,1,0,1-1.31A1.16,1.16,0,0,0,419.1,64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.78 68.39 425.19 69.85 424.81 61.73 420.78 68.39",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5,70.52,425,72.25a2.36,2.36,0,0,0,3.08,1.47A2.52,2.52,0,0,0,429.5,70.52Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.06,71.36a3,3,0,0,1,.58-.08,2.49,2.49,0,0,1-1.55,2.44,2,2,0,0,1-.76.14A2.21,2.21,0,0,1,429.06,71.36Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.67,91a14,14,0,0,1,4.65-5c2.38-1.49,5.83-3.37,6.89-4.41a3.85,3.85,0,0,0,1.17-2.15l-.2-1.81s.87-.31,1.93,1a42.15,42.15,0,0,0,4.31,4,14.42,14.42,0,0,1-4.25,7,40.34,40.34,0,0,1-8.25,5.13s-.86-4.8-1.6-5.63S428.67,91,428.67,91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.67,91a44.26,44.26,0,0,1-.37-9.31L428,79.19l-1.07.12a14,14,0,0,0-3.28,2.53c-.68,1-1.72,6.57-1.35,9.68,1-3.17,3.46-5.12,4.42-3.42A17.76,17.76,0,0,0,428.67,91Z",
    style: {
      fill: "#e0e0e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Person--inject-19",
    d: "M354.2,152.32a9.62,9.62,0,1,0-7.34-.48A9.62,9.62,0,0,0,354.2,152.32Zm19.47,6.84a12.65,12.65,0,0,0-5.69-5.9,9.63,9.63,0,0,0-7.4-.59L347.74,157c-4.92,1.67-7.67,7.26-6.46,13.11l1,4.64,33.48-11.34Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--person--inject-19",
    d: "M350,72a7.74,7.74,0,0,0-4.74-3.62l-10.58-2.66c-4.06-1-8.35,1.56-10.09,6.05l-1.37,3.56,27.59,6.92.47-3.78A10.15,10.15,0,0,0,350,72Zm-8.9-6.64a7.74,7.74,0,1,0-4.76-3.53A7.74,7.74,0,0,0,341.1,65.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-19",
    d: "M370.4,105.25a.29.29,0,0,0,0-.33l-1.32-1.66a1.33,1.33,0,0,1-.16-1.34v0h0a1.35,1.35,0,0,1,1.06-.83l2.1-.23a.28.28,0,0,0,.24-.23,10.18,10.18,0,0,0,.17-1.95,11,11,0,0,0-.16-2,.27.27,0,0,0-.24-.22L370,96.22A1.32,1.32,0,0,1,369,95.4s0,0,0,0a1.32,1.32,0,0,1,.17-1.34l1.32-1.65a.29.29,0,0,0,0-.33,10.93,10.93,0,0,0-2.75-2.76.29.29,0,0,0-.33,0l-1.65,1.31a1.36,1.36,0,0,1-1.35.16h0a1.31,1.31,0,0,1-.83-1.07l-.24-2.1a.28.28,0,0,0-.22-.24,11.41,11.41,0,0,0-3.91,0,.29.29,0,0,0-.23.24l-.25,2.1a1.32,1.32,0,0,1-.83,1.07h0a1.38,1.38,0,0,1-1.35-.17l-1.65-1.31a.29.29,0,0,0-.33,0A11,11,0,0,0,351.71,92a.29.29,0,0,0,0,.33L353,94a1.33,1.33,0,0,1,.16,1.35s0,0,0,0a1.3,1.3,0,0,1-1.06.82l-2.11.24a.28.28,0,0,0-.24.23,11.55,11.55,0,0,0,0,3.89.27.27,0,0,0,.24.23l2.1.25a1.35,1.35,0,0,1,1.07.84s0,0,0,0a1.29,1.29,0,0,1-.16,1.34l-1.31,1.66a.28.28,0,0,0,0,.33,11.35,11.35,0,0,0,2.76,2.77.27.27,0,0,0,.33,0l1.65-1.3a1.33,1.33,0,0,1,1.35-.16h0a1.3,1.3,0,0,1,.82,1.06l.24,2.1a.28.28,0,0,0,.23.25,11.14,11.14,0,0,0,1.95.17,11.43,11.43,0,0,0,2-.17.29.29,0,0,0,.22-.24l.25-2.1a1.31,1.31,0,0,1,.82-1.06h0a1.33,1.33,0,0,1,1.35.17l1.65,1.32a.27.27,0,0,0,.33,0A11.1,11.1,0,0,0,370.4,105.25Zm-9.35-.83a5.8,5.8,0,1,1,5.79-5.78A5.8,5.8,0,0,1,361.05,104.42Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-19",
    d: "M266.47,160.51a.42.42,0,0,0,0-.47l-1.88-2.37a1.89,1.89,0,0,1-.22-1.92,0,0,0,0,0,0,0h0a1.89,1.89,0,0,1,1.51-1.18l3-.34a.38.38,0,0,0,.35-.32,15.55,15.55,0,0,0,.24-2.78,16.7,16.7,0,0,0-.23-2.8.4.4,0,0,0-.34-.32l-3-.34a1.92,1.92,0,0,1-1.51-1.18.14.14,0,0,0,0-.06,1.9,1.9,0,0,1,.24-1.91l1.88-2.35a.41.41,0,0,0,0-.47,15.86,15.86,0,0,0-3.93-3.95.41.41,0,0,0-.47,0l-2.36,1.87a1.93,1.93,0,0,1-1.92.23l0,0a1.9,1.9,0,0,1-1.18-1.52l-.33-3a.41.41,0,0,0-.33-.35,16.59,16.59,0,0,0-5.58,0,.4.4,0,0,0-.32.34l-.35,3a1.9,1.9,0,0,1-1.18,1.52l0,0a1.93,1.93,0,0,1-1.92-.25l-2.35-1.87a.42.42,0,0,0-.48,0,16,16,0,0,0-3.94,3.94.39.39,0,0,0,0,.47l1.87,2.36a1.91,1.91,0,0,1,.22,1.91.11.11,0,0,1,0,.06,1.87,1.87,0,0,1-1.51,1.17l-3,.33a.4.4,0,0,0-.34.33,15.72,15.72,0,0,0-.24,2.78,14.91,14.91,0,0,0,.23,2.78.37.37,0,0,0,.34.32l3,.36a1.93,1.93,0,0,1,1.52,1.19v0a1.84,1.84,0,0,1-.24,1.91L239.76,160a.41.41,0,0,0,0,.47,15.73,15.73,0,0,0,3.94,3.95.39.39,0,0,0,.46,0l2.37-1.87a1.91,1.91,0,0,1,1.92-.22h0a1.9,1.9,0,0,1,1.18,1.52l.33,3a.39.39,0,0,0,.32.35,16,16,0,0,0,5.58,0,.39.39,0,0,0,.32-.34l.36-3a1.87,1.87,0,0,1,1.17-1.51h0a1.9,1.9,0,0,1,1.93.23l2.35,1.88a.38.38,0,0,0,.47,0A16.16,16.16,0,0,0,266.47,160.51Zm-13.36-1.2a8.27,8.27,0,1,1,8.28-8.24A8.26,8.26,0,0,1,253.11,159.31Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.06,138.59a.26.26,0,0,0,0-.3l-1.2-1.51a1.21,1.21,0,0,1-.14-1.23v0h0a1.21,1.21,0,0,1,1-.76l1.92-.22a.24.24,0,0,0,.22-.2,10.26,10.26,0,0,0,.15-1.78,9.89,9.89,0,0,0-.14-1.79.27.27,0,0,0-.22-.21l-1.92-.22a1.21,1.21,0,0,1-1-.75s0,0,0,0a1.19,1.19,0,0,1,.16-1.22l1.2-1.51a.26.26,0,0,0,0-.3,10,10,0,0,0-2.51-2.52.27.27,0,0,0-.3,0l-1.51,1.2a1.25,1.25,0,0,1-1.23.15h0a1.25,1.25,0,0,1-.76-1l-.21-1.92a.28.28,0,0,0-.21-.22,10.7,10.7,0,0,0-3.57,0,.26.26,0,0,0-.2.22l-.23,1.92a1.19,1.19,0,0,1-.76,1s0,0,0,0a1.25,1.25,0,0,1-1.23-.16l-1.5-1.2a.27.27,0,0,0-.31,0A10.06,10.06,0,0,0,295,126.5a.24.24,0,0,0,0,.3l1.19,1.51a1.18,1.18,0,0,1,.14,1.22s0,0,0,0a1.2,1.2,0,0,1-1,.74l-1.93.22a.25.25,0,0,0-.22.21,10.26,10.26,0,0,0-.15,1.78,9.44,9.44,0,0,0,.14,1.78.24.24,0,0,0,.22.2l1.92.23a1.23,1.23,0,0,1,1,.76s0,0,0,0a1.19,1.19,0,0,1-.15,1.22l-1.2,1.51a.26.26,0,0,0,0,.3,10.1,10.1,0,0,0,2.52,2.53.26.26,0,0,0,.3,0l1.51-1.2a1.22,1.22,0,0,1,1.23-.14h0a1.18,1.18,0,0,1,.75,1l.22,1.92a.24.24,0,0,0,.21.22,10.16,10.16,0,0,0,1.78.16,10.34,10.34,0,0,0,1.78-.15.27.27,0,0,0,.21-.22l.23-1.92a1.19,1.19,0,0,1,.75-1h0a1.25,1.25,0,0,1,1.24.15l1.5,1.21a.25.25,0,0,0,.3,0A10.44,10.44,0,0,0,312.06,138.59Zm-8.55-.76a5.29,5.29,0,1,1,5.3-5.27A5.28,5.28,0,0,1,303.51,137.83Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.06,138.59a.26.26,0,0,0,0-.3l-1.2-1.51a1.21,1.21,0,0,1-.14-1.23v0h0a1.21,1.21,0,0,1,1-.76l1.92-.22a.24.24,0,0,0,.22-.2,10.26,10.26,0,0,0,.15-1.78,9.89,9.89,0,0,0-.14-1.79.27.27,0,0,0-.22-.21l-1.92-.22a1.21,1.21,0,0,1-1-.75s0,0,0,0a1.19,1.19,0,0,1,.16-1.22l1.2-1.51a.26.26,0,0,0,0-.3,10,10,0,0,0-2.51-2.52.27.27,0,0,0-.3,0l-1.51,1.2a1.25,1.25,0,0,1-1.23.15h0a1.25,1.25,0,0,1-.76-1l-.21-1.92a.28.28,0,0,0-.21-.22,10.7,10.7,0,0,0-3.57,0,.26.26,0,0,0-.2.22l-.23,1.92a1.19,1.19,0,0,1-.76,1s0,0,0,0a1.25,1.25,0,0,1-1.23-.16l-1.5-1.2a.27.27,0,0,0-.31,0A10.06,10.06,0,0,0,295,126.5a.24.24,0,0,0,0,.3l1.19,1.51a1.18,1.18,0,0,1,.14,1.22s0,0,0,0a1.2,1.2,0,0,1-1,.74l-1.93.22a.25.25,0,0,0-.22.21,10.26,10.26,0,0,0-.15,1.78,9.44,9.44,0,0,0,.14,1.78.24.24,0,0,0,.22.2l1.92.23a1.23,1.23,0,0,1,1,.76s0,0,0,0a1.19,1.19,0,0,1-.15,1.22l-1.2,1.51a.26.26,0,0,0,0,.3,10.1,10.1,0,0,0,2.52,2.53.26.26,0,0,0,.3,0l1.51-1.2a1.22,1.22,0,0,1,1.23-.14h0a1.18,1.18,0,0,1,.75,1l.22,1.92a.24.24,0,0,0,.21.22,10.16,10.16,0,0,0,1.78.16,10.34,10.34,0,0,0,1.78-.15.27.27,0,0,0,.21-.22l.23-1.92a1.19,1.19,0,0,1,.75-1h0a1.25,1.25,0,0,1,1.24.15l1.5,1.21a.25.25,0,0,0,.3,0A10.44,10.44,0,0,0,312.06,138.59Zm-8.55-.76a5.29,5.29,0,1,1,5.3-5.27A5.28,5.28,0,0,1,303.51,137.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--bar-graph--inject-19",
    d: "M303.13,77.76l-5.56,1.17L301,95.15,306.54,94Zm9.69,4.65-5.56,1.17,2.07,9.81,5.55-1.17Zm9.45,3.5-5.56,1.18,1,4.54,5.55-1.17ZM287.7,73.42l4.95,23.48,5.55-1.17-4.95-23.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--bar-graph--inject-19",
    d: "M299.16,186.8l8.86,1.06L311.1,162l-8.86-1.06Zm-13.31-1.59,8.86,1.06,1.87-15.65-8.87-1.06Zm-13.31-1.58,8.86,1.05.86-7.25-8.86-1.06Zm44.39-32.71-4.46,37.47,8.86,1.05L325.8,152Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTauxUtilisation);
export default __webpack_public_path__ + "static/media/taux-utilisation.8f010d924d3ad9b3323de009ca75f9fb.svg";
export { ForwardRef as ReactComponent };